import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var SubscriptionLevel = /*#__PURE__*/function (SubscriptionLevel) {
  SubscriptionLevel[SubscriptionLevel["SUBSCRIPTION_LEVEL_BASIC"] = 0] = "SUBSCRIPTION_LEVEL_BASIC";
  SubscriptionLevel[SubscriptionLevel["SUBSCRIPTION_LEVEL_PROFESSIONAL"] = 1] = "SUBSCRIPTION_LEVEL_PROFESSIONAL";
  SubscriptionLevel[SubscriptionLevel["SUBSCRIPTION_LEVEL_ENTERPRISE"] = 2] = "SUBSCRIPTION_LEVEL_ENTERPRISE";
  SubscriptionLevel[SubscriptionLevel["SUBSCRIPTION_LEVEL_LITE"] = 3] = "SUBSCRIPTION_LEVEL_LITE";
  SubscriptionLevel[SubscriptionLevel["SUBSCRIPTION_LEVEL_PREMIUM"] = 4] = "SUBSCRIPTION_LEVEL_PREMIUM";
  SubscriptionLevel[SubscriptionLevel["SUBSCRIPTION_LEVEL_ELITE"] = 5] = "SUBSCRIPTION_LEVEL_ELITE";
  SubscriptionLevel[SubscriptionLevel["SUBSCRIPTION_LEVEL_FREE"] = 6] = "SUBSCRIPTION_LEVEL_FREE";
  SubscriptionLevel[SubscriptionLevel["SUBSCRIPTION_LEVEL_STARTER"] = 7] = "SUBSCRIPTION_LEVEL_STARTER";
  SubscriptionLevel[SubscriptionLevel["SUBSCRIPTION_LEVEL_BASIC_PLUS"] = 8] = "SUBSCRIPTION_LEVEL_BASIC_PLUS";
  SubscriptionLevel[SubscriptionLevel["SUBSCRIPTION_LEVEL_PROFESSIONAL_PLUS"] = 9] = "SUBSCRIPTION_LEVEL_PROFESSIONAL_PLUS";
  SubscriptionLevel[SubscriptionLevel["SUBSCRIPTION_LEVEL_ENTERPRISE_PLUS"] = 10] = "SUBSCRIPTION_LEVEL_ENTERPRISE_PLUS";
  SubscriptionLevel[SubscriptionLevel["SUBSCRIPTION_LEVEL_REPLACED_BY_SUBSCRIPTION_TIERS"] = 11] = "SUBSCRIPTION_LEVEL_REPLACED_BY_SUBSCRIPTION_TIERS";
  SubscriptionLevel[SubscriptionLevel["SUBSCRIPTION_LEVEL_ENTERPRISE_PLUS_PILOT"] = 12] = "SUBSCRIPTION_LEVEL_ENTERPRISE_PLUS_PILOT";
  return SubscriptionLevel;
}(SubscriptionLevel || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AddonActivationStatus = /*#__PURE__*/function (AddonActivationStatus) {
  AddonActivationStatus[AddonActivationStatus["ADDON_ACTIVATION_STATUS_PENDING"] = 0] = "ADDON_ACTIVATION_STATUS_PENDING";
  AddonActivationStatus[AddonActivationStatus["ADDON_ACTIVATION_STATUS_FAILURE"] = 1] = "ADDON_ACTIVATION_STATUS_FAILURE";
  AddonActivationStatus[AddonActivationStatus["ADDON_ACTIVATION_STATUS_SUCCESS"] = 2] = "ADDON_ACTIVATION_STATUS_SUCCESS";
  return AddonActivationStatus;
}(AddonActivationStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var PartnerType = /*#__PURE__*/function (PartnerType) {
  PartnerType[PartnerType["PARTNER_TYPE_UNSPECIFIED"] = 0] = "PARTNER_TYPE_UNSPECIFIED";
  PartnerType[PartnerType["PARTNER_TYPE_AGENCY"] = 1] = "PARTNER_TYPE_AGENCY";
  PartnerType[PartnerType["PARTNER_TYPE_ENTERPRISE"] = 2] = "PARTNER_TYPE_ENTERPRISE";
  return PartnerType;
}(PartnerType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Action = /*#__PURE__*/function (Action) {
  Action[Action["ACTION_UNSPECIFIED"] = 0] = "ACTION_UNSPECIFIED";
  Action[Action["ACTION_CREATE_SNAPSHOT_REPORT"] = 1] = "ACTION_CREATE_SNAPSHOT_REPORT";
  Action[Action["ACTION_CREATE_SNAPSHOT_REPORT_BULK"] = 2] = "ACTION_CREATE_SNAPSHOT_REPORT_BULK";
  Action[Action["ACTION_ACTIVATE_RM"] = 3] = "ACTION_ACTIVATE_RM";
  Action[Action["ACTION_ACTIVATE_DEMO_RM"] = 4] = "ACTION_ACTIVATE_DEMO_RM";
  Action[Action["ACTION_ACTIVATE_SM"] = 5] = "ACTION_ACTIVATE_SM";
  Action[Action["ACTION_ACTIVATE_MS"] = 6] = "ACTION_ACTIVATE_MS";
  Action[Action["ACTION_CONVERT_DEMO_RM"] = 7] = "ACTION_CONVERT_DEMO_RM";
  Action[Action["ACTION_ACTIVATE_MARKETPLACE_PRODUCT"] = 8] = "ACTION_ACTIVATE_MARKETPLACE_PRODUCT";
  Action[Action["ACTION_REFRESH_SNAPSHOT_REPORT"] = 9] = "ACTION_REFRESH_SNAPSHOT_REPORT";
  Action[Action["ACTION_ACTIVATE_LISTING_DISTRIBUTION"] = 10] = "ACTION_ACTIVATE_LISTING_DISTRIBUTION";
  Action[Action["ACTION_ACTIVATE_LISTING_SYNC_PRO"] = 11] = "ACTION_ACTIVATE_LISTING_SYNC_PRO";
  Action[Action["ACTION_ACTIVATE_CUSTOM_PRODUCT"] = 12] = "ACTION_ACTIVATE_CUSTOM_PRODUCT";
  Action[Action["ACTION_ACCESS_SNAPSHOT_WIDGET"] = 13] = "ACTION_ACCESS_SNAPSHOT_WIDGET";
  Action[Action["ACTION_ACTIVATE_ADDON"] = 14] = "ACTION_ACTIVATE_ADDON";
  return Action;
}(Action || {});
var BillingFrequency = /*#__PURE__*/function (BillingFrequency) {
  BillingFrequency[BillingFrequency["BILLING_FREQUENCY_INVALID"] = 0] = "BILLING_FREQUENCY_INVALID";
  BillingFrequency[BillingFrequency["BILLING_FREQUENCY_MONTHLY"] = 1] = "BILLING_FREQUENCY_MONTHLY";
  BillingFrequency[BillingFrequency["BILLING_FREQUENCY_YEARLY"] = 2] = "BILLING_FREQUENCY_YEARLY";
  return BillingFrequency;
}(BillingFrequency || {});
var SubscriptionTierUpdateType = /*#__PURE__*/function (SubscriptionTierUpdateType) {
  SubscriptionTierUpdateType[SubscriptionTierUpdateType["SUBSCRIPTION_TIER_UPDATE_TYPE_INVALID"] = 0] = "SUBSCRIPTION_TIER_UPDATE_TYPE_INVALID";
  SubscriptionTierUpdateType[SubscriptionTierUpdateType["SUBSCRIPTION_TIER_UPDATE_TYPE_FREE_TO_PAID"] = 1] = "SUBSCRIPTION_TIER_UPDATE_TYPE_FREE_TO_PAID";
  SubscriptionTierUpdateType[SubscriptionTierUpdateType["SUBSCRIPTION_TIER_UPDATE_TYPE_SWITCH_FREE_TRIAL"] = 2] = "SUBSCRIPTION_TIER_UPDATE_TYPE_SWITCH_FREE_TRIAL";
  SubscriptionTierUpdateType[SubscriptionTierUpdateType["SUBSCRIPTION_TIER_UPDATE_TYPE_CANCEL_FREE_TRIAL"] = 3] = "SUBSCRIPTION_TIER_UPDATE_TYPE_CANCEL_FREE_TRIAL";
  SubscriptionTierUpdateType[SubscriptionTierUpdateType["SUBSCRIPTION_TIER_UPDATE_TYPE_CANCEL_FREE_TRIAL_FAILED_PAYMENT"] = 4] = "SUBSCRIPTION_TIER_UPDATE_TYPE_CANCEL_FREE_TRIAL_FAILED_PAYMENT";
  SubscriptionTierUpdateType[SubscriptionTierUpdateType["SUBSCRIPTION_TIER_UPDATE_TYPE_FREE_TO_FREE_TRIAL"] = 5] = "SUBSCRIPTION_TIER_UPDATE_TYPE_FREE_TO_FREE_TRIAL";
  SubscriptionTierUpdateType[SubscriptionTierUpdateType["SUBSCRIPTION_TIER_UPDATE_TYPE_PAID_TO_PAID"] = 6] = "SUBSCRIPTION_TIER_UPDATE_TYPE_PAID_TO_PAID";
  return SubscriptionTierUpdateType;
}(SubscriptionTierUpdateType || {});
var UpdateSubscriptionTierStatus = /*#__PURE__*/function (UpdateSubscriptionTierStatus) {
  UpdateSubscriptionTierStatus[UpdateSubscriptionTierStatus["UPDATE_SUBSCRIPTION_TIER_STATUS_INVALID"] = 0] = "UPDATE_SUBSCRIPTION_TIER_STATUS_INVALID";
  UpdateSubscriptionTierStatus[UpdateSubscriptionTierStatus["UPDATE_SUBSCRIPTION_TIER_STATUS_UNSET"] = 1] = "UPDATE_SUBSCRIPTION_TIER_STATUS_UNSET";
  UpdateSubscriptionTierStatus[UpdateSubscriptionTierStatus["UPDATE_SUBSCRIPTION_TIER_STATUS_PROCESSING"] = 2] = "UPDATE_SUBSCRIPTION_TIER_STATUS_PROCESSING";
  UpdateSubscriptionTierStatus[UpdateSubscriptionTierStatus["UPDATE_SUBSCRIPTION_TIER_STATUS_SUCCESS"] = 3] = "UPDATE_SUBSCRIPTION_TIER_STATUS_SUCCESS";
  UpdateSubscriptionTierStatus[UpdateSubscriptionTierStatus["UPDATE_SUBSCRIPTION_TIER_STATUS_FAILURE"] = 4] = "UPDATE_SUBSCRIPTION_TIER_STATUS_FAILURE";
  return UpdateSubscriptionTierStatus;
}(UpdateSubscriptionTierStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AccessLevel = /*#__PURE__*/function (AccessLevel) {
  AccessLevel[AccessLevel["ACCESS_LEVEL_ALPHA"] = 0] = "ACCESS_LEVEL_ALPHA";
  AccessLevel[AccessLevel["ACCESS_LEVEL_BETA"] = 1] = "ACCESS_LEVEL_BETA";
  AccessLevel[AccessLevel["ACCESS_LEVEL_ALL"] = 2] = "ACCESS_LEVEL_ALL";
  AccessLevel[AccessLevel["ACCESS_LEVEL_EXPERIMENT"] = 3] = "ACCESS_LEVEL_EXPERIMENT";
  return AccessLevel;
}(AccessLevel || {});
var Expiration = /*#__PURE__*/function (Expiration) {
  Expiration[Expiration["EXPIRATION_INVALID"] = 0] = "EXPIRATION_INVALID";
  Expiration[Expiration["EXPIRATION_UNSET"] = 1] = "EXPIRATION_UNSET";
  Expiration[Expiration["EXPIRATION_TWO_WEEKS"] = 2] = "EXPIRATION_TWO_WEEKS";
  Expiration[Expiration["EXPIRATION_FOUR_WEEKS"] = 3] = "EXPIRATION_FOUR_WEEKS";
  Expiration[Expiration["EXPIRATION_TWELVE_WEEKS"] = 4] = "EXPIRATION_TWELVE_WEEKS";
  Expiration[Expiration["EXPIRATION_TWENTY_FOUR_WEEKS"] = 5] = "EXPIRATION_TWENTY_FOUR_WEEKS";
  Expiration[Expiration["EXPIRATION_ONE_MINUTE"] = 6] = "EXPIRATION_ONE_MINUTE";
  return Expiration;
}(Expiration || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ReportAccessIDType = /*#__PURE__*/function (ReportAccessIDType) {
  ReportAccessIDType[ReportAccessIDType["REPORT_ACCESS_ID_TYPE_UNSET"] = 0] = "REPORT_ACCESS_ID_TYPE_UNSET";
  ReportAccessIDType[ReportAccessIDType["REPORT_ACCESS_ID_TYPE_REPORT"] = 1] = "REPORT_ACCESS_ID_TYPE_REPORT";
  ReportAccessIDType[ReportAccessIDType["REPORT_ACCESS_ID_TYPE_REPORT_CATEGORY"] = 2] = "REPORT_ACCESS_ID_TYPE_REPORT_CATEGORY";
  return ReportAccessIDType;
}(ReportAccessIDType || {});
var ReportAccessScope = /*#__PURE__*/function (ReportAccessScope) {
  ReportAccessScope[ReportAccessScope["REPORT_ACCESS_SCOPE_UNSET"] = 0] = "REPORT_ACCESS_SCOPE_UNSET";
  ReportAccessScope[ReportAccessScope["REPORT_ACCESS_SCOPE_NO_ACCESS"] = 1] = "REPORT_ACCESS_SCOPE_NO_ACCESS";
  ReportAccessScope[ReportAccessScope["REPORT_ACCESS_SCOPE_VIEW"] = 2] = "REPORT_ACCESS_SCOPE_VIEW";
  ReportAccessScope[ReportAccessScope["REPORT_ACCESS_SCOPE_EDIT"] = 3] = "REPORT_ACCESS_SCOPE_EDIT";
  return ReportAccessScope;
}(ReportAccessScope || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var PartnerHealthState = /*#__PURE__*/function (PartnerHealthState) {
  PartnerHealthState[PartnerHealthState["PARTNER_HEALTH_STATE_HEALTHY"] = 0] = "PARTNER_HEALTH_STATE_HEALTHY";
  PartnerHealthState[PartnerHealthState["PARTNER_HEALTH_STATE_AT_RISK"] = 1] = "PARTNER_HEALTH_STATE_AT_RISK";
  PartnerHealthState[PartnerHealthState["PARTNER_HEALTH_STATE_RESTRICTED"] = 2] = "PARTNER_HEALTH_STATE_RESTRICTED";
  return PartnerHealthState;
}(PartnerHealthState || {});
var PartnerHealthSubState = /*#__PURE__*/function (PartnerHealthSubState) {
  PartnerHealthSubState[PartnerHealthSubState["PARTNER_HEALTH_SUB_STATE_UNSPECIFIED"] = 0] = "PARTNER_HEALTH_SUB_STATE_UNSPECIFIED";
  PartnerHealthSubState[PartnerHealthSubState["PARTNER_HEALTH_SUB_STATE_ACTIVE"] = 1] = "PARTNER_HEALTH_SUB_STATE_ACTIVE";
  PartnerHealthSubState[PartnerHealthSubState["PARTNER_HEALTH_SUB_STATE_SUBSCRIPTION_OVERDUE"] = 2] = "PARTNER_HEALTH_SUB_STATE_SUBSCRIPTION_OVERDUE";
  PartnerHealthSubState[PartnerHealthSubState["PARTNER_HEALTH_SUB_STATE_SUBSCRIPTION_SUSPENDED"] = 3] = "PARTNER_HEALTH_SUB_STATE_SUBSCRIPTION_SUSPENDED";
  PartnerHealthSubState[PartnerHealthSubState["PARTNER_HEALTH_SUB_STATE_PAYMENT_PLAN"] = 4] = "PARTNER_HEALTH_SUB_STATE_PAYMENT_PLAN";
  return PartnerHealthSubState;
}(PartnerHealthSubState || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var PartnerOrigin = /*#__PURE__*/function (PartnerOrigin) {
  PartnerOrigin[PartnerOrigin["PARTNER_ORIGIN_INVALID"] = 0] = "PARTNER_ORIGIN_INVALID";
  PartnerOrigin[PartnerOrigin["PARTNER_ORIGIN_UNSET"] = 1] = "PARTNER_ORIGIN_UNSET";
  PartnerOrigin[PartnerOrigin["PARTNER_ORIGIN_INTERNAL"] = 2] = "PARTNER_ORIGIN_INTERNAL";
  PartnerOrigin[PartnerOrigin["PARTNER_ORIGIN_SELF_SIGN_UP"] = 3] = "PARTNER_ORIGIN_SELF_SIGN_UP";
  return PartnerOrigin;
}(PartnerOrigin || {});
var GetSignUpAddPaymentCardResultResponseStatus = /*#__PURE__*/function (GetSignUpAddPaymentCardResultResponseStatus) {
  GetSignUpAddPaymentCardResultResponseStatus[GetSignUpAddPaymentCardResultResponseStatus["GET_SIGN_UP_ADD_PAYMENT_CARD_RESULT_RESPONSE_STATUS_INVALID"] = 0] = "GET_SIGN_UP_ADD_PAYMENT_CARD_RESULT_RESPONSE_STATUS_INVALID";
  GetSignUpAddPaymentCardResultResponseStatus[GetSignUpAddPaymentCardResultResponseStatus["GET_SIGN_UP_ADD_PAYMENT_CARD_RESULT_RESPONSE_STATUS_OK"] = 1] = "GET_SIGN_UP_ADD_PAYMENT_CARD_RESULT_RESPONSE_STATUS_OK";
  GetSignUpAddPaymentCardResultResponseStatus[GetSignUpAddPaymentCardResultResponseStatus["GET_SIGN_UP_ADD_PAYMENT_CARD_RESULT_RESPONSE_STATUS_HAS_ERROR"] = 2] = "GET_SIGN_UP_ADD_PAYMENT_CARD_RESULT_RESPONSE_STATUS_HAS_ERROR";
  return GetSignUpAddPaymentCardResultResponseStatus;
}(GetSignUpAddPaymentCardResultResponseStatus || {});
var Status = /*#__PURE__*/function (Status) {
  Status[Status["STATUS_INVALID"] = 0] = "STATUS_INVALID";
  Status[Status["STATUS_IN_PROGRESS"] = 1] = "STATUS_IN_PROGRESS";
  Status[Status["STATUS_COMPLETE"] = 2] = "STATUS_COMPLETE";
  Status[Status["STATUS_ERROR"] = 3] = "STATUS_ERROR";
  return Status;
}(Status || {});
var SupportFlag = /*#__PURE__*/function (SupportFlag) {
  SupportFlag[SupportFlag["SUPPORT_FLAG_INVALID"] = 0] = "SUPPORT_FLAG_INVALID";
  SupportFlag[SupportFlag["SUPPORT_FLAG_UNSET"] = 1] = "SUPPORT_FLAG_UNSET";
  SupportFlag[SupportFlag["SUPPORT_FLAG_TRUE"] = 2] = "SUPPORT_FLAG_TRUE";
  SupportFlag[SupportFlag["SUPPORT_FLAG_FALSE"] = 3] = "SUPPORT_FLAG_FALSE";
  return SupportFlag;
}(SupportFlag || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var RewardStatus = /*#__PURE__*/function (RewardStatus) {
  RewardStatus[RewardStatus["REWARD_STATUS_INVALID"] = 0] = "REWARD_STATUS_INVALID";
  RewardStatus[RewardStatus["REWARD_STATUS_UNSET"] = 1] = "REWARD_STATUS_UNSET";
  RewardStatus[RewardStatus["REWARD_STATUS_INELIGIBLE"] = 2] = "REWARD_STATUS_INELIGIBLE";
  RewardStatus[RewardStatus["REWARD_STATUS_ELIGIBLE"] = 3] = "REWARD_STATUS_ELIGIBLE";
  RewardStatus[RewardStatus["REWARD_STATUS_PROCESSING_CLAIM"] = 4] = "REWARD_STATUS_PROCESSING_CLAIM";
  RewardStatus[RewardStatus["REWARD_STATUS_CLAIMED"] = 5] = "REWARD_STATUS_CLAIMED";
  return RewardStatus;
}(RewardStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var SubscriptionFailure = /*#__PURE__*/function (SubscriptionFailure) {
  SubscriptionFailure[SubscriptionFailure["SUBSCRIPTION_FAILURE_NONE"] = 0] = "SUBSCRIPTION_FAILURE_NONE";
  SubscriptionFailure[SubscriptionFailure["SUBSCRIPTION_FAILURE_OVERDUE"] = 1] = "SUBSCRIPTION_FAILURE_OVERDUE";
  return SubscriptionFailure;
}(SubscriptionFailure || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var SalesSetting = /*#__PURE__*/function (SalesSetting) {
  SalesSetting[SalesSetting["SALES_SETTING_INVALID"] = 0] = "SALES_SETTING_INVALID";
  SalesSetting[SalesSetting["SALES_SETTING_ENABLED"] = 1] = "SALES_SETTING_ENABLED";
  SalesSetting[SalesSetting["SALES_SETTING_DISABLED"] = 2] = "SALES_SETTING_DISABLED";
  SalesSetting[SalesSetting["SALES_SETTING_UNSET"] = 3] = "SALES_SETTING_UNSET";
  return SalesSetting;
}(SalesSetting || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var TimeRange = /*#__PURE__*/function (TimeRange) {
  TimeRange[TimeRange["TIME_RANGE_SEVEN_DAYS"] = 0] = "TIME_RANGE_SEVEN_DAYS";
  TimeRange[TimeRange["TIME_RANGE_THIRTY_DAYS"] = 1] = "TIME_RANGE_THIRTY_DAYS";
  TimeRange[TimeRange["TIME_RANGE_NINETY_DAYS"] = 2] = "TIME_RANGE_NINETY_DAYS";
  TimeRange[TimeRange["TIME_RANGE_SIX_MONTHS"] = 3] = "TIME_RANGE_SIX_MONTHS";
  TimeRange[TimeRange["TIME_RANGE_TWELVE_MONTHS"] = 4] = "TIME_RANGE_TWELVE_MONTHS";
  TimeRange[TimeRange["TIME_RANGE_UNSPECIFIED"] = 5] = "TIME_RANGE_UNSPECIFIED";
  return TimeRange;
}(TimeRange || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var TaskStatus = /*#__PURE__*/function (TaskStatus) {
  TaskStatus[TaskStatus["TASK_STATUS_INVALID"] = 0] = "TASK_STATUS_INVALID";
  TaskStatus[TaskStatus["TASK_STATUS_UNSET"] = 1] = "TASK_STATUS_UNSET";
  TaskStatus[TaskStatus["TASK_STATUS_INCOMPLETE"] = 2] = "TASK_STATUS_INCOMPLETE";
  TaskStatus[TaskStatus["TASK_STATUS_COMPLETE"] = 3] = "TASK_STATUS_COMPLETE";
  return TaskStatus;
}(TaskStatus || {});
var Usage = /*#__PURE__*/function (Usage) {
  Usage[Usage["USAGE_INVALID"] = 0] = "USAGE_INVALID";
  Usage[Usage["USAGE_REQUIRED"] = 1] = "USAGE_REQUIRED";
  Usage[Usage["USAGE_OPTIONAL"] = 2] = "USAGE_OPTIONAL";
  Usage[Usage["USAGE_DISABLED"] = 3] = "USAGE_DISABLED";
  return Usage;
}(Usage || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Field = /*#__PURE__*/function (Field) {
  Field[Field["FIELD_INVALID"] = 0] = "FIELD_INVALID";
  Field[Field["FIELD_LOGO_URL"] = 1] = "FIELD_LOGO_URL";
  Field[Field["FIELD_FAVICON_URL"] = 2] = "FIELD_FAVICON_URL";
  Field[Field["FIELD_SHORTCUT_ICON_URL"] = 3] = "FIELD_SHORTCUT_ICON_URL";
  Field[Field["FIELD_UI_THEME"] = 4] = "FIELD_UI_THEME";
  Field[Field["FIELD_PRIMARY_COLOR"] = 5] = "FIELD_PRIMARY_COLOR";
  Field[Field["FIELD_NAME"] = 6] = "FIELD_NAME";
  Field[Field["FIELD_DARK_MODE_LOGO_URL"] = 7] = "FIELD_DARK_MODE_LOGO_URL";
  Field[Field["FIELD_BUSINESS_APP_UI_THEME"] = 8] = "FIELD_BUSINESS_APP_UI_THEME";
  return Field;
}(Field || {});
var UITheme = /*#__PURE__*/function (UITheme) {
  UITheme[UITheme["UI_THEME_INVALID"] = 0] = "UI_THEME_INVALID";
  UITheme[UITheme["UI_THEME_DARK"] = 1] = "UI_THEME_DARK";
  UITheme[UITheme["UI_THEME_LIGHT"] = 2] = "UI_THEME_LIGHT";
  UITheme[UITheme["UI_THEME_USER_PREFERENCE"] = 3] = "UI_THEME_USER_PREFERENCE";
  return UITheme;
}(UITheme || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var NavigationItemBadge = /*#__PURE__*/function (NavigationItemBadge) {
  NavigationItemBadge[NavigationItemBadge["NAVIGATION_ITEM_BADGE_NONE"] = 0] = "NAVIGATION_ITEM_BADGE_NONE";
  NavigationItemBadge[NavigationItemBadge["NAVIGATION_ITEM_BADGE_NEW"] = 1] = "NAVIGATION_ITEM_BADGE_NEW";
  NavigationItemBadge[NavigationItemBadge["NAVIGATION_ITEM_BADGE_BETA"] = 2] = "NAVIGATION_ITEM_BADGE_BETA";
  return NavigationItemBadge;
}(NavigationItemBadge || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var SegmentedOnboardingConfiguration = /*#__PURE__*/function (SegmentedOnboardingConfiguration) {
  SegmentedOnboardingConfiguration[SegmentedOnboardingConfiguration["SEGMENTED_ONBOARDING_UNSET"] = 0] = "SEGMENTED_ONBOARDING_UNSET";
  SegmentedOnboardingConfiguration[SegmentedOnboardingConfiguration["SEGMENTED_ONBOARDING_OPTIONAL"] = 1] = "SEGMENTED_ONBOARDING_OPTIONAL";
  SegmentedOnboardingConfiguration[SegmentedOnboardingConfiguration["SEGMENTED_ONBOARDING_REQUIRED"] = 2] = "SEGMENTED_ONBOARDING_REQUIRED";
  SegmentedOnboardingConfiguration[SegmentedOnboardingConfiguration["SEGMENTED_ONBOARDING_DISABLED"] = 3] = "SEGMENTED_ONBOARDING_DISABLED";
  return SegmentedOnboardingConfiguration;
}(SegmentedOnboardingConfiguration || {});
var BrandingUITheme = /*#__PURE__*/function (BrandingUITheme) {
  BrandingUITheme[BrandingUITheme["Dark"] = 0] = "Dark";
  BrandingUITheme[BrandingUITheme["Light"] = 1] = "Light";
  return BrandingUITheme;
}(BrandingUITheme || {});
// *********************************

function enumStringToValue$q(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue$p(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$o(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Trial {
  static fromProto(proto) {
    let m = new Trial();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.subscriptionLevel) {
      m.subscriptionLevel = enumStringToValue$o(SubscriptionLevel, proto.subscriptionLevel);
    }
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    if (proto.cancel) {
      m.cancel = new Date(proto.cancel);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.trialId !== 'undefined') {
      toReturn['trialId'] = this.trialId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.subscriptionLevel !== 'undefined') {
      toReturn['subscriptionLevel'] = this.subscriptionLevel;
    }
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    if (typeof this.cancel !== 'undefined' && this.cancel !== null) {
      toReturn['cancel'] = 'toApiJson' in this.cancel ? this.cancel.toApiJson() : this.cancel;
    }
    if (typeof this.createdBy !== 'undefined') {
      toReturn['createdBy'] = this.createdBy;
    }
    if (typeof this.modifiedBy !== 'undefined') {
      toReturn['modifiedBy'] = this.modifiedBy;
    }
    if (typeof this.subscriptionTierId !== 'undefined') {
      toReturn['subscriptionTierId'] = this.subscriptionTierId;
    }
    return toReturn;
  }
}
function enumStringToValue$n(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AddonActivation {
  static fromProto(proto) {
    let m = new AddonActivation();
    m = Object.assign(m, proto);
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    if (proto.status) {
      m.status = enumStringToValue$n(AddonActivationStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.activationFailureReason !== 'undefined') {
      toReturn['activationFailureReason'] = this.activationFailureReason;
    }
    return toReturn;
  }
}
class PartnerAddon {
  static fromProto(proto) {
    let m = new PartnerAddon();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.supportsBulkActivation !== 'undefined') {
      toReturn['supportsBulkActivation'] = this.supportsBulkActivation;
    }
    return toReturn;
  }
}
function enumStringToValue$m(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ListTopRequest {
  static fromProto(proto) {
    let m = new ListTopRequest();
    m = Object.assign(m, proto);
    if (proto.partnerType) {
      m.partnerType = enumStringToValue$m(PartnerType, proto.partnerType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerType !== 'undefined') {
      toReturn['partnerType'] = this.partnerType;
    }
    return toReturn;
  }
}
class ListTopResponse {
  static fromProto(proto) {
    let m = new ListTopResponse();
    m = Object.assign(m, proto);
    if (proto.partnerStats) {
      m.partnerStats = proto.partnerStats.map(PartnerStats.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerStats !== 'undefined' && this.partnerStats !== null) {
      toReturn['partnerStats'] = 'toApiJson' in this.partnerStats ? this.partnerStats.toApiJson() : this.partnerStats;
    }
    return toReturn;
  }
}
class PartnerStats {
  static fromProto(proto) {
    let m = new PartnerStats();
    m = Object.assign(m, proto);
    if (proto.notPayedTerms) {
      m.notPayedTerms = parseInt(proto.notPayedTerms, 10);
    }
    if (proto.uniqueBilledProductsLast6Months) {
      m.uniqueBilledProductsLast6Months = parseInt(proto.uniqueBilledProductsLast6Months, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.accountingStatus !== 'undefined') {
      toReturn['accountingStatus'] = this.accountingStatus;
    }
    if (typeof this.notPayedTerms !== 'undefined') {
      toReturn['notPayedTerms'] = this.notPayedTerms;
    }
    if (typeof this.outstandingBalance !== 'undefined') {
      toReturn['outstandingBalance'] = this.outstandingBalance;
    }
    if (typeof this.currentlyAssignedSalesPerson !== 'undefined') {
      toReturn['currentlyAssignedSalesPerson'] = this.currentlyAssignedSalesPerson;
    }
    if (typeof this.additionalSalesPerson !== 'undefined') {
      toReturn['additionalSalesPerson'] = this.additionalSalesPerson;
    }
    if (typeof this.recurringMeetingTime !== 'undefined') {
      toReturn['recurringMeetingTime'] = this.recurringMeetingTime;
    }
    if (typeof this.recurringMeetingDay !== 'undefined') {
      toReturn['recurringMeetingDay'] = this.recurringMeetingDay;
    }
    if (typeof this.recurringMeetingFrequency !== 'undefined') {
      toReturn['recurringMeetingFrequency'] = this.recurringMeetingFrequency;
    }
    if (typeof this.subscriptionLevel !== 'undefined') {
      toReturn['subscriptionLevel'] = this.subscriptionLevel;
    }
    if (typeof this.partnerCohortSize !== 'undefined') {
      toReturn['partnerCohortSize'] = this.partnerCohortSize;
    }
    if (typeof this.isMultiLocation !== 'undefined') {
      toReturn['isMultiLocation'] = this.isMultiLocation;
    }
    if (typeof this.latestMonthRevenue !== 'undefined') {
      toReturn['latestMonthRevenue'] = this.latestMonthRevenue;
    }
    if (typeof this.oneMonthEarlierRevenue !== 'undefined') {
      toReturn['oneMonthEarlierRevenue'] = this.oneMonthEarlierRevenue;
    }
    if (typeof this.twoMonthEarlierRevenue !== 'undefined') {
      toReturn['twoMonthEarlierRevenue'] = this.twoMonthEarlierRevenue;
    }
    if (typeof this.ytdRevenue !== 'undefined') {
      toReturn['ytdRevenue'] = this.ytdRevenue;
    }
    if (typeof this.revGrowthSinceLastMonth !== 'undefined') {
      toReturn['revGrowthSinceLastMonth'] = this.revGrowthSinceLastMonth;
    }
    if (typeof this.percentageRevGrowthFromLastMonth !== 'undefined') {
      toReturn['percentageRevGrowthFromLastMonth'] = this.percentageRevGrowthFromLastMonth;
    }
    if (typeof this.uniqueBilledProductsLast6Months !== 'undefined') {
      toReturn['uniqueBilledProductsLast6Months'] = this.uniqueBilledProductsLast6Months;
    }
    if (typeof this.logoUrl !== 'undefined') {
      toReturn['logoUrl'] = this.logoUrl;
    }
    if (typeof this.associatedPid !== 'undefined') {
      toReturn['associatedPid'] = this.associatedPid;
    }
    return toReturn;
  }
}
function enumStringToValue$l(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetUpdateSubscriptionTierStatusRequest {
  static fromProto(proto) {
    let m = new GetUpdateSubscriptionTierStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetUpdateSubscriptionTierStatusResponse {
  static fromProto(proto) {
    let m = new GetUpdateSubscriptionTierStatusResponse();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$l(UpdateSubscriptionTierStatus, proto.status);
    }
    if (proto.modified) {
      m.modified = new Date(proto.modified);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    if (typeof this.modified !== 'undefined' && this.modified !== null) {
      toReturn['modified'] = 'toApiJson' in this.modified ? this.modified.toApiJson() : this.modified;
    }
    return toReturn;
  }
}
class InitiateSubscriptionTierUpdateRequest {
  static fromProto(proto) {
    let m = new InitiateSubscriptionTierUpdateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.tierId !== 'undefined') {
      toReturn['tierId'] = this.tierId;
    }
    return toReturn;
  }
}
class UpdateSubscriptionTierRequest {
  static fromProto(proto) {
    let m = new UpdateSubscriptionTierRequest();
    m = Object.assign(m, proto);
    if (proto.frequency) {
      m.frequency = enumStringToValue$l(BillingFrequency, proto.frequency);
    }
    if (proto.updateType) {
      m.updateType = enumStringToValue$l(SubscriptionTierUpdateType, proto.updateType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.tierId !== 'undefined') {
      toReturn['tierId'] = this.tierId;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    if (typeof this.updateType !== 'undefined') {
      toReturn['updateType'] = this.updateType;
    }
    return toReturn;
  }
}
function enumStringToValue$k(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ExperimentSetting {
  static fromProto(proto) {
    let m = new ExperimentSetting();
    m = Object.assign(m, proto);
    if (proto.selectionCriteria) {
      m.selectionCriteria = SelectionCriteria.fromProto(proto.selectionCriteria);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.variantRatio !== 'undefined') {
      toReturn['variantRatio'] = this.variantRatio;
    }
    if (typeof this.selectionCriteria !== 'undefined' && this.selectionCriteria !== null) {
      toReturn['selectionCriteria'] = 'toApiJson' in this.selectionCriteria ? this.selectionCriteria.toApiJson() : this.selectionCriteria;
    }
    if (typeof this.metricsDashboardUrl !== 'undefined') {
      toReturn['metricsDashboardUrl'] = this.metricsDashboardUrl;
    }
    return toReturn;
  }
}
class FeatureFlag {
  static fromProto(proto) {
    let m = new FeatureFlag();
    m = Object.assign(m, proto);
    if (proto.accessLevel) {
      m.accessLevel = enumStringToValue$k(AccessLevel, proto.accessLevel);
    }
    if (proto.accessLevelChangedDate) {
      m.accessLevelChangedDate = new Date(proto.accessLevelChangedDate);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.whitelist) {
      m.whitelist = proto.whitelist.map(PartnerAccess.fromProto);
    }
    if (proto.blacklist) {
      m.blacklist = proto.blacklist.map(PartnerAccess.fromProto);
    }
    if (proto.experimentSettings) {
      m.experimentSettings = ExperimentSetting.fromProto(proto.experimentSettings);
    }
    if (proto.expiration) {
      m.expiration = enumStringToValue$k(Expiration, proto.expiration);
    }
    if (proto.expiryStart) {
      m.expiryStart = new Date(proto.expiryStart);
    }
    if (proto.expiryFinish) {
      m.expiryFinish = new Date(proto.expiryFinish);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.accessLevel !== 'undefined') {
      toReturn['accessLevel'] = this.accessLevel;
    }
    if (typeof this.accessLevelChangedDate !== 'undefined' && this.accessLevelChangedDate !== null) {
      toReturn['accessLevelChangedDate'] = 'toApiJson' in this.accessLevelChangedDate ? this.accessLevelChangedDate.toApiJson() : this.accessLevelChangedDate;
    }
    if (typeof this.accessLevelChangedByEmail !== 'undefined') {
      toReturn['accessLevelChangedByEmail'] = this.accessLevelChangedByEmail;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.createdByEmail !== 'undefined') {
      toReturn['createdByEmail'] = this.createdByEmail;
    }
    if (typeof this.moreInfoUrl !== 'undefined') {
      toReturn['moreInfoUrl'] = this.moreInfoUrl;
    }
    if (typeof this.archived !== 'undefined') {
      toReturn['archived'] = this.archived;
    }
    if (typeof this.whitelist !== 'undefined' && this.whitelist !== null) {
      toReturn['whitelist'] = 'toApiJson' in this.whitelist ? this.whitelist.toApiJson() : this.whitelist;
    }
    if (typeof this.blacklist !== 'undefined' && this.blacklist !== null) {
      toReturn['blacklist'] = 'toApiJson' in this.blacklist ? this.blacklist.toApiJson() : this.blacklist;
    }
    if (typeof this.experimentSettings !== 'undefined' && this.experimentSettings !== null) {
      toReturn['experimentSettings'] = 'toApiJson' in this.experimentSettings ? this.experimentSettings.toApiJson() : this.experimentSettings;
    }
    if (typeof this.ownerName !== 'undefined') {
      toReturn['ownerName'] = this.ownerName;
    }
    if (typeof this.expiration !== 'undefined') {
      toReturn['expiration'] = this.expiration;
    }
    if (typeof this.expiryStart !== 'undefined' && this.expiryStart !== null) {
      toReturn['expiryStart'] = 'toApiJson' in this.expiryStart ? this.expiryStart.toApiJson() : this.expiryStart;
    }
    if (typeof this.expiryFinish !== 'undefined' && this.expiryFinish !== null) {
      toReturn['expiryFinish'] = 'toApiJson' in this.expiryFinish ? this.expiryFinish.toApiJson() : this.expiryFinish;
    }
    if (typeof this.isExpired !== 'undefined') {
      toReturn['isExpired'] = this.isExpired;
    }
    return toReturn;
  }
}
class PartnerAccess {
  static fromProto(proto) {
    let m = new PartnerAccess();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    return toReturn;
  }
}
class SelectionCriteria {
  static fromProto(proto) {
    let m = new SelectionCriteria();
    m = Object.assign(m, proto);
    if (proto.partnerCreatedAfterDate) {
      m.partnerCreatedAfterDate = new Date(proto.partnerCreatedAfterDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subscriptionTierIds !== 'undefined') {
      toReturn['subscriptionTierIds'] = this.subscriptionTierIds;
    }
    if (typeof this.partnerCreatedAfterDate !== 'undefined' && this.partnerCreatedAfterDate !== null) {
      toReturn['partnerCreatedAfterDate'] = 'toApiJson' in this.partnerCreatedAfterDate ? this.partnerCreatedAfterDate.toApiJson() : this.partnerCreatedAfterDate;
    }
    return toReturn;
  }
}
function enumStringToValue$j(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PartnerAdminPermissions {
  static fromProto(proto) {
    let m = new PartnerAdminPermissions();
    m = Object.assign(m, proto);
    if (proto.defaultReportAccessScope) {
      m.defaultReportAccessScope = enumStringToValue$j(ReportAccessScope, proto.defaultReportAccessScope);
    }
    if (proto.reportAccess) {
      m.reportAccess = proto.reportAccess.map(ReportAccess.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.canAccessBilling !== 'undefined') {
      toReturn['canAccessBilling'] = this.canAccessBilling;
    }
    if (typeof this.canAccessRetailBilling !== 'undefined') {
      toReturn['canAccessRetailBilling'] = this.canAccessRetailBilling;
    }
    if (typeof this.canAccessAccounts !== 'undefined') {
      toReturn['canAccessAccounts'] = this.canAccessAccounts;
    }
    if (typeof this.canAccessMarketing !== 'undefined') {
      toReturn['canAccessMarketing'] = this.canAccessMarketing;
    }
    if (typeof this.canAccessSales !== 'undefined') {
      toReturn['canAccessSales'] = this.canAccessSales;
    }
    if (typeof this.canAccessConcierge !== 'undefined') {
      toReturn['canAccessConcierge'] = this.canAccessConcierge;
    }
    if (typeof this.canAccessBrands !== 'undefined') {
      toReturn['canAccessBrands'] = this.canAccessBrands;
    }
    if (typeof this.canAccessDashboard !== 'undefined') {
      toReturn['canAccessDashboard'] = this.canAccessDashboard;
    }
    if (typeof this.canAccessOrders !== 'undefined') {
      toReturn['canAccessOrders'] = this.canAccessOrders;
    }
    if (typeof this.canAccessMarketplace !== 'undefined') {
      toReturn['canAccessMarketplace'] = this.canAccessMarketplace;
    }
    if (typeof this.canAccessCompanyProfile !== 'undefined') {
      toReturn['canAccessCompanyProfile'] = this.canAccessCompanyProfile;
    }
    if (typeof this.canAccessAutomations !== 'undefined') {
      toReturn['canAccessAutomations'] = this.canAccessAutomations;
    }
    if (typeof this.defaultReportAccessScope !== 'undefined') {
      toReturn['defaultReportAccessScope'] = this.defaultReportAccessScope;
    }
    if (typeof this.reportAccess !== 'undefined' && this.reportAccess !== null) {
      toReturn['reportAccess'] = 'toApiJson' in this.reportAccess ? this.reportAccess.toApiJson() : this.reportAccess;
    }
    return toReturn;
  }
}
class ReportAccess {
  static fromProto(proto) {
    let m = new ReportAccess();
    m = Object.assign(m, proto);
    if (proto.idType) {
      m.idType = enumStringToValue$j(ReportAccessIDType, proto.idType);
    }
    if (proto.scope) {
      m.scope = enumStringToValue$j(ReportAccessScope, proto.scope);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.idType !== 'undefined') {
      toReturn['idType'] = this.idType;
    }
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    return toReturn;
  }
}
function enumStringToValue$i(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PartnerHealth {
  static fromProto(proto) {
    let m = new PartnerHealth();
    m = Object.assign(m, proto);
    if (proto.state) {
      m.state = enumStringToValue$i(PartnerHealthState, proto.state);
    }
    if (proto.subState) {
      m.subState = enumStringToValue$i(PartnerHealthSubState, proto.subState);
    }
    if (proto.changedOn) {
      m.changedOn = new Date(proto.changedOn);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.subState !== 'undefined') {
      toReturn['subState'] = this.subState;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    if (typeof this.changedOn !== 'undefined' && this.changedOn !== null) {
      toReturn['changedOn'] = 'toApiJson' in this.changedOn ? this.changedOn.toApiJson() : this.changedOn;
    }
    if (typeof this.changedBy !== 'undefined') {
      toReturn['changedBy'] = this.changedBy;
    }
    if (typeof this.inRetention !== 'undefined') {
      toReturn['inRetention'] = this.inRetention;
    }
    return toReturn;
  }
}
function enumStringToValue$h(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CompanyProfile {
  static fromProto(proto) {
    let m = new CompanyProfile();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.address2 !== 'undefined') {
      toReturn['address2'] = this.address2;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.postalCode !== 'undefined') {
      toReturn['postalCode'] = this.postalCode;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.websiteAddress !== 'undefined') {
      toReturn['websiteAddress'] = this.websiteAddress;
    }
    if (typeof this.emailAddress !== 'undefined') {
      toReturn['emailAddress'] = this.emailAddress;
    }
    if (typeof this.crmCompanyId !== 'undefined') {
      toReturn['crmCompanyId'] = this.crmCompanyId;
    }
    return toReturn;
  }
}
class CreatePartnerRequest {
  static fromProto(proto) {
    let m = new CreatePartnerRequest();
    m = Object.assign(m, proto);
    if (proto.companyProfile) {
      m.companyProfile = CompanyProfile.fromProto(proto.companyProfile);
    }
    if (proto.initialUser) {
      m.initialUser = PartnerUser.fromProto(proto.initialUser);
    }
    if (proto.termsOfService) {
      m.termsOfService = TermOfService.fromProto(proto.termsOfService);
    }
    if (proto.acquisitionData) {
      m.acquisitionData = PartnerAcquisitionData.fromProto(proto.acquisitionData);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.idempotentKey !== 'undefined') {
      toReturn['idempotentKey'] = this.idempotentKey;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.companyProfile !== 'undefined' && this.companyProfile !== null) {
      toReturn['companyProfile'] = 'toApiJson' in this.companyProfile ? this.companyProfile.toApiJson() : this.companyProfile;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.initialUser !== 'undefined' && this.initialUser !== null) {
      toReturn['initialUser'] = 'toApiJson' in this.initialUser ? this.initialUser.toApiJson() : this.initialUser;
    }
    if (typeof this.billingCurrencyCode !== 'undefined') {
      toReturn['billingCurrencyCode'] = this.billingCurrencyCode;
    }
    if (typeof this.termsOfService !== 'undefined' && this.termsOfService !== null) {
      toReturn['termsOfService'] = 'toApiJson' in this.termsOfService ? this.termsOfService.toApiJson() : this.termsOfService;
    }
    if (typeof this.startOnTutorialCampaign !== 'undefined') {
      toReturn['startOnTutorialCampaign'] = this.startOnTutorialCampaign;
    }
    if (typeof this.acquisitionData !== 'undefined' && this.acquisitionData !== null) {
      toReturn['acquisitionData'] = 'toApiJson' in this.acquisitionData ? this.acquisitionData.toApiJson() : this.acquisitionData;
    }
    if (typeof this.subdomain !== 'undefined') {
      toReturn['subdomain'] = this.subdomain;
    }
    if (typeof this.subscriptionTierId !== 'undefined') {
      toReturn['subscriptionTierId'] = this.subscriptionTierId;
    }
    if (typeof this.stripeToken !== 'undefined') {
      toReturn['stripeToken'] = this.stripeToken;
    }
    return toReturn;
  }
}
class GetCreatePartnerStatusRequest {
  static fromProto(proto) {
    let m = new GetCreatePartnerStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.idempotentKey !== 'undefined') {
      toReturn['idempotentKey'] = this.idempotentKey;
    }
    return toReturn;
  }
}
class GetCreatePartnerStatusResponse {
  static fromProto(proto) {
    let m = new GetCreatePartnerStatusResponse();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$h(Status, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.errorMessage !== 'undefined') {
      toReturn['errorMessage'] = this.errorMessage;
    }
    return toReturn;
  }
}
class GetSignUpAddPaymentCardResultRequest {
  static fromProto(proto) {
    let m = new GetSignUpAddPaymentCardResultRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetSignUpAddPaymentCardResultResponse {
  static fromProto(proto) {
    let m = new GetSignUpAddPaymentCardResultResponse();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$h(GetSignUpAddPaymentCardResultResponseStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.error !== 'undefined') {
      toReturn['error'] = this.error;
    }
    return toReturn;
  }
}
class GetUpdatePartnerStatusRequest {
  static fromProto(proto) {
    let m = new GetUpdatePartnerStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.idempotentKey !== 'undefined') {
      toReturn['idempotentKey'] = this.idempotentKey;
    }
    return toReturn;
  }
}
class GetUpdatePartnerStatusResponse {
  static fromProto(proto) {
    let m = new GetUpdatePartnerStatusResponse();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$h(Status, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.errorMessage !== 'undefined') {
      toReturn['errorMessage'] = this.errorMessage;
    }
    return toReturn;
  }
}
class PartnerAcquisitionData {
  static fromProto(proto) {
    let m = new PartnerAcquisitionData();
    m = Object.assign(m, proto);
    if (proto.origin) {
      m.origin = enumStringToValue$h(PartnerOrigin, proto.origin);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    if (typeof this.visitorIdCookie !== 'undefined') {
      toReturn['visitorIdCookie'] = this.visitorIdCookie;
    }
    if (typeof this.conquerLocalAcademyVisitorId !== 'undefined') {
      toReturn['conquerLocalAcademyVisitorId'] = this.conquerLocalAcademyVisitorId;
    }
    if (typeof this.conversionPoint !== 'undefined') {
      toReturn['conversionPoint'] = this.conversionPoint;
    }
    if (typeof this.affiliateId !== 'undefined') {
      toReturn['affiliateId'] = this.affiliateId;
    }
    if (typeof this.numberOfEmployees !== 'undefined') {
      toReturn['numberOfEmployees'] = this.numberOfEmployees;
    }
    if (typeof this.referrerId !== 'undefined') {
      toReturn['referrerId'] = this.referrerId;
    }
    if (typeof this.clearbitCollectedSignupDataId !== 'undefined') {
      toReturn['clearbitCollectedSignupDataId'] = this.clearbitCollectedSignupDataId;
    }
    return toReturn;
  }
}
class PartnerInfo {
  static fromProto(proto) {
    let m = new PartnerInfo();
    m = Object.assign(m, proto);
    if (proto.premiumSupportFlag) {
      m.premiumSupportFlag = enumStringToValue$h(SupportFlag, proto.premiumSupportFlag);
    }
    if (proto.standardPrioritySupportFlag) {
      m.standardPrioritySupportFlag = enumStringToValue$h(SupportFlag, proto.standardPrioritySupportFlag);
    }
    if (proto.priorityChatSupportFlag) {
      m.priorityChatSupportFlag = enumStringToValue$h(SupportFlag, proto.priorityChatSupportFlag);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerName !== 'undefined') {
      toReturn['partnerName'] = this.partnerName;
    }
    if (typeof this.partnerApiKey !== 'undefined') {
      toReturn['partnerApiKey'] = this.partnerApiKey;
    }
    if (typeof this.partnerType !== 'undefined') {
      toReturn['partnerType'] = this.partnerType;
    }
    if (typeof this.serviceLevel !== 'undefined') {
      toReturn['serviceLevel'] = this.serviceLevel;
    }
    if (typeof this.accountExecutive !== 'undefined') {
      toReturn['accountExecutive'] = this.accountExecutive;
    }
    if (typeof this.stripeBillingFlag !== 'undefined') {
      toReturn['stripeBillingFlag'] = this.stripeBillingFlag;
    }
    if (typeof this.excludeFromKpisFlag !== 'undefined') {
      toReturn['excludeFromKpisFlag'] = this.excludeFromKpisFlag;
    }
    if (typeof this.vbcFlag !== 'undefined') {
      toReturn['vbcFlag'] = this.vbcFlag;
    }
    if (typeof this.campaignSubscriptionEnabledFlag !== 'undefined') {
      toReturn['campaignSubscriptionEnabledFlag'] = this.campaignSubscriptionEnabledFlag;
    }
    if (typeof this.vbcKey !== 'undefined') {
      toReturn['vbcKey'] = this.vbcKey;
    }
    if (typeof this.rmPid !== 'undefined') {
      toReturn['rmPid'] = this.rmPid;
    }
    if (typeof this.rmKey !== 'undefined') {
      toReturn['rmKey'] = this.rmKey;
    }
    if (typeof this.msPid !== 'undefined') {
      toReturn['msPid'] = this.msPid;
    }
    if (typeof this.msKey !== 'undefined') {
      toReturn['msKey'] = this.msKey;
    }
    if (typeof this.smPid !== 'undefined') {
      toReturn['smPid'] = this.smPid;
    }
    if (typeof this.smKey !== 'undefined') {
      toReturn['smKey'] = this.smKey;
    }
    if (typeof this.nbPid !== 'undefined') {
      toReturn['nbPid'] = this.nbPid;
    }
    if (typeof this.nbKey !== 'undefined') {
      toReturn['nbKey'] = this.nbKey;
    }
    if (typeof this.armPid !== 'undefined') {
      toReturn['armPid'] = this.armPid;
    }
    if (typeof this.armKey !== 'undefined') {
      toReturn['armKey'] = this.armKey;
    }
    if (typeof this.enableProductMarketplaceFlag !== 'undefined') {
      toReturn['enableProductMarketplaceFlag'] = this.enableProductMarketplaceFlag;
    }
    if (typeof this.hidePricingFlag !== 'undefined') {
      toReturn['hidePricingFlag'] = this.hidePricingFlag;
    }
    if (typeof this.stDefaultCampaignId !== 'undefined') {
      toReturn['stDefaultCampaignId'] = this.stDefaultCampaignId;
    }
    if (typeof this.oauthKey !== 'undefined') {
      toReturn['oauthKey'] = this.oauthKey;
    }
    if (typeof this.oauthSecret !== 'undefined') {
      toReturn['oauthSecret'] = this.oauthSecret;
    }
    if (typeof this.rmMaxCompetitors !== 'undefined') {
      toReturn['rmMaxCompetitors'] = this.rmMaxCompetitors;
    }
    if (typeof this.rmMaxServices !== 'undefined') {
      toReturn['rmMaxServices'] = this.rmMaxServices;
    }
    if (typeof this.enableListingDistributionFlag !== 'undefined') {
      toReturn['enableListingDistributionFlag'] = this.enableListingDistributionFlag;
    }
    if (typeof this.showExpiryFlag !== 'undefined') {
      toReturn['showExpiryFlag'] = this.showExpiryFlag;
    }
    if (typeof this.wholesalePrice !== 'undefined') {
      toReturn['wholesalePrice'] = this.wholesalePrice;
    }
    if (typeof this.enableForAdminFlag !== 'undefined') {
      toReturn['enableForAdminFlag'] = this.enableForAdminFlag;
    }
    if (typeof this.enableListingSyncProFlag !== 'undefined') {
      toReturn['enableListingSyncProFlag'] = this.enableListingSyncProFlag;
    }
    if (typeof this.listingSyncProServiceProvider !== 'undefined') {
      toReturn['listingSyncProServiceProvider'] = this.listingSyncProServiceProvider;
    }
    if (typeof this.enableListingSyncProDiscountFlag !== 'undefined') {
      toReturn['enableListingSyncProDiscountFlag'] = this.enableListingSyncProDiscountFlag;
    }
    if (typeof this.pausedFlag !== 'undefined') {
      toReturn['pausedFlag'] = this.pausedFlag;
    }
    if (typeof this.cancelledFlag !== 'undefined') {
      toReturn['cancelledFlag'] = this.cancelledFlag;
    }
    if (typeof this.premiumSupportFlag !== 'undefined') {
      toReturn['premiumSupportFlag'] = this.premiumSupportFlag;
    }
    if (typeof this.standardPrioritySupportFlag !== 'undefined') {
      toReturn['standardPrioritySupportFlag'] = this.standardPrioritySupportFlag;
    }
    if (typeof this.priorityChatSupportFlag !== 'undefined') {
      toReturn['priorityChatSupportFlag'] = this.priorityChatSupportFlag;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    return toReturn;
  }
}
class PartnerUser {
  static fromProto(proto) {
    let m = new PartnerUser();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    return toReturn;
  }
}
class TermOfService {
  static fromProto(proto) {
    let m = new TermOfService();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accepted !== 'undefined') {
      toReturn['accepted'] = this.accepted;
    }
    if (typeof this.browserIpAddress !== 'undefined') {
      toReturn['browserIpAddress'] = this.browserIpAddress;
    }
    return toReturn;
  }
}
class UpdateCompanyProfileRequest {
  static fromProto(proto) {
    let m = new UpdateCompanyProfileRequest();
    m = Object.assign(m, proto);
    if (proto.companyProfileInfo) {
      m.companyProfileInfo = CompanyProfile.fromProto(proto.companyProfileInfo);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.companyProfileInfo !== 'undefined' && this.companyProfileInfo !== null) {
      toReturn['companyProfileInfo'] = 'toApiJson' in this.companyProfileInfo ? this.companyProfileInfo.toApiJson() : this.companyProfileInfo;
    }
    return toReturn;
  }
}
class UpdatePartnerRequest {
  static fromProto(proto) {
    let m = new UpdatePartnerRequest();
    m = Object.assign(m, proto);
    if (proto.partnerInfo) {
      m.partnerInfo = PartnerInfo.fromProto(proto.partnerInfo);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.idempotentKey !== 'undefined') {
      toReturn['idempotentKey'] = this.idempotentKey;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.partnerInfo !== 'undefined' && this.partnerInfo !== null) {
      toReturn['partnerInfo'] = 'toApiJson' in this.partnerInfo ? this.partnerInfo.toApiJson() : this.partnerInfo;
    }
    return toReturn;
  }
}
function enumStringToValue$g(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class EmailPasswordCredential {
  static fromProto(proto) {
    let m = new EmailPasswordCredential();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.password !== 'undefined') {
      toReturn['password'] = this.password;
    }
    return toReturn;
  }
}
class ExistingAccount {
  static fromProto(proto) {
    let m = new ExistingAccount();
    m = Object.assign(m, proto);
    if (proto.credential) {
      m.credential = SignUpCredential.fromProto(proto.credential);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.credential !== 'undefined' && this.credential !== null) {
      toReturn['credential'] = 'toApiJson' in this.credential ? this.credential.toApiJson() : this.credential;
    }
    return toReturn;
  }
}
class GetGoogleProfileRequest {
  static fromProto(proto) {
    let m = new GetGoogleProfileRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.googleCode !== 'undefined') {
      toReturn['googleCode'] = this.googleCode;
    }
    if (typeof this.redirectUrl !== 'undefined') {
      toReturn['redirectUrl'] = this.redirectUrl;
    }
    return toReturn;
  }
}
class GetGoogleProfileResponse {
  static fromProto(proto) {
    let m = new GetGoogleProfileResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.emailVerified !== 'undefined') {
      toReturn['emailVerified'] = this.emailVerified;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.picture !== 'undefined') {
      toReturn['picture'] = this.picture;
    }
    if (typeof this.givenName !== 'undefined') {
      toReturn['givenName'] = this.givenName;
    }
    if (typeof this.familyName !== 'undefined') {
      toReturn['familyName'] = this.familyName;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.token !== 'undefined') {
      toReturn['token'] = this.token;
    }
    return toReturn;
  }
}
class GetLinkedinProfileRequest {
  static fromProto(proto) {
    let m = new GetLinkedinProfileRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.authorizationCode !== 'undefined') {
      toReturn['authorizationCode'] = this.authorizationCode;
    }
    if (typeof this.redirectUrl !== 'undefined') {
      toReturn['redirectUrl'] = this.redirectUrl;
    }
    return toReturn;
  }
}
class GetLinkedinProfileResponse {
  static fromProto(proto) {
    let m = new GetLinkedinProfileResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.profilePictureUrn !== 'undefined') {
      toReturn['profilePictureUrn'] = this.profilePictureUrn;
    }
    if (typeof this.token !== 'undefined') {
      toReturn['token'] = this.token;
    }
    return toReturn;
  }
}
class GetMicrosoftProfileRequest {
  static fromProto(proto) {
    let m = new GetMicrosoftProfileRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.authorizationCode !== 'undefined') {
      toReturn['authorizationCode'] = this.authorizationCode;
    }
    if (typeof this.redirectUrl !== 'undefined') {
      toReturn['redirectUrl'] = this.redirectUrl;
    }
    return toReturn;
  }
}
class GetMicrosoftProfileResponse {
  static fromProto(proto) {
    let m = new GetMicrosoftProfileResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.picture !== 'undefined') {
      toReturn['picture'] = this.picture;
    }
    if (typeof this.idToken !== 'undefined') {
      toReturn['idToken'] = this.idToken;
    }
    return toReturn;
  }
}
class GetSelfSignUpStatusRequest {
  static fromProto(proto) {
    let m = new GetSelfSignUpStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.idempotentKey !== 'undefined') {
      toReturn['idempotentKey'] = this.idempotentKey;
    }
    return toReturn;
  }
}
class GetSelfSignUpStatusResponse {
  static fromProto(proto) {
    let m = new GetSelfSignUpStatusResponse();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$g(Status, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.errorMessage !== 'undefined') {
      toReturn['errorMessage'] = this.errorMessage;
    }
    return toReturn;
  }
}
class GoogleTokenCredential {
  static fromProto(proto) {
    let m = new GoogleTokenCredential();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.googleToken !== 'undefined') {
      toReturn['googleToken'] = this.googleToken;
    }
    return toReturn;
  }
}
class IsEmailDisposableRequest {
  static fromProto(proto) {
    let m = new IsEmailDisposableRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.recaptchaV2Token !== 'undefined') {
      toReturn['recaptchaV2Token'] = this.recaptchaV2Token;
    }
    if (typeof this.recaptchaV3Token !== 'undefined') {
      toReturn['recaptchaV3Token'] = this.recaptchaV3Token;
    }
    return toReturn;
  }
}
class IsEmailDisposableResponse {
  static fromProto(proto) {
    let m = new IsEmailDisposableResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isDisposable !== 'undefined') {
      toReturn['isDisposable'] = this.isDisposable;
    }
    return toReturn;
  }
}
class IsEmailInUseRequest {
  static fromProto(proto) {
    let m = new IsEmailInUseRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.recaptchaV2Token !== 'undefined') {
      toReturn['recaptchaV2Token'] = this.recaptchaV2Token;
    }
    if (typeof this.recaptchaV3Token !== 'undefined') {
      toReturn['recaptchaV3Token'] = this.recaptchaV3Token;
    }
    if (typeof this.visitorId !== 'undefined') {
      toReturn['visitorId'] = this.visitorId;
    }
    return toReturn;
  }
}
class IsEmailInUseResponse {
  static fromProto(proto) {
    let m = new IsEmailInUseResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subjects !== 'undefined') {
      toReturn['subjects'] = this.subjects;
    }
    return toReturn;
  }
}
class LinkedInTokenCredential {
  static fromProto(proto) {
    let m = new LinkedInTokenCredential();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.linkedinAccessToken !== 'undefined') {
      toReturn['linkedinAccessToken'] = this.linkedinAccessToken;
    }
    return toReturn;
  }
}
class LoginRequest {
  static fromProto(proto) {
    let m = new LoginRequest();
    m = Object.assign(m, proto);
    if (proto.emailPasswordCredential) {
      m.emailPasswordCredential = EmailPasswordCredential.fromProto(proto.emailPasswordCredential);
    }
    if (proto.tokenCredential) {
      m.tokenCredential = GoogleTokenCredential.fromProto(proto.tokenCredential);
    }
    if (proto.linkedinCredential) {
      m.linkedinCredential = LinkedInTokenCredential.fromProto(proto.linkedinCredential);
    }
    if (proto.microsoftCredential) {
      m.microsoftCredential = MicrosoftTokenCredential.fromProto(proto.microsoftCredential);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailPasswordCredential !== 'undefined' && this.emailPasswordCredential !== null) {
      toReturn['emailPasswordCredential'] = 'toApiJson' in this.emailPasswordCredential ? this.emailPasswordCredential.toApiJson() : this.emailPasswordCredential;
    }
    if (typeof this.tokenCredential !== 'undefined' && this.tokenCredential !== null) {
      toReturn['tokenCredential'] = 'toApiJson' in this.tokenCredential ? this.tokenCredential.toApiJson() : this.tokenCredential;
    }
    if (typeof this.linkedinCredential !== 'undefined' && this.linkedinCredential !== null) {
      toReturn['linkedinCredential'] = 'toApiJson' in this.linkedinCredential ? this.linkedinCredential.toApiJson() : this.linkedinCredential;
    }
    if (typeof this.microsoftCredential !== 'undefined' && this.microsoftCredential !== null) {
      toReturn['microsoftCredential'] = 'toApiJson' in this.microsoftCredential ? this.microsoftCredential.toApiJson() : this.microsoftCredential;
    }
    if (typeof this.nextUrl !== 'undefined') {
      toReturn['nextUrl'] = this.nextUrl;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class LoginResponse {
  static fromProto(proto) {
    let m = new LoginResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextUrl !== 'undefined') {
      toReturn['nextUrl'] = this.nextUrl;
    }
    return toReturn;
  }
}
class MicrosoftTokenCredential {
  static fromProto(proto) {
    let m = new MicrosoftTokenCredential();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.microsoftIdToken !== 'undefined') {
      toReturn['microsoftIdToken'] = this.microsoftIdToken;
    }
    return toReturn;
  }
}
class NewAccount {
  static fromProto(proto) {
    let m = new NewAccount();
    m = Object.assign(m, proto);
    if (proto.credential) {
      m.credential = SignUpCredential.fromProto(proto.credential);
    }
    if (proto.companyProfile) {
      m.companyProfile = CompanyProfile.fromProto(proto.companyProfile);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.credential !== 'undefined' && this.credential !== null) {
      toReturn['credential'] = 'toApiJson' in this.credential ? this.credential.toApiJson() : this.credential;
    }
    if (typeof this.companyProfile !== 'undefined' && this.companyProfile !== null) {
      toReturn['companyProfile'] = 'toApiJson' in this.companyProfile ? this.companyProfile.toApiJson() : this.companyProfile;
    }
    return toReturn;
  }
}
class SelfSignUpExistingAccountGroupRequest {
  static fromProto(proto) {
    let m = new SelfSignUpExistingAccountGroupRequest();
    m = Object.assign(m, proto);
    if (proto.termsOfService) {
      m.termsOfService = TermOfService.fromProto(proto.termsOfService);
    }
    if (proto.acquisitionData) {
      m.acquisitionData = PartnerAcquisitionData.fromProto(proto.acquisitionData);
    }
    if (proto.googleToken) {
      m.googleToken = GoogleTokenCredential.fromProto(proto.googleToken);
    }
    if (proto.initialUser) {
      m.initialUser = EmailPasswordCredential.fromProto(proto.initialUser);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.idempotentKey !== 'undefined') {
      toReturn['idempotentKey'] = this.idempotentKey;
    }
    if (typeof this.recaptchaResponse !== 'undefined') {
      toReturn['recaptchaResponse'] = this.recaptchaResponse;
    }
    if (typeof this.recaptchaV3Token !== 'undefined') {
      toReturn['recaptchaV3Token'] = this.recaptchaV3Token;
    }
    if (typeof this.termsOfService !== 'undefined' && this.termsOfService !== null) {
      toReturn['termsOfService'] = 'toApiJson' in this.termsOfService ? this.termsOfService.toApiJson() : this.termsOfService;
    }
    if (typeof this.acquisitionData !== 'undefined' && this.acquisitionData !== null) {
      toReturn['acquisitionData'] = 'toApiJson' in this.acquisitionData ? this.acquisitionData.toApiJson() : this.acquisitionData;
    }
    if (typeof this.googleToken !== 'undefined' && this.googleToken !== null) {
      toReturn['googleToken'] = 'toApiJson' in this.googleToken ? this.googleToken.toApiJson() : this.googleToken;
    }
    if (typeof this.initialUser !== 'undefined' && this.initialUser !== null) {
      toReturn['initialUser'] = 'toApiJson' in this.initialUser ? this.initialUser.toApiJson() : this.initialUser;
    }
    return toReturn;
  }
}
class SelfSignUpRequest {
  static fromProto(proto) {
    let m = new SelfSignUpRequest();
    m = Object.assign(m, proto);
    if (proto.initialUser) {
      m.initialUser = PartnerUser.fromProto(proto.initialUser);
    }
    if (proto.companyProfile) {
      m.companyProfile = CompanyProfile.fromProto(proto.companyProfile);
    }
    if (proto.acquisitionData) {
      m.acquisitionData = PartnerAcquisitionData.fromProto(proto.acquisitionData);
    }
    if (proto.termsOfService) {
      m.termsOfService = TermOfService.fromProto(proto.termsOfService);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.idempotentKey !== 'undefined') {
      toReturn['idempotentKey'] = this.idempotentKey;
    }
    if (typeof this.initialUser !== 'undefined' && this.initialUser !== null) {
      toReturn['initialUser'] = 'toApiJson' in this.initialUser ? this.initialUser.toApiJson() : this.initialUser;
    }
    if (typeof this.websiteOptOutFlag !== 'undefined') {
      toReturn['websiteOptOutFlag'] = this.websiteOptOutFlag;
    }
    if (typeof this.billingCurrencyCode !== 'undefined') {
      toReturn['billingCurrencyCode'] = this.billingCurrencyCode;
    }
    if (typeof this.companyProfile !== 'undefined' && this.companyProfile !== null) {
      toReturn['companyProfile'] = 'toApiJson' in this.companyProfile ? this.companyProfile.toApiJson() : this.companyProfile;
    }
    if (typeof this.acquisitionData !== 'undefined' && this.acquisitionData !== null) {
      toReturn['acquisitionData'] = 'toApiJson' in this.acquisitionData ? this.acquisitionData.toApiJson() : this.acquisitionData;
    }
    if (typeof this.recaptchaResponse !== 'undefined') {
      toReturn['recaptchaResponse'] = this.recaptchaResponse;
    }
    if (typeof this.recaptchaV3Token !== 'undefined') {
      toReturn['recaptchaV3Token'] = this.recaptchaV3Token;
    }
    if (typeof this.termsOfService !== 'undefined' && this.termsOfService !== null) {
      toReturn['termsOfService'] = 'toApiJson' in this.termsOfService ? this.termsOfService.toApiJson() : this.termsOfService;
    }
    if (typeof this.userPassword !== 'undefined') {
      toReturn['userPassword'] = this.userPassword;
    }
    return toReturn;
  }
}
class SelfSignUpWithGoogleRequest {
  static fromProto(proto) {
    let m = new SelfSignUpWithGoogleRequest();
    m = Object.assign(m, proto);
    if (proto.acquisitionData) {
      m.acquisitionData = PartnerAcquisitionData.fromProto(proto.acquisitionData);
    }
    if (proto.companyProfile) {
      m.companyProfile = CompanyProfile.fromProto(proto.companyProfile);
    }
    if (proto.termsOfService) {
      m.termsOfService = TermOfService.fromProto(proto.termsOfService);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.idempotentKey !== 'undefined') {
      toReturn['idempotentKey'] = this.idempotentKey;
    }
    if (typeof this.googleToken !== 'undefined') {
      toReturn['googleToken'] = this.googleToken;
    }
    if (typeof this.acquisitionData !== 'undefined' && this.acquisitionData !== null) {
      toReturn['acquisitionData'] = 'toApiJson' in this.acquisitionData ? this.acquisitionData.toApiJson() : this.acquisitionData;
    }
    if (typeof this.companyProfile !== 'undefined' && this.companyProfile !== null) {
      toReturn['companyProfile'] = 'toApiJson' in this.companyProfile ? this.companyProfile.toApiJson() : this.companyProfile;
    }
    if (typeof this.websiteOptOutFlag !== 'undefined') {
      toReturn['websiteOptOutFlag'] = this.websiteOptOutFlag;
    }
    if (typeof this.recaptchaResponse !== 'undefined') {
      toReturn['recaptchaResponse'] = this.recaptchaResponse;
    }
    if (typeof this.recaptchaV3Token !== 'undefined') {
      toReturn['recaptchaV3Token'] = this.recaptchaV3Token;
    }
    if (typeof this.billingCurrencyCode !== 'undefined') {
      toReturn['billingCurrencyCode'] = this.billingCurrencyCode;
    }
    if (typeof this.termsOfService !== 'undefined' && this.termsOfService !== null) {
      toReturn['termsOfService'] = 'toApiJson' in this.termsOfService ? this.termsOfService.toApiJson() : this.termsOfService;
    }
    return toReturn;
  }
}
class SelfSignUpWithLinkedRequest {
  static fromProto(proto) {
    let m = new SelfSignUpWithLinkedRequest();
    m = Object.assign(m, proto);
    if (proto.acquisitionData) {
      m.acquisitionData = PartnerAcquisitionData.fromProto(proto.acquisitionData);
    }
    if (proto.companyProfile) {
      m.companyProfile = CompanyProfile.fromProto(proto.companyProfile);
    }
    if (proto.termsOfService) {
      m.termsOfService = TermOfService.fromProto(proto.termsOfService);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.idempotentKey !== 'undefined') {
      toReturn['idempotentKey'] = this.idempotentKey;
    }
    if (typeof this.linkedinToken !== 'undefined') {
      toReturn['linkedinToken'] = this.linkedinToken;
    }
    if (typeof this.acquisitionData !== 'undefined' && this.acquisitionData !== null) {
      toReturn['acquisitionData'] = 'toApiJson' in this.acquisitionData ? this.acquisitionData.toApiJson() : this.acquisitionData;
    }
    if (typeof this.companyProfile !== 'undefined' && this.companyProfile !== null) {
      toReturn['companyProfile'] = 'toApiJson' in this.companyProfile ? this.companyProfile.toApiJson() : this.companyProfile;
    }
    if (typeof this.websiteOptOutFlag !== 'undefined') {
      toReturn['websiteOptOutFlag'] = this.websiteOptOutFlag;
    }
    if (typeof this.recaptchaResponse !== 'undefined') {
      toReturn['recaptchaResponse'] = this.recaptchaResponse;
    }
    if (typeof this.recaptchaV3Token !== 'undefined') {
      toReturn['recaptchaV3Token'] = this.recaptchaV3Token;
    }
    if (typeof this.billingCurrencyCode !== 'undefined') {
      toReturn['billingCurrencyCode'] = this.billingCurrencyCode;
    }
    if (typeof this.termsOfService !== 'undefined' && this.termsOfService !== null) {
      toReturn['termsOfService'] = 'toApiJson' in this.termsOfService ? this.termsOfService.toApiJson() : this.termsOfService;
    }
    return toReturn;
  }
}
class SignUpCredential {
  static fromProto(proto) {
    let m = new SignUpCredential();
    m = Object.assign(m, proto);
    if (proto.googleToken) {
      m.googleToken = GoogleTokenCredential.fromProto(proto.googleToken);
    }
    if (proto.user) {
      m.user = UserCredential.fromProto(proto.user);
    }
    if (proto.linkedinToken) {
      m.linkedinToken = LinkedInTokenCredential.fromProto(proto.linkedinToken);
    }
    if (proto.microsoftToken) {
      m.microsoftToken = MicrosoftTokenCredential.fromProto(proto.microsoftToken);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.googleToken !== 'undefined' && this.googleToken !== null) {
      toReturn['googleToken'] = 'toApiJson' in this.googleToken ? this.googleToken.toApiJson() : this.googleToken;
    }
    if (typeof this.user !== 'undefined' && this.user !== null) {
      toReturn['user'] = 'toApiJson' in this.user ? this.user.toApiJson() : this.user;
    }
    if (typeof this.linkedinToken !== 'undefined' && this.linkedinToken !== null) {
      toReturn['linkedinToken'] = 'toApiJson' in this.linkedinToken ? this.linkedinToken.toApiJson() : this.linkedinToken;
    }
    if (typeof this.microsoftToken !== 'undefined' && this.microsoftToken !== null) {
      toReturn['microsoftToken'] = 'toApiJson' in this.microsoftToken ? this.microsoftToken.toApiJson() : this.microsoftToken;
    }
    return toReturn;
  }
}
class SignUpRequest {
  static fromProto(proto) {
    let m = new SignUpRequest();
    m = Object.assign(m, proto);
    if (proto.newAccount) {
      m.newAccount = NewAccount.fromProto(proto.newAccount);
    }
    if (proto.existingAccount) {
      m.existingAccount = ExistingAccount.fromProto(proto.existingAccount);
    }
    if (proto.acquisitionData) {
      m.acquisitionData = PartnerAcquisitionData.fromProto(proto.acquisitionData);
    }
    if (proto.termsOfService) {
      m.termsOfService = TermOfService.fromProto(proto.termsOfService);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.idempotentKey !== 'undefined') {
      toReturn['idempotentKey'] = this.idempotentKey;
    }
    if (typeof this.newAccount !== 'undefined' && this.newAccount !== null) {
      toReturn['newAccount'] = 'toApiJson' in this.newAccount ? this.newAccount.toApiJson() : this.newAccount;
    }
    if (typeof this.existingAccount !== 'undefined' && this.existingAccount !== null) {
      toReturn['existingAccount'] = 'toApiJson' in this.existingAccount ? this.existingAccount.toApiJson() : this.existingAccount;
    }
    if (typeof this.acquisitionData !== 'undefined' && this.acquisitionData !== null) {
      toReturn['acquisitionData'] = 'toApiJson' in this.acquisitionData ? this.acquisitionData.toApiJson() : this.acquisitionData;
    }
    if (typeof this.termsOfService !== 'undefined' && this.termsOfService !== null) {
      toReturn['termsOfService'] = 'toApiJson' in this.termsOfService ? this.termsOfService.toApiJson() : this.termsOfService;
    }
    if (typeof this.recaptchaV2Token !== 'undefined') {
      toReturn['recaptchaV2Token'] = this.recaptchaV2Token;
    }
    if (typeof this.recaptchaV3Token !== 'undefined') {
      toReturn['recaptchaV3Token'] = this.recaptchaV3Token;
    }
    if (typeof this.billingCurrencyCode !== 'undefined') {
      toReturn['billingCurrencyCode'] = this.billingCurrencyCode;
    }
    if (typeof this.websiteOptOutFlag !== 'undefined') {
      toReturn['websiteOptOutFlag'] = this.websiteOptOutFlag;
    }
    if (typeof this.subscriptionTierId !== 'undefined') {
      toReturn['subscriptionTierId'] = this.subscriptionTierId;
    }
    if (typeof this.stripeToken !== 'undefined') {
      toReturn['stripeToken'] = this.stripeToken;
    }
    if (typeof this.nextUrl !== 'undefined') {
      toReturn['nextUrl'] = this.nextUrl;
    }
    return toReturn;
  }
}
class UserCredential {
  static fromProto(proto) {
    let m = new UserCredential();
    m = Object.assign(m, proto);
    if (proto.user) {
      m.user = PartnerUser.fromProto(proto.user);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.user !== 'undefined' && this.user !== null) {
      toReturn['user'] = 'toApiJson' in this.user ? this.user.toApiJson() : this.user;
    }
    if (typeof this.password !== 'undefined') {
      toReturn['password'] = this.password;
    }
    return toReturn;
  }
}
function enumStringToValue$f(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AddRewardToPartnerRequest {
  static fromProto(proto) {
    let m = new AddRewardToPartnerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.rewardId !== 'undefined') {
      toReturn['rewardId'] = this.rewardId;
    }
    return toReturn;
  }
}
class AttemptRewardClaimRequest {
  static fromProto(proto) {
    let m = new AttemptRewardClaimRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.rewardId !== 'undefined') {
      toReturn['rewardId'] = this.rewardId;
    }
    return toReturn;
  }
}
class Claimed {
  static fromProto(proto) {
    let m = new Claimed();
    m = Object.assign(m, proto);
    if (proto.date) {
      m.date = new Date(proto.date);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.date !== 'undefined' && this.date !== null) {
      toReturn['date'] = 'toApiJson' in this.date ? this.date.toApiJson() : this.date;
    }
    return toReturn;
  }
}
class GetRewardRequest {
  static fromProto(proto) {
    let m = new GetRewardRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.rewardId !== 'undefined') {
      toReturn['rewardId'] = this.rewardId;
    }
    return toReturn;
  }
}
class GetRewardResponse {
  static fromProto(proto) {
    let m = new GetRewardResponse();
    m = Object.assign(m, proto);
    if (proto.reward) {
      m.reward = Reward.fromProto(proto.reward);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reward !== 'undefined' && this.reward !== null) {
      toReturn['reward'] = 'toApiJson' in this.reward ? this.reward.toApiJson() : this.reward;
    }
    return toReturn;
  }
}
class IsRewardConditionMetForPartnerRequest {
  static fromProto(proto) {
    let m = new IsRewardConditionMetForPartnerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.rewardId !== 'undefined') {
      toReturn['rewardId'] = this.rewardId;
    }
    return toReturn;
  }
}
class IsRewardConditionMetForPartnerResponse {
  static fromProto(proto) {
    let m = new IsRewardConditionMetForPartnerResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.rewardConditionsMet !== 'undefined') {
      toReturn['rewardConditionsMet'] = this.rewardConditionsMet;
    }
    return toReturn;
  }
}
class Money {
  static fromProto(proto) {
    let m = new Money();
    m = Object.assign(m, proto);
    if (proto.valueInCents) {
      m.valueInCents = parseInt(proto.valueInCents, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.valueInCents !== 'undefined') {
      toReturn['valueInCents'] = this.valueInCents;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    return toReturn;
  }
}
class Reward {
  static fromProto(proto) {
    let m = new Reward();
    m = Object.assign(m, proto);
    if (proto.amount) {
      m.amount = Money.fromProto(proto.amount);
    }
    if (proto.status) {
      m.status = enumStringToValue$f(RewardStatus, proto.status);
    }
    if (proto.claimed) {
      m.claimed = Claimed.fromProto(proto.claimed);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.rewardId !== 'undefined') {
      toReturn['rewardId'] = this.rewardId;
    }
    if (typeof this.amount !== 'undefined' && this.amount !== null) {
      toReturn['amount'] = 'toApiJson' in this.amount ? this.amount.toApiJson() : this.amount;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.claimed !== 'undefined' && this.claimed !== null) {
      toReturn['claimed'] = 'toApiJson' in this.claimed ? this.claimed.toApiJson() : this.claimed;
    }
    return toReturn;
  }
}
function enumStringToValue$e(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetSalesConfigRequest {
  static fromProto(proto) {
    let m = new GetSalesConfigRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class GetSalesConfigResponse {
  static fromProto(proto) {
    let m = new GetSalesConfigResponse();
    m = Object.assign(m, proto);
    if (proto.config) {
      m.config = SalesConfiguration.fromProto(proto.config);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    return toReturn;
  }
}
class SalesConfigInputs {
  static fromProto(proto) {
    let m = new SalesConfigInputs();
    m = Object.assign(m, proto);
    if (proto.hideProducts) {
      m.hideProducts = enumStringToValue$e(SalesSetting, proto.hideProducts);
    }
    if (proto.hideRmDemo) {
      m.hideRmDemo = enumStringToValue$e(SalesSetting, proto.hideRmDemo);
    }
    if (proto.hideOrders) {
      m.hideOrders = enumStringToValue$e(SalesSetting, proto.hideOrders);
    }
    if (proto.stTeamActivity) {
      m.stTeamActivity = enumStringToValue$e(SalesSetting, proto.stTeamActivity);
    }
    if (proto.stAllowSalespersonCampaignAdd) {
      m.stAllowSalespersonCampaignAdd = enumStringToValue$e(SalesSetting, proto.stAllowSalespersonCampaignAdd);
    }
    if (proto.stShowProductsWholesalePrice) {
      m.stShowProductsWholesalePrice = enumStringToValue$e(SalesSetting, proto.stShowProductsWholesalePrice);
    }
    if (proto.stShowTrainingResourcesField) {
      m.stShowTrainingResourcesField = enumStringToValue$e(SalesSetting, proto.stShowTrainingResourcesField);
    }
    if (proto.stSalespersonSharedAccountAccess) {
      m.stSalespersonSharedAccountAccess = enumStringToValue$e(SalesSetting, proto.stSalespersonSharedAccountAccess);
    }
    if (proto.stEnableSnapshotsPerSalespersonLimit) {
      m.stEnableSnapshotsPerSalespersonLimit = enumStringToValue$e(SalesSetting, proto.stEnableSnapshotsPerSalespersonLimit);
    }
    if (proto.stSnapshotsPerSalespersonLimit) {
      m.stSnapshotsPerSalespersonLimit = parseInt(proto.stSnapshotsPerSalespersonLimit, 10);
    }
    if (proto.stBusinessCenterAccess) {
      m.stBusinessCenterAccess = enumStringToValue$e(SalesSetting, proto.stBusinessCenterAccess);
    }
    if (proto.stShowInbox) {
      m.stShowInbox = enumStringToValue$e(SalesSetting, proto.stShowInbox);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hideProducts !== 'undefined') {
      toReturn['hideProducts'] = this.hideProducts;
    }
    if (typeof this.hideRmDemo !== 'undefined') {
      toReturn['hideRmDemo'] = this.hideRmDemo;
    }
    if (typeof this.hideOrders !== 'undefined') {
      toReturn['hideOrders'] = this.hideOrders;
    }
    if (typeof this.stTeamActivity !== 'undefined') {
      toReturn['stTeamActivity'] = this.stTeamActivity;
    }
    if (typeof this.stAllowSalespersonCampaignAdd !== 'undefined') {
      toReturn['stAllowSalespersonCampaignAdd'] = this.stAllowSalespersonCampaignAdd;
    }
    if (typeof this.stShowProductsWholesalePrice !== 'undefined') {
      toReturn['stShowProductsWholesalePrice'] = this.stShowProductsWholesalePrice;
    }
    if (typeof this.stShowTrainingResourcesField !== 'undefined') {
      toReturn['stShowTrainingResourcesField'] = this.stShowTrainingResourcesField;
    }
    if (typeof this.stSalespersonSharedAccountAccess !== 'undefined') {
      toReturn['stSalespersonSharedAccountAccess'] = this.stSalespersonSharedAccountAccess;
    }
    if (typeof this.stDefaultDisplayCurrency !== 'undefined') {
      toReturn['stDefaultDisplayCurrency'] = this.stDefaultDisplayCurrency;
    }
    if (typeof this.stEnableSnapshotsPerSalespersonLimit !== 'undefined') {
      toReturn['stEnableSnapshotsPerSalespersonLimit'] = this.stEnableSnapshotsPerSalespersonLimit;
    }
    if (typeof this.stSnapshotsPerSalespersonLimit !== 'undefined') {
      toReturn['stSnapshotsPerSalespersonLimit'] = this.stSnapshotsPerSalespersonLimit;
    }
    if (typeof this.stBusinessCenterAccess !== 'undefined') {
      toReturn['stBusinessCenterAccess'] = this.stBusinessCenterAccess;
    }
    if (typeof this.stShowInbox !== 'undefined') {
      toReturn['stShowInbox'] = this.stShowInbox;
    }
    return toReturn;
  }
}
class SalesConfiguration {
  static fromProto(proto) {
    let m = new SalesConfiguration();
    m = Object.assign(m, proto);
    if (proto.stSnapshotsPerSalespersonLimit) {
      m.stSnapshotsPerSalespersonLimit = parseInt(proto.stSnapshotsPerSalespersonLimit, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hideProducts !== 'undefined') {
      toReturn['hideProducts'] = this.hideProducts;
    }
    if (typeof this.hideRmDemo !== 'undefined') {
      toReturn['hideRmDemo'] = this.hideRmDemo;
    }
    if (typeof this.stTeamActivity !== 'undefined') {
      toReturn['stTeamActivity'] = this.stTeamActivity;
    }
    if (typeof this.stAllowSalespersonCampaignAdd !== 'undefined') {
      toReturn['stAllowSalespersonCampaignAdd'] = this.stAllowSalespersonCampaignAdd;
    }
    if (typeof this.stShowProductsWholesalePrice !== 'undefined') {
      toReturn['stShowProductsWholesalePrice'] = this.stShowProductsWholesalePrice;
    }
    if (typeof this.stShowTrainingResourcesField !== 'undefined') {
      toReturn['stShowTrainingResourcesField'] = this.stShowTrainingResourcesField;
    }
    if (typeof this.stSalespersonSharedAccountAccess !== 'undefined') {
      toReturn['stSalespersonSharedAccountAccess'] = this.stSalespersonSharedAccountAccess;
    }
    if (typeof this.stDefaultDisplayCurrency !== 'undefined') {
      toReturn['stDefaultDisplayCurrency'] = this.stDefaultDisplayCurrency;
    }
    if (typeof this.stEnableSnapshotsPerSalespersonLimit !== 'undefined') {
      toReturn['stEnableSnapshotsPerSalespersonLimit'] = this.stEnableSnapshotsPerSalespersonLimit;
    }
    if (typeof this.stSnapshotsPerSalespersonLimit !== 'undefined') {
      toReturn['stSnapshotsPerSalespersonLimit'] = this.stSnapshotsPerSalespersonLimit;
    }
    if (typeof this.stBusinessCenterAccess !== 'undefined') {
      toReturn['stBusinessCenterAccess'] = this.stBusinessCenterAccess;
    }
    if (typeof this.hideOrders !== 'undefined') {
      toReturn['hideOrders'] = this.hideOrders;
    }
    if (typeof this.sscWhitelabeled !== 'undefined') {
      toReturn['sscWhitelabeled'] = this.sscWhitelabeled;
    }
    if (typeof this.stShowInbox !== 'undefined') {
      toReturn['stShowInbox'] = this.stShowInbox;
    }
    return toReturn;
  }
}
class SetSalesConfigRequest {
  static fromProto(proto) {
    let m = new SetSalesConfigRequest();
    m = Object.assign(m, proto);
    if (proto.config) {
      m.config = SalesConfigInputs.fromProto(proto.config);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class SetSalesConfigResponse {
  static fromProto(proto) {
    let m = new SetSalesConfigResponse();
    m = Object.assign(m, proto);
    if (proto.config) {
      m.config = SalesConfigInputs.fromProto(proto.config);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    return toReturn;
  }
}
function enumStringToValue$d(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class BusinessCenterConfiguration {
  static fromProto(proto) {
    let m = new BusinessCenterConfiguration();
    m = Object.assign(m, proto);
    if (proto.referralLink) {
      m.referralLink = ReferralLink.fromProto(proto.referralLink);
    }
    if (proto.singleLocationDefaultTimeRange) {
      m.singleLocationDefaultTimeRange = enumStringToValue$d(TimeRange, proto.singleLocationDefaultTimeRange);
    }
    if (proto.globalNotificationExpiryTime) {
      m.globalNotificationExpiryTime = new Date(proto.globalNotificationExpiryTime);
    }
    if (proto.multiLocationDefaultTimeRange) {
      m.multiLocationDefaultTimeRange = enumStringToValue$d(TimeRange, proto.multiLocationDefaultTimeRange);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.showContentLibrary !== 'undefined') {
      toReturn['showContentLibrary'] = this.showContentLibrary;
    }
    if (typeof this.showLmiDashboard !== 'undefined') {
      toReturn['showLmiDashboard'] = this.showLmiDashboard;
    }
    if (typeof this.showExecutiveReport !== 'undefined') {
      toReturn['showExecutiveReport'] = this.showExecutiveReport;
    }
    if (typeof this.showStore !== 'undefined') {
      toReturn['showStore'] = this.showStore;
    }
    if (typeof this.cancellationNotificationEmail !== 'undefined') {
      toReturn['cancellationNotificationEmail'] = this.cancellationNotificationEmail;
    }
    if (typeof this.globalNotification !== 'undefined') {
      toReturn['globalNotification'] = this.globalNotification;
    }
    if (typeof this.businessAppBranding !== 'undefined') {
      toReturn['businessAppBranding'] = this.businessAppBranding;
    }
    if (typeof this.referralLink !== 'undefined' && this.referralLink !== null) {
      toReturn['referralLink'] = 'toApiJson' in this.referralLink ? this.referralLink.toApiJson() : this.referralLink;
    }
    if (typeof this.accessTrialProducts !== 'undefined') {
      toReturn['accessTrialProducts'] = this.accessTrialProducts;
    }
    if (typeof this.hideQuickbooksConnector !== 'undefined') {
      toReturn['hideQuickbooksConnector'] = this.hideQuickbooksConnector;
    }
    if (typeof this.hideSmbAcademy !== 'undefined') {
      toReturn['hideSmbAcademy'] = this.hideSmbAcademy;
    }
    if (typeof this.showReviewGradeForSmbExecReport !== 'undefined') {
      toReturn['showReviewGradeForSmbExecReport'] = this.showReviewGradeForSmbExecReport;
    }
    if (typeof this.showGetStarted !== 'undefined') {
      toReturn['showGetStarted'] = this.showGetStarted;
    }
    if (typeof this.meetingSchedulerBusinessApp !== 'undefined') {
      toReturn['meetingSchedulerBusinessApp'] = this.meetingSchedulerBusinessApp;
    }
    if (typeof this.showSocialGradeForSmbExecReport !== 'undefined') {
      toReturn['showSocialGradeForSmbExecReport'] = this.showSocialGradeForSmbExecReport;
    }
    if (typeof this.showMyListingInBusinessCenter !== 'undefined') {
      toReturn['showMyListingInBusinessCenter'] = this.showMyListingInBusinessCenter;
    }
    if (typeof this.showInviteTeam !== 'undefined') {
      toReturn['showInviteTeam'] = this.showInviteTeam;
    }
    if (typeof this.disableBusinessNav !== 'undefined') {
      toReturn['disableBusinessNav'] = this.disableBusinessNav;
    }
    if (typeof this.showFulfillment !== 'undefined') {
      toReturn['showFulfillment'] = this.showFulfillment;
    }
    if (typeof this.showOrderPage !== 'undefined') {
      toReturn['showOrderPage'] = this.showOrderPage;
    }
    if (typeof this.showInvoices !== 'undefined') {
      toReturn['showInvoices'] = this.showInvoices;
    }
    if (typeof this.showDashboard !== 'undefined') {
      toReturn['showDashboard'] = this.showDashboard;
    }
    if (typeof this.showFiles !== 'undefined') {
      toReturn['showFiles'] = this.showFiles;
    }
    if (typeof this.showMyProducts !== 'undefined') {
      toReturn['showMyProducts'] = this.showMyProducts;
    }
    if (typeof this.showCustomers !== 'undefined') {
      toReturn['showCustomers'] = this.showCustomers;
    }
    if (typeof this.showRecentActivity !== 'undefined') {
      toReturn['showRecentActivity'] = this.showRecentActivity;
    }
    if (typeof this.showInboxMessage !== 'undefined') {
      toReturn['showInboxMessage'] = this.showInboxMessage;
    }
    if (typeof this.showCustomerJourney !== 'undefined') {
      toReturn['showCustomerJourney'] = this.showCustomerJourney;
    }
    if (typeof this.showOnboardingVideo !== 'undefined') {
      toReturn['showOnboardingVideo'] = this.showOnboardingVideo;
    }
    if (typeof this.onboardingVideoUrl !== 'undefined') {
      toReturn['onboardingVideoUrl'] = this.onboardingVideoUrl;
    }
    if (typeof this.showMarketingFunnel !== 'undefined') {
      toReturn['showMarketingFunnel'] = this.showMarketingFunnel;
    }
    if (typeof this.showCustomGuides !== 'undefined') {
      toReturn['showCustomGuides'] = this.showCustomGuides;
    }
    if (typeof this.customGuidesTags !== 'undefined') {
      toReturn['customGuidesTags'] = this.customGuidesTags;
    }
    if (typeof this.customGuidesUrl !== 'undefined') {
      toReturn['customGuidesUrl'] = this.customGuidesUrl;
    }
    if (typeof this.sendOnboardingCampaign !== 'undefined') {
      toReturn['sendOnboardingCampaign'] = this.sendOnboardingCampaign;
    }
    if (typeof this.onboardingCampaignId !== 'undefined') {
      toReturn['onboardingCampaignId'] = this.onboardingCampaignId;
    }
    if (typeof this.showRecommendationsBanner !== 'undefined') {
      toReturn['showRecommendationsBanner'] = this.showRecommendationsBanner;
    }
    if (typeof this.singleLocationDefaultTimeRange !== 'undefined') {
      toReturn['singleLocationDefaultTimeRange'] = this.singleLocationDefaultTimeRange;
    }
    if (typeof this.showGoogleSearchConsoleCta !== 'undefined') {
      toReturn['showGoogleSearchConsoleCta'] = this.showGoogleSearchConsoleCta;
    }
    if (typeof this.isBusinessProfileEditable !== 'undefined') {
      toReturn['isBusinessProfileEditable'] = this.isBusinessProfileEditable;
    }
    if (typeof this.allowSmbChatWithPartner !== 'undefined') {
      toReturn['allowSmbChatWithPartner'] = this.allowSmbChatWithPartner;
    }
    if (typeof this.showWordPressSalesOrders !== 'undefined') {
      toReturn['showWordPressSalesOrders'] = this.showWordPressSalesOrders;
    }
    if (typeof this.globalNotificationExpiryTime !== 'undefined' && this.globalNotificationExpiryTime !== null) {
      toReturn['globalNotificationExpiryTime'] = 'toApiJson' in this.globalNotificationExpiryTime ? this.globalNotificationExpiryTime.toApiJson() : this.globalNotificationExpiryTime;
    }
    if (typeof this.showListingScore !== 'undefined') {
      toReturn['showListingScore'] = this.showListingScore;
    }
    if (typeof this.multiLocationDefaultTimeRange !== 'undefined') {
      toReturn['multiLocationDefaultTimeRange'] = this.multiLocationDefaultTimeRange;
    }
    if (typeof this.hideCreateAccount !== 'undefined') {
      toReturn['hideCreateAccount'] = this.hideCreateAccount;
    }
    if (typeof this.notificationsEnabled !== 'undefined') {
      toReturn['notificationsEnabled'] = this.notificationsEnabled;
    }
    if (typeof this.showListingScoreAsPercent !== 'undefined') {
      toReturn['showListingScoreAsPercent'] = this.showListingScoreAsPercent;
    }
    if (typeof this.customGuidesInlineTitle !== 'undefined') {
      toReturn['customGuidesInlineTitle'] = this.customGuidesInlineTitle;
    }
    if (typeof this.allowExportReviews !== 'undefined') {
      toReturn['allowExportReviews'] = this.allowExportReviews;
    }
    if (typeof this.decoupleProductAndReportAccess !== 'undefined') {
      toReturn['decoupleProductAndReportAccess'] = this.decoupleProductAndReportAccess;
    }
    if (typeof this.showCrmCompanies !== 'undefined') {
      toReturn['showCrmCompanies'] = this.showCrmCompanies;
    }
    if (typeof this.showCrmTasks !== 'undefined') {
      toReturn['showCrmTasks'] = this.showCrmTasks;
    }
    if (typeof this.showCustomForms !== 'undefined') {
      toReturn['showCustomForms'] = this.showCustomForms;
    }
    if (typeof this.showAutomations !== 'undefined') {
      toReturn['showAutomations'] = this.showAutomations;
    }
    if (typeof this.showCrmOpportunities !== 'undefined') {
      toReturn['showCrmOpportunities'] = this.showCrmOpportunities;
    }
    if (typeof this.showDynamicLists !== 'undefined') {
      toReturn['showDynamicLists'] = this.showDynamicLists;
    }
    if (typeof this.showLeaderboard !== 'undefined') {
      toReturn['showLeaderboard'] = this.showLeaderboard;
    }
    return toReturn;
  }
}
class BusinessCenterMarketConfiguration {
  static fromProto(proto) {
    let m = new BusinessCenterMarketConfiguration();
    m = Object.assign(m, proto);
    if (proto.referralLink) {
      m.referralLink = ReferralLink.fromProto(proto.referralLink);
    }
    if (proto.singleLocationDefaultTimeRange) {
      m.singleLocationDefaultTimeRange = enumStringToValue$d(TimeRange, proto.singleLocationDefaultTimeRange);
    }
    if (proto.globalNotificationExpiryTime) {
      m.globalNotificationExpiryTime = new Date(proto.globalNotificationExpiryTime);
    }
    if (proto.multiLocationDefaultTimeRange) {
      m.multiLocationDefaultTimeRange = enumStringToValue$d(TimeRange, proto.multiLocationDefaultTimeRange);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.showContentLibrary !== 'undefined') {
      toReturn['showContentLibrary'] = this.showContentLibrary;
    }
    if (typeof this.showLmiDashboard !== 'undefined') {
      toReturn['showLmiDashboard'] = this.showLmiDashboard;
    }
    if (typeof this.showExecutiveReport !== 'undefined') {
      toReturn['showExecutiveReport'] = this.showExecutiveReport;
    }
    if (typeof this.showStore !== 'undefined') {
      toReturn['showStore'] = this.showStore;
    }
    if (typeof this.cancellationNotificationEmail !== 'undefined') {
      toReturn['cancellationNotificationEmail'] = this.cancellationNotificationEmail;
    }
    if (typeof this.globalNotification !== 'undefined') {
      toReturn['globalNotification'] = this.globalNotification;
    }
    if (typeof this.businessAppBranding !== 'undefined') {
      toReturn['businessAppBranding'] = this.businessAppBranding;
    }
    if (typeof this.accessTrialProducts !== 'undefined') {
      toReturn['accessTrialProducts'] = this.accessTrialProducts;
    }
    if (typeof this.hideQuickbooksConnector !== 'undefined') {
      toReturn['hideQuickbooksConnector'] = this.hideQuickbooksConnector;
    }
    if (typeof this.hideSmbAcademy !== 'undefined') {
      toReturn['hideSmbAcademy'] = this.hideSmbAcademy;
    }
    if (typeof this.showReviewGradeForSmbExecReport !== 'undefined') {
      toReturn['showReviewGradeForSmbExecReport'] = this.showReviewGradeForSmbExecReport;
    }
    if (typeof this.showGetStarted !== 'undefined') {
      toReturn['showGetStarted'] = this.showGetStarted;
    }
    if (typeof this.meetingSchedulerBusinessApp !== 'undefined') {
      toReturn['meetingSchedulerBusinessApp'] = this.meetingSchedulerBusinessApp;
    }
    if (typeof this.showSocialGradeForSmbExecReport !== 'undefined') {
      toReturn['showSocialGradeForSmbExecReport'] = this.showSocialGradeForSmbExecReport;
    }
    if (typeof this.showInviteTeam !== 'undefined') {
      toReturn['showInviteTeam'] = this.showInviteTeam;
    }
    if (typeof this.showFulfillment !== 'undefined') {
      toReturn['showFulfillment'] = this.showFulfillment;
    }
    if (typeof this.showOrderPage !== 'undefined') {
      toReturn['showOrderPage'] = this.showOrderPage;
    }
    if (typeof this.showInvoices !== 'undefined') {
      toReturn['showInvoices'] = this.showInvoices;
    }
    if (typeof this.showDashboard !== 'undefined') {
      toReturn['showDashboard'] = this.showDashboard;
    }
    if (typeof this.showFiles !== 'undefined') {
      toReturn['showFiles'] = this.showFiles;
    }
    if (typeof this.showMyProducts !== 'undefined') {
      toReturn['showMyProducts'] = this.showMyProducts;
    }
    if (typeof this.showCustomers !== 'undefined') {
      toReturn['showCustomers'] = this.showCustomers;
    }
    if (typeof this.showRecentActivity !== 'undefined') {
      toReturn['showRecentActivity'] = this.showRecentActivity;
    }
    if (typeof this.showInboxMessage !== 'undefined') {
      toReturn['showInboxMessage'] = this.showInboxMessage;
    }
    if (typeof this.referralLink !== 'undefined' && this.referralLink !== null) {
      toReturn['referralLink'] = 'toApiJson' in this.referralLink ? this.referralLink.toApiJson() : this.referralLink;
    }
    if (typeof this.showCustomerJourney !== 'undefined') {
      toReturn['showCustomerJourney'] = this.showCustomerJourney;
    }
    if (typeof this.showOnboardingVideo !== 'undefined') {
      toReturn['showOnboardingVideo'] = this.showOnboardingVideo;
    }
    if (typeof this.onboardingVideoUrl !== 'undefined') {
      toReturn['onboardingVideoUrl'] = this.onboardingVideoUrl;
    }
    if (typeof this.showMarketingFunnel !== 'undefined') {
      toReturn['showMarketingFunnel'] = this.showMarketingFunnel;
    }
    if (typeof this.showCustomGuides !== 'undefined') {
      toReturn['showCustomGuides'] = this.showCustomGuides;
    }
    if (typeof this.customGuidesTags !== 'undefined') {
      toReturn['customGuidesTags'] = this.customGuidesTags;
    }
    if (typeof this.customGuidesUrl !== 'undefined') {
      toReturn['customGuidesUrl'] = this.customGuidesUrl;
    }
    if (typeof this.sendOnboardingCampaign !== 'undefined') {
      toReturn['sendOnboardingCampaign'] = this.sendOnboardingCampaign;
    }
    if (typeof this.onboardingCampaignId !== 'undefined') {
      toReturn['onboardingCampaignId'] = this.onboardingCampaignId;
    }
    if (typeof this.showRecommendationsBanner !== 'undefined') {
      toReturn['showRecommendationsBanner'] = this.showRecommendationsBanner;
    }
    if (typeof this.singleLocationDefaultTimeRange !== 'undefined') {
      toReturn['singleLocationDefaultTimeRange'] = this.singleLocationDefaultTimeRange;
    }
    if (typeof this.showGoogleSearchConsoleCta !== 'undefined') {
      toReturn['showGoogleSearchConsoleCta'] = this.showGoogleSearchConsoleCta;
    }
    if (typeof this.isBusinessProfileEditable !== 'undefined') {
      toReturn['isBusinessProfileEditable'] = this.isBusinessProfileEditable;
    }
    if (typeof this.allowSmbChatWithPartner !== 'undefined') {
      toReturn['allowSmbChatWithPartner'] = this.allowSmbChatWithPartner;
    }
    if (typeof this.showWordPressSalesOrders !== 'undefined') {
      toReturn['showWordPressSalesOrders'] = this.showWordPressSalesOrders;
    }
    if (typeof this.globalNotificationExpiryTime !== 'undefined' && this.globalNotificationExpiryTime !== null) {
      toReturn['globalNotificationExpiryTime'] = 'toApiJson' in this.globalNotificationExpiryTime ? this.globalNotificationExpiryTime.toApiJson() : this.globalNotificationExpiryTime;
    }
    if (typeof this.showListingScore !== 'undefined') {
      toReturn['showListingScore'] = this.showListingScore;
    }
    if (typeof this.multiLocationDefaultTimeRange !== 'undefined') {
      toReturn['multiLocationDefaultTimeRange'] = this.multiLocationDefaultTimeRange;
    }
    if (typeof this.businessAppName !== 'undefined') {
      toReturn['businessAppName'] = this.businessAppName;
    }
    if (typeof this.hideCreateAccount !== 'undefined') {
      toReturn['hideCreateAccount'] = this.hideCreateAccount;
    }
    if (typeof this.notificationsEnabled !== 'undefined') {
      toReturn['notificationsEnabled'] = this.notificationsEnabled;
    }
    if (typeof this.showListingScoreAsPercent !== 'undefined') {
      toReturn['showListingScoreAsPercent'] = this.showListingScoreAsPercent;
    }
    if (typeof this.customGuidesInlineTitle !== 'undefined') {
      toReturn['customGuidesInlineTitle'] = this.customGuidesInlineTitle;
    }
    if (typeof this.allowExportReviews !== 'undefined') {
      toReturn['allowExportReviews'] = this.allowExportReviews;
    }
    if (typeof this.decoupleProductAndReportAccess !== 'undefined') {
      toReturn['decoupleProductAndReportAccess'] = this.decoupleProductAndReportAccess;
    }
    if (typeof this.showCrmCompanies !== 'undefined') {
      toReturn['showCrmCompanies'] = this.showCrmCompanies;
    }
    if (typeof this.showCrmTasks !== 'undefined') {
      toReturn['showCrmTasks'] = this.showCrmTasks;
    }
    if (typeof this.showCustomForms !== 'undefined') {
      toReturn['showCustomForms'] = this.showCustomForms;
    }
    if (typeof this.showAutomations !== 'undefined') {
      toReturn['showAutomations'] = this.showAutomations;
    }
    if (typeof this.showCrmOpportunities !== 'undefined') {
      toReturn['showCrmOpportunities'] = this.showCrmOpportunities;
    }
    if (typeof this.showDynamicLists !== 'undefined') {
      toReturn['showDynamicLists'] = this.showDynamicLists;
    }
    if (typeof this.showLeaderboard !== 'undefined') {
      toReturn['showLeaderboard'] = this.showLeaderboard;
    }
    return toReturn;
  }
}
class GetBusinessCenterMarketConfigurationRequest {
  static fromProto(proto) {
    let m = new GetBusinessCenterMarketConfigurationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class GetBusinessCenterMarketConfigurationResponse {
  static fromProto(proto) {
    let m = new GetBusinessCenterMarketConfigurationResponse();
    m = Object.assign(m, proto);
    if (proto.marketConfiguration) {
      m.marketConfiguration = BusinessCenterMarketConfiguration.fromProto(proto.marketConfiguration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.marketConfiguration !== 'undefined' && this.marketConfiguration !== null) {
      toReturn['marketConfiguration'] = 'toApiJson' in this.marketConfiguration ? this.marketConfiguration.toApiJson() : this.marketConfiguration;
    }
    return toReturn;
  }
}
class ReferralLink {
  static fromProto(proto) {
    let m = new ReferralLink();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.longUrl !== 'undefined') {
      toReturn['longUrl'] = this.longUrl;
    }
    if (typeof this.shortenedUrl !== 'undefined') {
      toReturn['shortenedUrl'] = this.shortenedUrl;
    }
    return toReturn;
  }
}
class SetBusinessCenterConfigRequest {
  static fromProto(proto) {
    let m = new SetBusinessCenterConfigRequest();
    m = Object.assign(m, proto);
    if (proto.config) {
      m.config = BusinessCenterConfiguration.fromProto(proto.config);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class SetBusinessCenterConfigResponse {
  static fromProto(proto) {
    let m = new SetBusinessCenterConfigResponse();
    m = Object.assign(m, proto);
    if (proto.config) {
      m.config = BusinessCenterConfiguration.fromProto(proto.config);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    return toReturn;
  }
}
class UpdateBusinessCenterMarketConfigurationRequest {
  static fromProto(proto) {
    let m = new UpdateBusinessCenterMarketConfigurationRequest();
    m = Object.assign(m, proto);
    if (proto.marketConfiguration) {
      m.marketConfiguration = BusinessCenterMarketConfiguration.fromProto(proto.marketConfiguration);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.marketConfiguration !== 'undefined' && this.marketConfiguration !== null) {
      toReturn['marketConfiguration'] = 'toApiJson' in this.marketConfiguration ? this.marketConfiguration.toApiJson() : this.marketConfiguration;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateBusinessCenterMarketConfigurationResponse {
  static fromProto(proto) {
    let m = new UpdateBusinessCenterMarketConfigurationResponse();
    m = Object.assign(m, proto);
    if (proto.marketConfiguration) {
      m.marketConfiguration = BusinessCenterMarketConfiguration.fromProto(proto.marketConfiguration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.marketConfiguration !== 'undefined' && this.marketConfiguration !== null) {
      toReturn['marketConfiguration'] = 'toApiJson' in this.marketConfiguration ? this.marketConfiguration.toApiJson() : this.marketConfiguration;
    }
    return toReturn;
  }
}
function enumStringToValue$c(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AppIdentifier {
  static fromProto(proto) {
    let m = new AppIdentifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class CompareSubscriptionTiersRequest {
  static fromProto(proto) {
    let m = new CompareSubscriptionTiersRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subscriptionTierIds !== 'undefined') {
      toReturn['subscriptionTierIds'] = this.subscriptionTierIds;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class CompareSubscriptionTiersResponse {
  static fromProto(proto) {
    let m = new CompareSubscriptionTiersResponse();
    m = Object.assign(m, proto);
    if (proto.rows) {
      m.rows = proto.rows.map(ComparisonRow.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.rows !== 'undefined' && this.rows !== null) {
      toReturn['rows'] = 'toApiJson' in this.rows ? this.rows.toApiJson() : this.rows;
    }
    return toReturn;
  }
}
class ComparisonCell {
  static fromProto(proto) {
    let m = new ComparisonCell();
    m = Object.assign(m, proto);
    if (proto.count) {
      m.count = CountConstraint.fromProto(proto.count);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.count !== 'undefined' && this.count !== null) {
      toReturn['count'] = 'toApiJson' in this.count ? this.count.toApiJson() : this.count;
    }
    if (typeof this.isIncluded !== 'undefined') {
      toReturn['isIncluded'] = this.isIncluded;
    }
    if (typeof this.isLimited !== 'undefined') {
      toReturn['isLimited'] = this.isLimited;
    }
    return toReturn;
  }
}
class ComparisonRow {
  static fromProto(proto) {
    let m = new ComparisonRow();
    m = Object.assign(m, proto);
    if (proto.cells) {
      m.cells = proto.cells.map(ComparisonCell.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.rowId !== 'undefined') {
      toReturn['rowId'] = this.rowId;
    }
    if (typeof this.sectionId !== 'undefined') {
      toReturn['sectionId'] = this.sectionId;
    }
    if (typeof this.cells !== 'undefined' && this.cells !== null) {
      toReturn['cells'] = 'toApiJson' in this.cells ? this.cells.toApiJson() : this.cells;
    }
    return toReturn;
  }
}
class CountConstraint {
  static fromProto(proto) {
    let m = new CountConstraint();
    m = Object.assign(m, proto);
    if (proto.included) {
      m.included = parseInt(proto.included, 10);
    }
    if (proto.additionalCost) {
      m.additionalCost = TierCostConstraint.fromProto(proto.additionalCost);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.included !== 'undefined') {
      toReturn['included'] = this.included;
    }
    if (typeof this.additionalCost !== 'undefined' && this.additionalCost !== null) {
      toReturn['additionalCost'] = 'toApiJson' in this.additionalCost ? this.additionalCost.toApiJson() : this.additionalCost;
    }
    return toReturn;
  }
}
class GetSubscriptionTierRequest {
  static fromProto(proto) {
    let m = new GetSubscriptionTierRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetSubscriptionTierResponse {
  static fromProto(proto) {
    let m = new GetSubscriptionTierResponse();
    m = Object.assign(m, proto);
    if (proto.subscriptionTier) {
      m.subscriptionTier = SubscriptionTier.fromProto(proto.subscriptionTier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subscriptionTier !== 'undefined' && this.subscriptionTier !== null) {
      toReturn['subscriptionTier'] = 'toApiJson' in this.subscriptionTier ? this.subscriptionTier.toApiJson() : this.subscriptionTier;
    }
    return toReturn;
  }
}
class ListSubscriptionTiersRequest {
  static fromProto(proto) {
    let m = new ListSubscriptionTiersRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.cursor) {
      m.cursor = parseInt(proto.cursor, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ListSubscriptionTiersResponse {
  static fromProto(proto) {
    let m = new ListSubscriptionTiersResponse();
    m = Object.assign(m, proto);
    if (proto.subscriptionTier) {
      m.subscriptionTier = proto.subscriptionTier.map(SubscriptionTier.fromProto);
    }
    if (proto.cursor) {
      m.cursor = parseInt(proto.cursor, 10);
    }
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subscriptionTier !== 'undefined' && this.subscriptionTier !== null) {
      toReturn['subscriptionTier'] = 'toApiJson' in this.subscriptionTier ? this.subscriptionTier.toApiJson() : this.subscriptionTier;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class SubscriptionTier {
  static fromProto(proto) {
    let m = new SubscriptionTier();
    m = Object.assign(m, proto);
    if (proto.rank) {
      m.rank = parseInt(proto.rank, 10);
    }
    if (proto.usageLimits) {
      m.usageLimits = TierUsageLimits.fromProto(proto.usageLimits);
    }
    if (proto.subscriptionUpdate) {
      m.subscriptionUpdate = SubscriptionUpdate.fromProto(proto.subscriptionUpdate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.partnerModelLevel !== 'undefined') {
      toReturn['partnerModelLevel'] = this.partnerModelLevel;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.pricingPlanId !== 'undefined') {
      toReturn['pricingPlanId'] = this.pricingPlanId;
    }
    if (typeof this.tierVersion !== 'undefined') {
      toReturn['tierVersion'] = this.tierVersion;
    }
    if (typeof this.archived !== 'undefined') {
      toReturn['archived'] = this.archived;
    }
    if (typeof this.enabledFeatures !== 'undefined') {
      toReturn['enabledFeatures'] = this.enabledFeatures;
    }
    if (typeof this.allowTrials !== 'undefined') {
      toReturn['allowTrials'] = this.allowTrials;
    }
    if (typeof this.rank !== 'undefined') {
      toReturn['rank'] = this.rank;
    }
    if (typeof this.usageLimits !== 'undefined' && this.usageLimits !== null) {
      toReturn['usageLimits'] = 'toApiJson' in this.usageLimits ? this.usageLimits.toApiJson() : this.usageLimits;
    }
    if (typeof this.subscriptionUpdate !== 'undefined' && this.subscriptionUpdate !== null) {
      toReturn['subscriptionUpdate'] = 'toApiJson' in this.subscriptionUpdate ? this.subscriptionUpdate.toApiJson() : this.subscriptionUpdate;
    }
    if (typeof this.allowSelfUpgrade !== 'undefined') {
      toReturn['allowSelfUpgrade'] = this.allowSelfUpgrade;
    }
    if (typeof this.allowFreeTrials !== 'undefined') {
      toReturn['allowFreeTrials'] = this.allowFreeTrials;
    }
    return toReturn;
  }
}
class SubscriptionUpdate {
  static fromProto(proto) {
    let m = new SubscriptionUpdate();
    m = Object.assign(m, proto);
    if (proto.salesOrderAppId) {
      m.salesOrderAppId = AppIdentifier.fromProto(proto.salesOrderAppId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesOrderAppId !== 'undefined' && this.salesOrderAppId !== null) {
      toReturn['salesOrderAppId'] = 'toApiJson' in this.salesOrderAppId ? this.salesOrderAppId.toApiJson() : this.salesOrderAppId;
    }
    if (typeof this.subscriptionSkus !== 'undefined') {
      toReturn['subscriptionSkus'] = this.subscriptionSkus;
    }
    if (typeof this.oneTimeSubscriptionSkus !== 'undefined') {
      toReturn['oneTimeSubscriptionSkus'] = this.oneTimeSubscriptionSkus;
    }
    if (typeof this.monthlySubscriptionSkus !== 'undefined') {
      toReturn['monthlySubscriptionSkus'] = this.monthlySubscriptionSkus;
    }
    return toReturn;
  }
}
class TierCostConstraint {
  static fromProto(proto) {
    let m = new TierCostConstraint();
    m = Object.assign(m, proto);
    if (proto.cost) {
      m.cost = parseInt(proto.cost, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cost !== 'undefined') {
      toReturn['cost'] = this.cost;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.isFree !== 'undefined') {
      toReturn['isFree'] = this.isFree;
    }
    return toReturn;
  }
}
class TierUsageLimits {
  static fromProto(proto) {
    let m = new TierUsageLimits();
    m = Object.assign(m, proto);
    if (proto.teamMembers) {
      m.teamMembers = parseInt(proto.teamMembers, 10);
    }
    if (proto.emailsPerMonth) {
      m.emailsPerMonth = parseInt(proto.emailsPerMonth, 10);
    }
    if (proto.annualFee) {
      m.annualFee = parseInt(proto.annualFee, 10);
    }
    if (proto.newSeatCost) {
      m.newSeatCost = parseInt(proto.newSeatCost, 10);
    }
    if (proto.wholesaleDiscount) {
      m.wholesaleDiscount = parseInt(proto.wholesaleDiscount, 10);
    }
    if (proto.snapshots) {
      m.snapshots = parseInt(proto.snapshots, 10);
    }
    if (proto.toolkits) {
      m.toolkits = parseInt(proto.toolkits, 10);
    }
    if (proto.toolkitData) {
      m.toolkitData = proto.toolkitData.map(ToolkitData.fromProto);
    }
    if (proto.monthlyFee) {
      m.monthlyFee = parseInt(proto.monthlyFee, 10);
    }
    if (proto.onboardingFee) {
      m.onboardingFee = parseInt(proto.onboardingFee, 10);
    }
    if (proto.automationsPerMonth) {
      m.automationsPerMonth = parseInt(proto.automationsPerMonth, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.teamMembers !== 'undefined') {
      toReturn['teamMembers'] = this.teamMembers;
    }
    if (typeof this.emailsPerMonth !== 'undefined') {
      toReturn['emailsPerMonth'] = this.emailsPerMonth;
    }
    if (typeof this.annualFee !== 'undefined') {
      toReturn['annualFee'] = this.annualFee;
    }
    if (typeof this.newSeatCost !== 'undefined') {
      toReturn['newSeatCost'] = this.newSeatCost;
    }
    if (typeof this.wholesaleDiscount !== 'undefined') {
      toReturn['wholesaleDiscount'] = this.wholesaleDiscount;
    }
    if (typeof this.snapshots !== 'undefined') {
      toReturn['snapshots'] = this.snapshots;
    }
    if (typeof this.toolkits !== 'undefined') {
      toReturn['toolkits'] = this.toolkits;
    }
    if (typeof this.toolkitData !== 'undefined' && this.toolkitData !== null) {
      toReturn['toolkitData'] = 'toApiJson' in this.toolkitData ? this.toolkitData.toApiJson() : this.toolkitData;
    }
    if (typeof this.monthlyFee !== 'undefined') {
      toReturn['monthlyFee'] = this.monthlyFee;
    }
    if (typeof this.onboardingFee !== 'undefined') {
      toReturn['onboardingFee'] = this.onboardingFee;
    }
    if (typeof this.automationsPerMonth !== 'undefined') {
      toReturn['automationsPerMonth'] = this.automationsPerMonth;
    }
    return toReturn;
  }
}
class ToolkitData {
  static fromProto(proto) {
    let m = new ToolkitData();
    m = Object.assign(m, proto);
    if (proto.limit) {
      m.limit = parseInt(proto.limit, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.limit !== 'undefined') {
      toReturn['limit'] = this.limit;
    }
    return toReturn;
  }
}
function enumStringToValue$b(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateTermsOfServiceRequest {
  static fromProto(proto) {
    let m = new CreateTermsOfServiceRequest();
    m = Object.assign(m, proto);
    if (proto.termsOfService) {
      m.termsOfService = TermsOfService.fromProto(proto.termsOfService);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.termsOfService !== 'undefined' && this.termsOfService !== null) {
      toReturn['termsOfService'] = 'toApiJson' in this.termsOfService ? this.termsOfService.toApiJson() : this.termsOfService;
    }
    return toReturn;
  }
}
class GetTermsOfServiceRequest {
  static fromProto(proto) {
    let m = new GetTermsOfServiceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.feature !== 'undefined') {
      toReturn['feature'] = this.feature;
    }
    return toReturn;
  }
}
class GetTermsOfServiceResponse {
  static fromProto(proto) {
    let m = new GetTermsOfServiceResponse();
    m = Object.assign(m, proto);
    if (proto.termsOfService) {
      m.termsOfService = TermsOfService.fromProto(proto.termsOfService);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.termsOfService !== 'undefined' && this.termsOfService !== null) {
      toReturn['termsOfService'] = 'toApiJson' in this.termsOfService ? this.termsOfService.toApiJson() : this.termsOfService;
    }
    return toReturn;
  }
}
class TermsOfService {
  static fromProto(proto) {
    let m = new TermsOfService();
    m = Object.assign(m, proto);
    if (proto.createdOn) {
      m.createdOn = new Date(proto.createdOn);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.termsOfService !== 'undefined') {
      toReturn['termsOfService'] = this.termsOfService;
    }
    if (typeof this.product !== 'undefined') {
      toReturn['product'] = this.product;
    }
    if (typeof this.language !== 'undefined') {
      toReturn['language'] = this.language;
    }
    if (typeof this.createdOn !== 'undefined' && this.createdOn !== null) {
      toReturn['createdOn'] = 'toApiJson' in this.createdOn ? this.createdOn.toApiJson() : this.createdOn;
    }
    if (typeof this.feature !== 'undefined') {
      toReturn['feature'] = this.feature;
    }
    return toReturn;
  }
}
function enumStringToValue$a(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetUserAgreementTermsOfServiceRequest {
  static fromProto(proto) {
    let m = new GetUserAgreementTermsOfServiceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.feature !== 'undefined') {
      toReturn['feature'] = this.feature;
    }
    return toReturn;
  }
}
class GetUserAgreementTermsOfServiceResponse {
  static fromProto(proto) {
    let m = new GetUserAgreementTermsOfServiceResponse();
    m = Object.assign(m, proto);
    if (proto.userAgreementTermsOfService) {
      m.userAgreementTermsOfService = UserAgreementTermsOfService.fromProto(proto.userAgreementTermsOfService);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userAgreementTermsOfService !== 'undefined' && this.userAgreementTermsOfService !== null) {
      toReturn['userAgreementTermsOfService'] = 'toApiJson' in this.userAgreementTermsOfService ? this.userAgreementTermsOfService.toApiJson() : this.userAgreementTermsOfService;
    }
    return toReturn;
  }
}
class SetUserAgreementTermsOfServiceRequest {
  static fromProto(proto) {
    let m = new SetUserAgreementTermsOfServiceRequest();
    m = Object.assign(m, proto);
    if (proto.userAgreementTermsOfService) {
      m.userAgreementTermsOfService = UserAgreementTermsOfService.fromProto(proto.userAgreementTermsOfService);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userAgreementTermsOfService !== 'undefined' && this.userAgreementTermsOfService !== null) {
      toReturn['userAgreementTermsOfService'] = 'toApiJson' in this.userAgreementTermsOfService ? this.userAgreementTermsOfService.toApiJson() : this.userAgreementTermsOfService;
    }
    return toReturn;
  }
}
class UserAgreementTermsOfService {
  static fromProto(proto) {
    let m = new UserAgreementTermsOfService();
    m = Object.assign(m, proto);
    if (proto.acceptedAt) {
      m.acceptedAt = new Date(proto.acceptedAt);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.accepted !== 'undefined') {
      toReturn['accepted'] = this.accepted;
    }
    if (typeof this.acceptedAt !== 'undefined' && this.acceptedAt !== null) {
      toReturn['acceptedAt'] = 'toApiJson' in this.acceptedAt ? this.acceptedAt.toApiJson() : this.acceptedAt;
    }
    if (typeof this.feature !== 'undefined') {
      toReturn['feature'] = this.feature;
    }
    return toReturn;
  }
}
function enumStringToValue$9(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class DeleteWizardStatusRequest {
  static fromProto(proto) {
    let m = new DeleteWizardStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class GetWizardStatusRequest {
  static fromProto(proto) {
    let m = new GetWizardStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class GetWizardStatusResponse {
  static fromProto(proto) {
    let m = new GetWizardStatusResponse();
    m = Object.assign(m, proto);
    if (proto.wizardStatus) {
      m.wizardStatus = WizardStatus.fromProto(proto.wizardStatus);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.wizardStatus !== 'undefined' && this.wizardStatus !== null) {
      toReturn['wizardStatus'] = 'toApiJson' in this.wizardStatus ? this.wizardStatus.toApiJson() : this.wizardStatus;
    }
    return toReturn;
  }
}
class ListWizardStatusRequest {
  static fromProto(proto) {
    let m = new ListWizardStatusRequest();
    m = Object.assign(m, proto);
    if (proto.paging) {
      m.paging = PagingRequestMetadata.fromProto(proto.paging);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.paging !== 'undefined' && this.paging !== null) {
      toReturn['paging'] = 'toApiJson' in this.paging ? this.paging.toApiJson() : this.paging;
    }
    return toReturn;
  }
}
class ListWizardStatusResponse {
  static fromProto(proto) {
    let m = new ListWizardStatusResponse();
    m = Object.assign(m, proto);
    if (proto.wizardStatuses) {
      m.wizardStatuses = proto.wizardStatuses.map(WizardStatus.fromProto);
    }
    if (proto.paging) {
      m.paging = PagedResponseData.fromProto(proto.paging);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.wizardStatuses !== 'undefined' && this.wizardStatuses !== null) {
      toReturn['wizardStatuses'] = 'toApiJson' in this.wizardStatuses ? this.wizardStatuses.toApiJson() : this.wizardStatuses;
    }
    if (typeof this.paging !== 'undefined' && this.paging !== null) {
      toReturn['paging'] = 'toApiJson' in this.paging ? this.paging.toApiJson() : this.paging;
    }
    return toReturn;
  }
}
class PagedResponseData {
  static fromProto(proto) {
    let m = new PagedResponseData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class PagingRequestMetadata {
  static fromProto(proto) {
    let m = new PagingRequestMetadata();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagingResponseMetadata {
  static fromProto(proto) {
    let m = new PagingResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.pageNumber) {
      m.pageNumber = parseInt(proto.pageNumber, 10);
    }
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.pageNumber !== 'undefined') {
      toReturn['pageNumber'] = this.pageNumber;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class ReplaceWizardStatusRequest {
  static fromProto(proto) {
    let m = new ReplaceWizardStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.activeStep !== 'undefined') {
      toReturn['activeStep'] = this.activeStep;
    }
    return toReturn;
  }
}
class WizardStatus {
  static fromProto(proto) {
    let m = new WizardStatus();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.activeStep !== 'undefined') {
      toReturn['activeStep'] = this.activeStep;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    return toReturn;
  }
}
function enumStringToValue$8(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CustomerSurveyAddFeedbackRequest {
  static fromProto(proto) {
    let m = new CustomerSurveyAddFeedbackRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerSurveyResponseId !== 'undefined') {
      toReturn['customerSurveyResponseId'] = this.customerSurveyResponseId;
    }
    if (typeof this.feedback !== 'undefined') {
      toReturn['feedback'] = this.feedback;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    return toReturn;
  }
}
class CustomerSurveyListResponsesRequest {
  static fromProto(proto) {
    let m = new CustomerSurveyListResponsesRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = CustomerSurveyPagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class CustomerSurveyListResponsesResponse {
  static fromProto(proto) {
    let m = new CustomerSurveyListResponsesResponse();
    m = Object.assign(m, proto);
    if (proto.responses) {
      m.responses = proto.responses.map(CustomerSurveyResponse.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = CustomerSurveyPagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.responses !== 'undefined' && this.responses !== null) {
      toReturn['responses'] = 'toApiJson' in this.responses ? this.responses.toApiJson() : this.responses;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class CustomerSurveyPagedRequestOptions {
  static fromProto(proto) {
    let m = new CustomerSurveyPagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class CustomerSurveyPagedResponseMetadata {
  static fromProto(proto) {
    let m = new CustomerSurveyPagedResponseMetadata();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class CustomerSurveyRespondRequest {
  static fromProto(proto) {
    let m = new CustomerSurveyRespondRequest();
    m = Object.assign(m, proto);
    if (proto.rating) {
      m.rating = parseInt(proto.rating, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.rating !== 'undefined') {
      toReturn['rating'] = this.rating;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    return toReturn;
  }
}
class CustomerSurveyRespondResponse {
  static fromProto(proto) {
    let m = new CustomerSurveyRespondResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerSurveyResponseId !== 'undefined') {
      toReturn['customerSurveyResponseId'] = this.customerSurveyResponseId;
    }
    return toReturn;
  }
}
class CustomerSurveyResponse {
  static fromProto(proto) {
    let m = new CustomerSurveyResponse();
    m = Object.assign(m, proto);
    if (proto.rating) {
      m.rating = parseInt(proto.rating, 10);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerSurveyResponseId !== 'undefined') {
      toReturn['customerSurveyResponseId'] = this.customerSurveyResponseId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.rating !== 'undefined') {
      toReturn['rating'] = this.rating;
    }
    if (typeof this.feedback !== 'undefined') {
      toReturn['feedback'] = this.feedback;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    return toReturn;
  }
}
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class BrandingV2 {
  static fromProto(proto) {
    let m = new BrandingV2();
    m = Object.assign(m, proto);
    if (proto.uiTheme) {
      m.uiTheme = enumStringToValue$7(UITheme, proto.uiTheme);
    }
    if (proto.marketOverrides) {
      m.marketOverrides = proto.marketOverrides.map(v => enumStringToValue$7(Field, v));
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.businessAppUiTheme) {
      m.businessAppUiTheme = enumStringToValue$7(UITheme, proto.businessAppUiTheme);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.faviconUrl !== 'undefined') {
      toReturn['faviconUrl'] = this.faviconUrl;
    }
    if (typeof this.shortcutIconUrl !== 'undefined') {
      toReturn['shortcutIconUrl'] = this.shortcutIconUrl;
    }
    if (typeof this.logoUrl !== 'undefined') {
      toReturn['logoUrl'] = this.logoUrl;
    }
    if (typeof this.uiTheme !== 'undefined') {
      toReturn['uiTheme'] = this.uiTheme;
    }
    if (typeof this.primaryColor !== 'undefined') {
      toReturn['primaryColor'] = this.primaryColor;
    }
    if (typeof this.marketOverrides !== 'undefined') {
      toReturn['marketOverrides'] = this.marketOverrides;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.darkModeLogoUrl !== 'undefined') {
      toReturn['darkModeLogoUrl'] = this.darkModeLogoUrl;
    }
    if (typeof this.businessAppUiTheme !== 'undefined') {
      toReturn['businessAppUiTheme'] = this.businessAppUiTheme;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AcquisitionData {
  static fromProto(proto) {
    let m = new AcquisitionData();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    if (typeof this.visitorIdCookie !== 'undefined') {
      toReturn['visitorIdCookie'] = this.visitorIdCookie;
    }
    if (typeof this.conquerLocalAcademyVisitorId !== 'undefined') {
      toReturn['conquerLocalAcademyVisitorId'] = this.conquerLocalAcademyVisitorId;
    }
    if (typeof this.conversionPoint !== 'undefined') {
      toReturn['conversionPoint'] = this.conversionPoint;
    }
    if (typeof this.numberOfEmployees !== 'undefined') {
      toReturn['numberOfEmployees'] = this.numberOfEmployees;
    }
    if (typeof this.affiliateId !== 'undefined') {
      toReturn['affiliateId'] = this.affiliateId;
    }
    if (typeof this.referrerId !== 'undefined') {
      toReturn['referrerId'] = this.referrerId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.clearbitCollectedSignupDataId !== 'undefined') {
      toReturn['clearbitCollectedSignupDataId'] = this.clearbitCollectedSignupDataId;
    }
    return toReturn;
  }
}
class GetAcquisitionDataRequest {
  static fromProto(proto) {
    let m = new GetAcquisitionDataRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetAcquisitionDataResponse {
  static fromProto(proto) {
    let m = new GetAcquisitionDataResponse();
    m = Object.assign(m, proto);
    if (proto.acquisitionData) {
      m.acquisitionData = AcquisitionData.fromProto(proto.acquisitionData);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.acquisitionData !== 'undefined' && this.acquisitionData !== null) {
      toReturn['acquisitionData'] = 'toApiJson' in this.acquisitionData ? this.acquisitionData.toApiJson() : this.acquisitionData;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetFreeTrialRequest {
  static fromProto(proto) {
    let m = new GetFreeTrialRequest();
    m = Object.assign(m, proto);
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class GetFreeTrialResponse {
  static fromProto(proto) {
    let m = new GetFreeTrialResponse();
    m = Object.assign(m, proto);
    if (proto.trialStart) {
      m.trialStart = new Date(proto.trialStart);
    }
    if (proto.trialEnd) {
      m.trialEnd = new Date(proto.trialEnd);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.trialStart !== 'undefined' && this.trialStart !== null) {
      toReturn['trialStart'] = 'toApiJson' in this.trialStart ? this.trialStart.toApiJson() : this.trialStart;
    }
    if (typeof this.trialEnd !== 'undefined' && this.trialEnd !== null) {
      toReturn['trialEnd'] = 'toApiJson' in this.trialEnd ? this.trialEnd.toApiJson() : this.trialEnd;
    }
    if (typeof this.onFreeTrial !== 'undefined') {
      toReturn['onFreeTrial'] = this.onFreeTrial;
    }
    if (typeof this.actionRequiredStatus !== 'undefined') {
      toReturn['actionRequiredStatus'] = this.actionRequiredStatus;
    }
    return toReturn;
  }
}
class GetFreeTrialStatusRequest {
  static fromProto(proto) {
    let m = new GetFreeTrialStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetFreeTrialStatusResponse {
  static fromProto(proto) {
    let m = new GetFreeTrialStatusResponse();
    m = Object.assign(m, proto);
    if (proto.freeTrialEnd) {
      m.freeTrialEnd = new Date(proto.freeTrialEnd);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.onFreeTrial !== 'undefined') {
      toReturn['onFreeTrial'] = this.onFreeTrial;
    }
    if (typeof this.freeTrialEnd !== 'undefined' && this.freeTrialEnd !== null) {
      toReturn['freeTrialEnd'] = 'toApiJson' in this.freeTrialEnd ? this.freeTrialEnd.toApiJson() : this.freeTrialEnd;
    }
    return toReturn;
  }
}
class UpdateCancelFreeTrialReasonMutation {
  static fromProto(proto) {
    let m = new UpdateCancelFreeTrialReasonMutation();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.cancelReason !== 'undefined') {
      toReturn['cancelReason'] = this.cancelReason;
    }
    if (typeof this.additionalComment !== 'undefined') {
      toReturn['additionalComment'] = this.additionalComment;
    }
    return toReturn;
  }
}
class UpdateFreeTrialActionRequiredStatusMutation {
  static fromProto(proto) {
    let m = new UpdateFreeTrialActionRequiredStatusMutation();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.actionRequiredStatus !== 'undefined') {
      toReturn['actionRequiredStatus'] = this.actionRequiredStatus;
    }
    return toReturn;
  }
}
class UpdateFreeTrialMutation {
  static fromProto(proto) {
    let m = new UpdateFreeTrialMutation();
    m = Object.assign(m, proto);
    if (proto.cancelFreeTrialReason) {
      m.cancelFreeTrialReason = UpdateCancelFreeTrialReasonMutation.fromProto(proto.cancelFreeTrialReason);
    }
    if (proto.actionRequiredStatus) {
      m.actionRequiredStatus = UpdateFreeTrialActionRequiredStatusMutation.fromProto(proto.actionRequiredStatus);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cancelFreeTrialReason !== 'undefined' && this.cancelFreeTrialReason !== null) {
      toReturn['cancelFreeTrialReason'] = 'toApiJson' in this.cancelFreeTrialReason ? this.cancelFreeTrialReason.toApiJson() : this.cancelFreeTrialReason;
    }
    if (typeof this.actionRequiredStatus !== 'undefined' && this.actionRequiredStatus !== null) {
      toReturn['actionRequiredStatus'] = 'toApiJson' in this.actionRequiredStatus ? this.actionRequiredStatus.toApiJson() : this.actionRequiredStatus;
    }
    return toReturn;
  }
}
class UpdateFreeTrialRequest {
  static fromProto(proto) {
    let m = new UpdateFreeTrialRequest();
    m = Object.assign(m, proto);
    if (proto.mutations) {
      m.mutations = proto.mutations.map(UpdateFreeTrialMutation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.mutations !== 'undefined' && this.mutations !== null) {
      toReturn['mutations'] = 'toApiJson' in this.mutations ? this.mutations.toApiJson() : this.mutations;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PartnerModel {
  static fromProto(proto) {
    let m = new PartnerModel();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.subscriptionTierId !== 'undefined') {
      toReturn['subscriptionTierId'] = this.subscriptionTierId;
    }
    if (typeof this.premiumSupport !== 'undefined') {
      toReturn['premiumSupport'] = this.premiumSupport;
    }
    if (typeof this.standardPrioritySupport !== 'undefined') {
      toReturn['standardPrioritySupport'] = this.standardPrioritySupport;
    }
    if (typeof this.priorityChatSupport !== 'undefined') {
      toReturn['priorityChatSupport'] = this.priorityChatSupport;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.addressLineOne !== 'undefined') {
      toReturn['addressLineOne'] = this.addressLineOne;
    }
    if (typeof this.addressLineTwo !== 'undefined') {
      toReturn['addressLineTwo'] = this.addressLineTwo;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.stateCode !== 'undefined') {
      toReturn['stateCode'] = this.stateCode;
    }
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    if (typeof this.postalCode !== 'undefined') {
      toReturn['postalCode'] = this.postalCode;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class NavigationItem {
  static fromProto(proto) {
    let m = new NavigationItem();
    m = Object.assign(m, proto);
    if (proto.nestedTabs) {
      m.nestedTabs = proto.nestedTabs.map(NavigationItemChild.fromProto);
    }
    if (proto.badge) {
      m.badge = enumStringToValue$3(NavigationItemBadge, proto.badge);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.locked !== 'undefined') {
      toReturn['locked'] = this.locked;
    }
    if (typeof this.nestedTabs !== 'undefined' && this.nestedTabs !== null) {
      toReturn['nestedTabs'] = 'toApiJson' in this.nestedTabs ? this.nestedTabs.toApiJson() : this.nestedTabs;
    }
    if (typeof this.link !== 'undefined') {
      toReturn['link'] = this.link;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.tabId !== 'undefined') {
      toReturn['tabId'] = this.tabId;
    }
    if (typeof this.popOut !== 'undefined') {
      toReturn['popOut'] = this.popOut;
    }
    if (typeof this.ngRoute !== 'undefined') {
      toReturn['ngRoute'] = this.ngRoute;
    }
    if (typeof this.subsectionHeader !== 'undefined') {
      toReturn['subsectionHeader'] = this.subsectionHeader;
    }
    if (typeof this.svgIcon !== 'undefined') {
      toReturn['svgIcon'] = this.svgIcon;
    }
    if (typeof this.icon !== 'undefined') {
      toReturn['icon'] = this.icon;
    }
    if (typeof this.badge !== 'undefined') {
      toReturn['badge'] = this.badge;
    }
    if (typeof this.i18nKey !== 'undefined') {
      toReturn['i18nKey'] = this.i18nKey;
    }
    return toReturn;
  }
}
class NavigationItemChild {
  static fromProto(proto) {
    let m = new NavigationItemChild();
    m = Object.assign(m, proto);
    if (proto.badge) {
      m.badge = enumStringToValue$3(NavigationItemBadge, proto.badge);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.locked !== 'undefined') {
      toReturn['locked'] = this.locked;
    }
    if (typeof this.link !== 'undefined') {
      toReturn['link'] = this.link;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.tabId !== 'undefined') {
      toReturn['tabId'] = this.tabId;
    }
    if (typeof this.popOut !== 'undefined') {
      toReturn['popOut'] = this.popOut;
    }
    if (typeof this.ngRoute !== 'undefined') {
      toReturn['ngRoute'] = this.ngRoute;
    }
    if (typeof this.subsectionHeader !== 'undefined') {
      toReturn['subsectionHeader'] = this.subsectionHeader;
    }
    if (typeof this.svgIcon !== 'undefined') {
      toReturn['svgIcon'] = this.svgIcon;
    }
    if (typeof this.icon !== 'undefined') {
      toReturn['icon'] = this.icon;
    }
    if (typeof this.badge !== 'undefined') {
      toReturn['badge'] = this.badge;
    }
    if (typeof this.i18nKey !== 'undefined') {
      toReturn['i18nKey'] = this.i18nKey;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetTaskManagerConfigRequest {
  static fromProto(proto) {
    let m = new GetTaskManagerConfigRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetTaskManagerConfigResponse {
  static fromProto(proto) {
    let m = new GetTaskManagerConfigResponse();
    m = Object.assign(m, proto);
    if (proto.config) {
      m.config = TaskManagerConfiguration.fromProto(proto.config);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    return toReturn;
  }
}
class SetTaskManagerConfigRequest {
  static fromProto(proto) {
    let m = new SetTaskManagerConfigRequest();
    m = Object.assign(m, proto);
    if (proto.config) {
      m.config = TaskManagerConfiguration.fromProto(proto.config);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class SetTaskManagerConfigResponse {
  static fromProto(proto) {
    let m = new SetTaskManagerConfigResponse();
    m = Object.assign(m, proto);
    if (proto.config) {
      m.config = TaskManagerConfiguration.fromProto(proto.config);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    return toReturn;
  }
}
class TaskManagerConfiguration {
  static fromProto(proto) {
    let m = new TaskManagerConfiguration();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tmShowInbox !== 'undefined') {
      toReturn['tmShowInbox'] = this.tmShowInbox;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Market {
  static fromProto(proto) {
    let m = new Market();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ActivateAddonRequest {
  static fromProto(proto) {
    let m = new ActivateAddonRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    return toReturn;
  }
}
class ActivateAddonResponse {
  static fromProto(proto) {
    let m = new ActivateAddonResponse();
    m = Object.assign(m, proto);
    if (proto.activation) {
      m.activation = AddonActivation.fromProto(proto.activation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activation !== 'undefined' && this.activation !== null) {
      toReturn['activation'] = 'toApiJson' in this.activation ? this.activation.toApiJson() : this.activation;
    }
    return toReturn;
  }
}
class AddPartnerToWhitelistRequest {
  static fromProto(proto) {
    let m = new AddPartnerToWhitelistRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.featureFlagId !== 'undefined') {
      toReturn['featureFlagId'] = this.featureFlagId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class BrandingApp {
  static fromProto(proto) {
    let m = new BrandingApp();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class BrandingAppsEntry {
  static fromProto(proto) {
    let m = new BrandingAppsEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = BrandingApp.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class BrandingAssets {
  static fromProto(proto) {
    let m = new BrandingAssets();
    m = Object.assign(m, proto);
    if (proto.faviconUrl) {
      m.faviconUrl = URL.fromProto(proto.faviconUrl);
    }
    if (proto.shortcutIconUrl) {
      m.shortcutIconUrl = URL.fromProto(proto.shortcutIconUrl);
    }
    if (proto.logoUrl) {
      m.logoUrl = URL.fromProto(proto.logoUrl);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.faviconUrl !== 'undefined' && this.faviconUrl !== null) {
      toReturn['faviconUrl'] = 'toApiJson' in this.faviconUrl ? this.faviconUrl.toApiJson() : this.faviconUrl;
    }
    if (typeof this.shortcutIconUrl !== 'undefined' && this.shortcutIconUrl !== null) {
      toReturn['shortcutIconUrl'] = 'toApiJson' in this.shortcutIconUrl ? this.shortcutIconUrl.toApiJson() : this.shortcutIconUrl;
    }
    if (typeof this.logoUrl !== 'undefined' && this.logoUrl !== null) {
      toReturn['logoUrl'] = 'toApiJson' in this.logoUrl ? this.logoUrl.toApiJson() : this.logoUrl;
    }
    return toReturn;
  }
}
class BatchGetFeatureFlagRequest {
  static fromProto(proto) {
    let m = new BatchGetFeatureFlagRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ids !== 'undefined') {
      toReturn['ids'] = this.ids;
    }
    return toReturn;
  }
}
class BatchGetFeatureFlagResponse {
  static fromProto(proto) {
    let m = new BatchGetFeatureFlagResponse();
    m = Object.assign(m, proto);
    if (proto.flags) {
      m.flags = proto.flags.map(FeatureFlag.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.flags !== 'undefined' && this.flags !== null) {
      toReturn['flags'] = 'toApiJson' in this.flags ? this.flags.toApiJson() : this.flags;
    }
    return toReturn;
  }
}
class BatchGetStatusFeatureFlagRequest {
  static fromProto(proto) {
    let m = new BatchGetStatusFeatureFlagRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.featureIds !== 'undefined') {
      toReturn['featureIds'] = this.featureIds;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class BatchGetStatusFeatureFlagResponse {
  static fromProto(proto) {
    let m = new BatchGetStatusFeatureFlagResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hasAccess !== 'undefined') {
      toReturn['hasAccess'] = this.hasAccess;
    }
    return toReturn;
  }
}
class Branding {
  static fromProto(proto) {
    let m = new Branding();
    m = Object.assign(m, proto);
    if (proto.uiTheme) {
      m.uiTheme = enumStringToValue(BrandingUITheme, proto.uiTheme);
    }
    if (proto.assets) {
      m.assets = BrandingAssets.fromProto(proto.assets);
    }
    if (proto.apps) {
      m.apps = Object.keys(proto.apps).reduce((obj, k) => {
        obj[k] = BrandingApp.fromProto(proto.apps[k]);
        return obj;
      }, {});
    }
    if (proto.theme) {
      m.theme = Theme.fromProto(proto.theme);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.uiTheme !== 'undefined') {
      toReturn['uiTheme'] = this.uiTheme;
    }
    if (typeof this.primaryColor !== 'undefined') {
      toReturn['primaryColor'] = this.primaryColor;
    }
    if (typeof this.assets !== 'undefined' && this.assets !== null) {
      toReturn['assets'] = 'toApiJson' in this.assets ? this.assets.toApiJson() : this.assets;
    }
    if (typeof this.apps !== 'undefined' && this.apps !== null) {
      toReturn['apps'] = 'toApiJson' in this.apps ? this.apps.toApiJson() : this.apps;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.partnerName !== 'undefined') {
      toReturn['partnerName'] = this.partnerName;
    }
    if (typeof this.theme !== 'undefined' && this.theme !== null) {
      toReturn['theme'] = 'toApiJson' in this.theme ? this.theme.toApiJson() : this.theme;
    }
    return toReturn;
  }
}
class CanSendPreviewEmailRequest {
  static fromProto(proto) {
    let m = new CanSendPreviewEmailRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class CanSendPreviewEmailResponse {
  static fromProto(proto) {
    let m = new CanSendPreviewEmailResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.canSendPreviewEmails !== 'undefined') {
      toReturn['canSendPreviewEmails'] = this.canSendPreviewEmails;
    }
    return toReturn;
  }
}
class CancelTrialRequest {
  static fromProto(proto) {
    let m = new CancelTrialRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.trialId !== 'undefined') {
      toReturn['trialId'] = this.trialId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class Configuration {
  static fromProto(proto) {
    let m = new Configuration();
    m = Object.assign(m, proto);
    if (proto.snapshotConfiguration) {
      m.snapshotConfiguration = SnapshotConfiguration.fromProto(proto.snapshotConfiguration);
    }
    if (proto.subscriptionLevel) {
      m.subscriptionLevel = enumStringToValue(SubscriptionLevel, proto.subscriptionLevel);
    }
    if (proto.reputationConfiguration) {
      m.reputationConfiguration = ReputationConfiguration.fromProto(proto.reputationConfiguration);
    }
    if (proto.salesConfiguration) {
      m.salesConfiguration = SalesConfiguration.fromProto(proto.salesConfiguration);
    }
    if (proto.businessCenterConfiguration) {
      m.businessCenterConfiguration = BusinessCenterConfiguration.fromProto(proto.businessCenterConfiguration);
    }
    if (proto.subscriptionFailure) {
      m.subscriptionFailure = enumStringToValue(SubscriptionFailure, proto.subscriptionFailure);
    }
    if (proto.emailConfiguration) {
      m.emailConfiguration = EmailConfiguration.fromProto(proto.emailConfiguration);
    }
    if (proto.mailingConfiguration) {
      m.mailingConfiguration = MailingConfiguration.fromProto(proto.mailingConfiguration);
    }
    if (proto.segmentedOnboardingConfiguration) {
      m.segmentedOnboardingConfiguration = enumStringToValue(SegmentedOnboardingConfiguration, proto.segmentedOnboardingConfiguration);
    }
    if (proto.taskManagerConfiguration) {
      m.taskManagerConfiguration = TaskManagerConfiguration.fromProto(proto.taskManagerConfiguration);
    }
    if (proto.exitLinkConfiguration) {
      m.exitLinkConfiguration = ExitLinkConfiguration.fromProto(proto.exitLinkConfiguration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.geoRegionForPerformanceMetrics !== 'undefined') {
      toReturn['geoRegionForPerformanceMetrics'] = this.geoRegionForPerformanceMetrics;
    }
    if (typeof this.snapshotConfiguration !== 'undefined' && this.snapshotConfiguration !== null) {
      toReturn['snapshotConfiguration'] = 'toApiJson' in this.snapshotConfiguration ? this.snapshotConfiguration.toApiJson() : this.snapshotConfiguration;
    }
    if (typeof this.enabledFeatures !== 'undefined') {
      toReturn['enabledFeatures'] = this.enabledFeatures;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.subscriptionLevel !== 'undefined') {
      toReturn['subscriptionLevel'] = this.subscriptionLevel;
    }
    if (typeof this.socialProfileGroupId !== 'undefined') {
      toReturn['socialProfileGroupId'] = this.socialProfileGroupId;
    }
    if (typeof this.reputationConfiguration !== 'undefined' && this.reputationConfiguration !== null) {
      toReturn['reputationConfiguration'] = 'toApiJson' in this.reputationConfiguration ? this.reputationConfiguration.toApiJson() : this.reputationConfiguration;
    }
    if (typeof this.salesConfiguration !== 'undefined' && this.salesConfiguration !== null) {
      toReturn['salesConfiguration'] = 'toApiJson' in this.salesConfiguration ? this.salesConfiguration.toApiJson() : this.salesConfiguration;
    }
    if (typeof this.businessCenterConfiguration !== 'undefined' && this.businessCenterConfiguration !== null) {
      toReturn['businessCenterConfiguration'] = 'toApiJson' in this.businessCenterConfiguration ? this.businessCenterConfiguration.toApiJson() : this.businessCenterConfiguration;
    }
    if (typeof this.hasBrandsEnabled !== 'undefined') {
      toReturn['hasBrandsEnabled'] = this.hasBrandsEnabled;
    }
    if (typeof this.hasProductMarketplace !== 'undefined') {
      toReturn['hasProductMarketplace'] = this.hasProductMarketplace;
    }
    if (typeof this.adintelIsEnabled !== 'undefined') {
      toReturn['adintelIsEnabled'] = this.adintelIsEnabled;
    }
    if (typeof this.msAlwaysEnabled !== 'undefined') {
      toReturn['msAlwaysEnabled'] = this.msAlwaysEnabled;
    }
    if (typeof this.subscriptionFailure !== 'undefined') {
      toReturn['subscriptionFailure'] = this.subscriptionFailure;
    }
    if (typeof this.emailConfiguration !== 'undefined' && this.emailConfiguration !== null) {
      toReturn['emailConfiguration'] = 'toApiJson' in this.emailConfiguration ? this.emailConfiguration.toApiJson() : this.emailConfiguration;
    }
    if (typeof this.mailingConfiguration !== 'undefined' && this.mailingConfiguration !== null) {
      toReturn['mailingConfiguration'] = 'toApiJson' in this.mailingConfiguration ? this.mailingConfiguration.toApiJson() : this.mailingConfiguration;
    }
    if (typeof this.subscriptionTierId !== 'undefined') {
      toReturn['subscriptionTierId'] = this.subscriptionTierId;
    }
    if (typeof this.segmentedOnboardingConfiguration !== 'undefined') {
      toReturn['segmentedOnboardingConfiguration'] = this.segmentedOnboardingConfiguration;
    }
    if (typeof this.taskManagerConfiguration !== 'undefined' && this.taskManagerConfiguration !== null) {
      toReturn['taskManagerConfiguration'] = 'toApiJson' in this.taskManagerConfiguration ? this.taskManagerConfiguration.toApiJson() : this.taskManagerConfiguration;
    }
    if (typeof this.msChatWidgetEnabled !== 'undefined') {
      toReturn['msChatWidgetEnabled'] = this.msChatWidgetEnabled;
    }
    if (typeof this.disableBusinessNav !== 'undefined') {
      toReturn['disableBusinessNav'] = this.disableBusinessNav;
    }
    if (typeof this.exitLinkConfiguration !== 'undefined' && this.exitLinkConfiguration !== null) {
      toReturn['exitLinkConfiguration'] = 'toApiJson' in this.exitLinkConfiguration ? this.exitLinkConfiguration.toApiJson() : this.exitLinkConfiguration;
    }
    if (typeof this.disableProductSwitcher !== 'undefined') {
      toReturn['disableProductSwitcher'] = this.disableProductSwitcher;
    }
    return toReturn;
  }
}
class UpdatePartnerModelMutationCountryState {
  static fromProto(proto) {
    let m = new UpdatePartnerModelMutationCountryState();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    if (typeof this.stateCode !== 'undefined') {
      toReturn['stateCode'] = this.stateCode;
    }
    return toReturn;
  }
}
class CreateAnalyticsDashboardRequest {
  static fromProto(proto) {
    let m = new CreateAnalyticsDashboardRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.featureFlagId !== 'undefined') {
      toReturn['featureFlagId'] = this.featureFlagId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class CreateFeatureFlagRequest {
  static fromProto(proto) {
    let m = new CreateFeatureFlagRequest();
    m = Object.assign(m, proto);
    if (proto.accessLevel) {
      m.accessLevel = enumStringToValue(AccessLevel, proto.accessLevel);
    }
    if (proto.whitelist) {
      m.whitelist = proto.whitelist.map(PartnerAccess.fromProto);
    }
    if (proto.blacklist) {
      m.blacklist = proto.blacklist.map(PartnerAccess.fromProto);
    }
    if (proto.experimentSettings) {
      m.experimentSettings = ExperimentSetting.fromProto(proto.experimentSettings);
    }
    if (proto.expiration) {
      m.expiration = enumStringToValue(Expiration, proto.expiration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.accessLevel !== 'undefined') {
      toReturn['accessLevel'] = this.accessLevel;
    }
    if (typeof this.moreInfoUrl !== 'undefined') {
      toReturn['moreInfoUrl'] = this.moreInfoUrl;
    }
    if (typeof this.whitelist !== 'undefined' && this.whitelist !== null) {
      toReturn['whitelist'] = 'toApiJson' in this.whitelist ? this.whitelist.toApiJson() : this.whitelist;
    }
    if (typeof this.blacklist !== 'undefined' && this.blacklist !== null) {
      toReturn['blacklist'] = 'toApiJson' in this.blacklist ? this.blacklist.toApiJson() : this.blacklist;
    }
    if (typeof this.experimentSettings !== 'undefined' && this.experimentSettings !== null) {
      toReturn['experimentSettings'] = 'toApiJson' in this.experimentSettings ? this.experimentSettings.toApiJson() : this.experimentSettings;
    }
    if (typeof this.ownerName !== 'undefined') {
      toReturn['ownerName'] = this.ownerName;
    }
    if (typeof this.expiration !== 'undefined') {
      toReturn['expiration'] = this.expiration;
    }
    return toReturn;
  }
}
class CreatePartnerAccountGroupRequest {
  static fromProto(proto) {
    let m = new CreatePartnerAccountGroupRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class CreatePreviewEmailRequest {
  static fromProto(proto) {
    let m = new CreatePreviewEmailRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class CreateTrialRequest {
  static fromProto(proto) {
    let m = new CreateTrialRequest();
    m = Object.assign(m, proto);
    if (proto.subscriptionLevel) {
      m.subscriptionLevel = enumStringToValue(SubscriptionLevel, proto.subscriptionLevel);
    }
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.subscriptionLevel !== 'undefined') {
      toReturn['subscriptionLevel'] = this.subscriptionLevel;
    }
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    if (typeof this.subscriptionTierId !== 'undefined') {
      toReturn['subscriptionTierId'] = this.subscriptionTierId;
    }
    return toReturn;
  }
}
class DeactivateAddonRequest {
  static fromProto(proto) {
    let m = new DeactivateAddonRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    return toReturn;
  }
}
class DeletePartnerAccountGroupRequest {
  static fromProto(proto) {
    let m = new DeletePartnerAccountGroupRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class EmailConfiguration {
  static fromProto(proto) {
    let m = new EmailConfiguration();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.senderName !== 'undefined') {
      toReturn['senderName'] = this.senderName;
    }
    if (typeof this.senderEmail !== 'undefined') {
      toReturn['senderEmail'] = this.senderEmail;
    }
    if (typeof this.replyEmail !== 'undefined') {
      toReturn['replyEmail'] = this.replyEmail;
    }
    return toReturn;
  }
}
class ExitLinkConfiguration {
  static fromProto(proto) {
    let m = new ExitLinkConfiguration();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.exitLinkText !== 'undefined') {
      toReturn['exitLinkText'] = this.exitLinkText;
    }
    if (typeof this.exitLinkUrl !== 'undefined') {
      toReturn['exitLinkUrl'] = this.exitLinkUrl;
    }
    return toReturn;
  }
}
class GenerateAccountGroupSessionRequest {
  static fromProto(proto) {
    let m = new GenerateAccountGroupSessionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.writeAccess !== 'undefined') {
      toReturn['writeAccess'] = this.writeAccess;
    }
    if (typeof this.deleteAccess !== 'undefined') {
      toReturn['deleteAccess'] = this.deleteAccess;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class GenerateAccountGroupSessionResponse {
  static fromProto(proto) {
    let m = new GenerateAccountGroupSessionResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.idToken !== 'undefined') {
      toReturn['idToken'] = this.idToken;
    }
    return toReturn;
  }
}
class GetAddonActivationRequest {
  static fromProto(proto) {
    let m = new GetAddonActivationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    return toReturn;
  }
}
class GetAddonActivationResponse {
  static fromProto(proto) {
    let m = new GetAddonActivationResponse();
    m = Object.assign(m, proto);
    if (proto.activation) {
      m.activation = AddonActivation.fromProto(proto.activation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activation !== 'undefined' && this.activation !== null) {
      toReturn['activation'] = 'toApiJson' in this.activation ? this.activation.toApiJson() : this.activation;
    }
    return toReturn;
  }
}
class GetBrandingRequest {
  static fromProto(proto) {
    let m = new GetBrandingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class GetBrandingResponse {
  static fromProto(proto) {
    let m = new GetBrandingResponse();
    m = Object.assign(m, proto);
    if (proto.branding) {
      m.branding = Branding.fromProto(proto.branding);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.branding !== 'undefined' && this.branding !== null) {
      toReturn['branding'] = 'toApiJson' in this.branding ? this.branding.toApiJson() : this.branding;
    }
    return toReturn;
  }
}
class GetBrandingV2Request {
  static fromProto(proto) {
    let m = new GetBrandingV2Request();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class GetBrandingV2Response {
  static fromProto(proto) {
    let m = new GetBrandingV2Response();
    m = Object.assign(m, proto);
    if (proto.branding) {
      m.branding = BrandingV2.fromProto(proto.branding);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.branding !== 'undefined' && this.branding !== null) {
      toReturn['branding'] = 'toApiJson' in this.branding ? this.branding.toApiJson() : this.branding;
    }
    return toReturn;
  }
}
class GetConfigurationRequest {
  static fromProto(proto) {
    let m = new GetConfigurationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class GetConfigurationResponse {
  static fromProto(proto) {
    let m = new GetConfigurationResponse();
    m = Object.assign(m, proto);
    if (proto.configuration) {
      m.configuration = Configuration.fromProto(proto.configuration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.configuration !== 'undefined' && this.configuration !== null) {
      toReturn['configuration'] = 'toApiJson' in this.configuration ? this.configuration.toApiJson() : this.configuration;
    }
    return toReturn;
  }
}
class GetMultiBrandingRequest {
  static fromProto(proto) {
    let m = new GetMultiBrandingRequest();
    m = Object.assign(m, proto);
    if (proto.requests) {
      m.requests = proto.requests.map(GetBrandingRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.requests !== 'undefined' && this.requests !== null) {
      toReturn['requests'] = 'toApiJson' in this.requests ? this.requests.toApiJson() : this.requests;
    }
    return toReturn;
  }
}
class GetMultiBrandingResponse {
  static fromProto(proto) {
    let m = new GetMultiBrandingResponse();
    m = Object.assign(m, proto);
    if (proto.brandings) {
      m.brandings = proto.brandings.map(SinglePartnerMarketBranding.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.brandings !== 'undefined' && this.brandings !== null) {
      toReturn['brandings'] = 'toApiJson' in this.brandings ? this.brandings.toApiJson() : this.brandings;
    }
    return toReturn;
  }
}
class GetMultiBrandingV2Request {
  static fromProto(proto) {
    let m = new GetMultiBrandingV2Request();
    m = Object.assign(m, proto);
    if (proto.requests) {
      m.requests = proto.requests.map(GetBrandingV2Request.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.requests !== 'undefined' && this.requests !== null) {
      toReturn['requests'] = 'toApiJson' in this.requests ? this.requests.toApiJson() : this.requests;
    }
    return toReturn;
  }
}
class GetMultiBrandingV2Response {
  static fromProto(proto) {
    let m = new GetMultiBrandingV2Response();
    m = Object.assign(m, proto);
    if (proto.branding) {
      m.branding = proto.branding.map(BrandingV2.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.branding !== 'undefined' && this.branding !== null) {
      toReturn['branding'] = 'toApiJson' in this.branding ? this.branding.toApiJson() : this.branding;
    }
    return toReturn;
  }
}
class GetMultiPartnerHealthRequest {
  static fromProto(proto) {
    let m = new GetMultiPartnerHealthRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerIds !== 'undefined') {
      toReturn['partnerIds'] = this.partnerIds;
    }
    return toReturn;
  }
}
class GetMultiPartnerHealthResponse {
  static fromProto(proto) {
    let m = new GetMultiPartnerHealthResponse();
    m = Object.assign(m, proto);
    if (proto.healths) {
      m.healths = proto.healths.map(PartnerHealth.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.healths !== 'undefined' && this.healths !== null) {
      toReturn['healths'] = 'toApiJson' in this.healths ? this.healths.toApiJson() : this.healths;
    }
    return toReturn;
  }
}
class GetMultiPartnerModelRequest {
  static fromProto(proto) {
    let m = new GetMultiPartnerModelRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerIds !== 'undefined') {
      toReturn['partnerIds'] = this.partnerIds;
    }
    return toReturn;
  }
}
class GetMultiPartnerModelResponse {
  static fromProto(proto) {
    let m = new GetMultiPartnerModelResponse();
    m = Object.assign(m, proto);
    if (proto.partners) {
      m.partners = proto.partners.map(PartnerModel.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partners !== 'undefined' && this.partners !== null) {
      toReturn['partners'] = 'toApiJson' in this.partners ? this.partners.toApiJson() : this.partners;
    }
    return toReturn;
  }
}
class GetPartnerAccountGroupMappingRequest {
  static fromProto(proto) {
    let m = new GetPartnerAccountGroupMappingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.accountGroupPartnerId !== 'undefined') {
      toReturn['accountGroupPartnerId'] = this.accountGroupPartnerId;
    }
    return toReturn;
  }
}
class GetPartnerAccountGroupMappingResponse {
  static fromProto(proto) {
    let m = new GetPartnerAccountGroupMappingResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.accountGroupPartnerId !== 'undefined') {
      toReturn['accountGroupPartnerId'] = this.accountGroupPartnerId;
    }
    return toReturn;
  }
}
class GetPartnerCenterNavigationRequest {
  static fromProto(proto) {
    let m = new GetPartnerCenterNavigationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetPartnerCenterNavigationResponse {
  static fromProto(proto) {
    let m = new GetPartnerCenterNavigationResponse();
    m = Object.assign(m, proto);
    if (proto.navigation) {
      m.navigation = proto.navigation.map(NavigationItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.navigation !== 'undefined' && this.navigation !== null) {
      toReturn['navigation'] = 'toApiJson' in this.navigation ? this.navigation.toApiJson() : this.navigation;
    }
    return toReturn;
  }
}
class GetPartnerHealthRequest {
  static fromProto(proto) {
    let m = new GetPartnerHealthRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetPartnerHealthResponse {
  static fromProto(proto) {
    let m = new GetPartnerHealthResponse();
    m = Object.assign(m, proto);
    if (proto.health) {
      m.health = PartnerHealth.fromProto(proto.health);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.health !== 'undefined' && this.health !== null) {
      toReturn['health'] = 'toApiJson' in this.health ? this.health.toApiJson() : this.health;
    }
    return toReturn;
  }
}
class GetPartnerModelRequest {
  static fromProto(proto) {
    let m = new GetPartnerModelRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetPartnerModelResponse {
  static fromProto(proto) {
    let m = new GetPartnerModelResponse();
    m = Object.assign(m, proto);
    if (proto.partner) {
      m.partner = PartnerModel.fromProto(proto.partner);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partner !== 'undefined' && this.partner !== null) {
      toReturn['partner'] = 'toApiJson' in this.partner ? this.partner.toApiJson() : this.partner;
    }
    return toReturn;
  }
}
class GetSingleSignOnRequest {
  static fromProto(proto) {
    let m = new GetSingleSignOnRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class GetSingleSignOnResponse {
  static fromProto(proto) {
    let m = new GetSingleSignOnResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.token !== 'undefined') {
      toReturn['token'] = this.token;
    }
    if (typeof this.companyId !== 'undefined') {
      toReturn['companyId'] = this.companyId;
    }
    if (typeof this.roadmapDomain !== 'undefined') {
      toReturn['roadmapDomain'] = this.roadmapDomain;
    }
    return toReturn;
  }
}
class GetTrialRequest {
  static fromProto(proto) {
    let m = new GetTrialRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetTrialResponse {
  static fromProto(proto) {
    let m = new GetTrialResponse();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.subscriptionLevel) {
      m.subscriptionLevel = enumStringToValue(SubscriptionLevel, proto.subscriptionLevel);
    }
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    if (proto.cancel) {
      m.cancel = new Date(proto.cancel);
    }
    if (proto.trial) {
      m.trial = Trial.fromProto(proto.trial);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.trialId !== 'undefined') {
      toReturn['trialId'] = this.trialId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.subscriptionLevel !== 'undefined') {
      toReturn['subscriptionLevel'] = this.subscriptionLevel;
    }
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    if (typeof this.cancel !== 'undefined' && this.cancel !== null) {
      toReturn['cancel'] = 'toApiJson' in this.cancel ? this.cancel.toApiJson() : this.cancel;
    }
    if (typeof this.trial !== 'undefined' && this.trial !== null) {
      toReturn['trial'] = 'toApiJson' in this.trial ? this.trial.toApiJson() : this.trial;
    }
    return toReturn;
  }
}
class ListAddonActivationsRequest {
  static fromProto(proto) {
    let m = new ListAddonActivationsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListAddonActivationsResponse {
  static fromProto(proto) {
    let m = new ListAddonActivationsResponse();
    m = Object.assign(m, proto);
    if (proto.activations) {
      m.activations = proto.activations.map(AddonActivation.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activations !== 'undefined' && this.activations !== null) {
      toReturn['activations'] = 'toApiJson' in this.activations ? this.activations.toApiJson() : this.activations;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListBrandingV2Request {
  static fromProto(proto) {
    let m = new ListBrandingV2Request();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListBrandingV2Response {
  static fromProto(proto) {
    let m = new ListBrandingV2Response();
    m = Object.assign(m, proto);
    if (proto.brandings) {
      m.brandings = proto.brandings.map(BrandingV2.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.brandings !== 'undefined' && this.brandings !== null) {
      toReturn['brandings'] = 'toApiJson' in this.brandings ? this.brandings.toApiJson() : this.brandings;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListFeatureFlagFilters {
  static fromProto(proto) {
    let m = new ListFeatureFlagFilters();
    m = Object.assign(m, proto);
    if (proto.accessLevel) {
      m.accessLevel = proto.accessLevel.map(v => enumStringToValue(AccessLevel, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.accessLevel !== 'undefined') {
      toReturn['accessLevel'] = this.accessLevel;
    }
    return toReturn;
  }
}
class ListFeatureFlagRequest {
  static fromProto(proto) {
    let m = new ListFeatureFlagRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.filters) {
      m.filters = ListFeatureFlagFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.archivedOnly !== 'undefined') {
      toReturn['archivedOnly'] = this.archivedOnly;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListFeatureFlagResponse {
  static fromProto(proto) {
    let m = new ListFeatureFlagResponse();
    m = Object.assign(m, proto);
    if (proto.flags) {
      m.flags = proto.flags.map(FeatureFlag.fromProto);
    }
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.flags !== 'undefined' && this.flags !== null) {
      toReturn['flags'] = 'toApiJson' in this.flags ? this.flags.toApiJson() : this.flags;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class ListMarketsForUserRequest {
  static fromProto(proto) {
    let m = new ListMarketsForUserRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ListMarketsForUserResponse {
  static fromProto(proto) {
    let m = new ListMarketsForUserResponse();
    m = Object.assign(m, proto);
    if (proto.markets) {
      m.markets = proto.markets.map(Market.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.markets !== 'undefined' && this.markets !== null) {
      toReturn['markets'] = 'toApiJson' in this.markets ? this.markets.toApiJson() : this.markets;
    }
    return toReturn;
  }
}
class ListPartnerAddonsRequest {
  static fromProto(proto) {
    let m = new ListPartnerAddonsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class ListPartnerAddonsResponse {
  static fromProto(proto) {
    let m = new ListPartnerAddonsResponse();
    m = Object.assign(m, proto);
    if (proto.addons) {
      m.addons = proto.addons.map(PartnerAddon.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addons !== 'undefined' && this.addons !== null) {
      toReturn['addons'] = 'toApiJson' in this.addons ? this.addons.toApiJson() : this.addons;
    }
    return toReturn;
  }
}
class ListPartnerHealthRequest {
  static fromProto(proto) {
    let m = new ListPartnerHealthRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    return toReturn;
  }
}
class ListPartnerHealthResponse {
  static fromProto(proto) {
    let m = new ListPartnerHealthResponse();
    m = Object.assign(m, proto);
    if (proto.healths) {
      m.healths = proto.healths.map(PartnerHealth.fromProto);
    }
    if (proto.hits) {
      m.hits = parseInt(proto.hits, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.healths !== 'undefined' && this.healths !== null) {
      toReturn['healths'] = 'toApiJson' in this.healths ? this.healths.toApiJson() : this.healths;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.hits !== 'undefined') {
      toReturn['hits'] = this.hits;
    }
    return toReturn;
  }
}
class ListTrialRequest {
  static fromProto(proto) {
    let m = new ListTrialRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    return toReturn;
  }
}
class ListTrialResponse {
  static fromProto(proto) {
    let m = new ListTrialResponse();
    m = Object.assign(m, proto);
    if (proto.trials) {
      m.trials = proto.trials.map(Trial.fromProto);
    }
    if (proto.hits) {
      m.hits = parseInt(proto.hits, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.trials !== 'undefined' && this.trials !== null) {
      toReturn['trials'] = 'toApiJson' in this.trials ? this.trials.toApiJson() : this.trials;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.hits !== 'undefined') {
      toReturn['hits'] = this.hits;
    }
    return toReturn;
  }
}
class MailingConfiguration {
  static fromProto(proto) {
    let m = new MailingConfiguration();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.mailingCompanyName !== 'undefined') {
      toReturn['mailingCompanyName'] = this.mailingCompanyName;
    }
    if (typeof this.mailingAddress !== 'undefined') {
      toReturn['mailingAddress'] = this.mailingAddress;
    }
    if (typeof this.mailingAddress2 !== 'undefined') {
      toReturn['mailingAddress2'] = this.mailingAddress2;
    }
    if (typeof this.mailingCity !== 'undefined') {
      toReturn['mailingCity'] = this.mailingCity;
    }
    if (typeof this.mailingState !== 'undefined') {
      toReturn['mailingState'] = this.mailingState;
    }
    if (typeof this.mailingCountry !== 'undefined') {
      toReturn['mailingCountry'] = this.mailingCountry;
    }
    if (typeof this.mailingPostalCode !== 'undefined') {
      toReturn['mailingPostalCode'] = this.mailingPostalCode;
    }
    if (typeof this.mailingPhoneNumber !== 'undefined') {
      toReturn['mailingPhoneNumber'] = this.mailingPhoneNumber;
    }
    if (typeof this.mailingWebsiteAddress !== 'undefined') {
      toReturn['mailingWebsiteAddress'] = this.mailingWebsiteAddress;
    }
    if (typeof this.mailingEmailAddress !== 'undefined') {
      toReturn['mailingEmailAddress'] = this.mailingEmailAddress;
    }
    return toReturn;
  }
}
class UpsertMutationMarketOverridesMutation {
  static fromProto(proto) {
    let m = new UpsertMutationMarketOverridesMutation();
    m = Object.assign(m, proto);
    if (proto.fields) {
      m.fields = proto.fields.map(v => enumStringToValue(Field, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fields !== 'undefined') {
      toReturn['fields'] = this.fields;
    }
    return toReturn;
  }
}
class UpdateFeatureFlagRequestMutation {
  static fromProto(proto) {
    let m = new UpdateFeatureFlagRequestMutation();
    m = Object.assign(m, proto);
    if (proto.accessLevel) {
      m.accessLevel = enumStringToValue(AccessLevel, proto.accessLevel);
    }
    if (proto.whitelist) {
      m.whitelist = UpdateFeatureFlagRequestMutationPartnerAccessMutation.fromProto(proto.whitelist);
    }
    if (proto.blacklist) {
      m.blacklist = UpdateFeatureFlagRequestMutationPartnerAccessMutation.fromProto(proto.blacklist);
    }
    if (proto.experimentSettings) {
      m.experimentSettings = ExperimentSetting.fromProto(proto.experimentSettings);
    }
    if (proto.expiration) {
      m.expiration = enumStringToValue(Expiration, proto.expiration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.accessLevel !== 'undefined') {
      toReturn['accessLevel'] = this.accessLevel;
    }
    if (typeof this.moreInfoUrl !== 'undefined') {
      toReturn['moreInfoUrl'] = this.moreInfoUrl;
    }
    if (typeof this.archived !== 'undefined') {
      toReturn['archived'] = this.archived;
    }
    if (typeof this.whitelist !== 'undefined' && this.whitelist !== null) {
      toReturn['whitelist'] = 'toApiJson' in this.whitelist ? this.whitelist.toApiJson() : this.whitelist;
    }
    if (typeof this.blacklist !== 'undefined' && this.blacklist !== null) {
      toReturn['blacklist'] = 'toApiJson' in this.blacklist ? this.blacklist.toApiJson() : this.blacklist;
    }
    if (typeof this.experimentSettings !== 'undefined' && this.experimentSettings !== null) {
      toReturn['experimentSettings'] = 'toApiJson' in this.experimentSettings ? this.experimentSettings.toApiJson() : this.experimentSettings;
    }
    if (typeof this.ownerName !== 'undefined') {
      toReturn['ownerName'] = this.ownerName;
    }
    if (typeof this.expiration !== 'undefined') {
      toReturn['expiration'] = this.expiration;
    }
    if (typeof this.restartExpiry !== 'undefined') {
      toReturn['restartExpiry'] = this.restartExpiry;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class UpdateFeatureFlagRequestMutationPartnerAccessMutation {
  static fromProto(proto) {
    let m = new UpdateFeatureFlagRequestMutationPartnerAccessMutation();
    m = Object.assign(m, proto);
    if (proto.accessList) {
      m.accessList = proto.accessList.map(PartnerAccess.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accessList !== 'undefined' && this.accessList !== null) {
      toReturn['accessList'] = 'toApiJson' in this.accessList ? this.accessList.toApiJson() : this.accessList;
    }
    return toReturn;
  }
}
class PartnerCanDoActionRequest {
  static fromProto(proto) {
    let m = new PartnerCanDoActionRequest();
    m = Object.assign(m, proto);
    if (proto.actionId) {
      m.actionId = enumStringToValue(Action, proto.actionId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.actionId !== 'undefined') {
      toReturn['actionId'] = this.actionId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class PartnerCanDoActionResponse {
  static fromProto(proto) {
    let m = new PartnerCanDoActionResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.result !== 'undefined') {
      toReturn['result'] = this.result;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    return toReturn;
  }
}
class ReputationConfiguration {
  static fromProto(proto) {
    let m = new ReputationConfiguration();
    m = Object.assign(m, proto);
    if (proto.maxCompetitors) {
      m.maxCompetitors = parseInt(proto.maxCompetitors, 10);
    }
    if (proto.maxServices) {
      m.maxServices = parseInt(proto.maxServices, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.maxCompetitors !== 'undefined') {
      toReturn['maxCompetitors'] = this.maxCompetitors;
    }
    if (typeof this.maxServices !== 'undefined') {
      toReturn['maxServices'] = this.maxServices;
    }
    if (typeof this.addressMatchStrictness !== 'undefined') {
      toReturn['addressMatchStrictness'] = this.addressMatchStrictness;
    }
    if (typeof this.companyNameMatchStrictness !== 'undefined') {
      toReturn['companyNameMatchStrictness'] = this.companyNameMatchStrictness;
    }
    if (typeof this.websiteMatchStrictness !== 'undefined') {
      toReturn['websiteMatchStrictness'] = this.websiteMatchStrictness;
    }
    return toReturn;
  }
}
class ResendPartnerAdminWelcomeEmailRequest {
  static fromProto(proto) {
    let m = new ResendPartnerAdminWelcomeEmailRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.usePlatformDefaultDomain !== 'undefined') {
      toReturn['usePlatformDefaultDomain'] = this.usePlatformDefaultDomain;
    }
    return toReturn;
  }
}
class ResetPartnerRequest {
  static fromProto(proto) {
    let m = new ResetPartnerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class SearchPartnerModelsFilters {
  static fromProto(proto) {
    let m = new SearchPartnerModelsFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.subscriptionTierId !== 'undefined') {
      toReturn['subscriptionTierId'] = this.subscriptionTierId;
    }
    return toReturn;
  }
}
class SearchPartnerModelsRequest {
  static fromProto(proto) {
    let m = new SearchPartnerModelsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    if (proto.filters) {
      m.filters = SearchPartnerModelsFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class SearchPartnerModelsResponse {
  static fromProto(proto) {
    let m = new SearchPartnerModelsResponse();
    m = Object.assign(m, proto);
    if (proto.partners) {
      m.partners = proto.partners.map(PartnerModel.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partners !== 'undefined' && this.partners !== null) {
      toReturn['partners'] = 'toApiJson' in this.partners ? this.partners.toApiJson() : this.partners;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class SetPartnerHealthRequest {
  static fromProto(proto) {
    let m = new SetPartnerHealthRequest();
    m = Object.assign(m, proto);
    if (proto.state) {
      m.state = enumStringToValue(PartnerHealthState, proto.state);
    }
    if (proto.subState) {
      m.subState = enumStringToValue(PartnerHealthSubState, proto.subState);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.subState !== 'undefined') {
      toReturn['subState'] = this.subState;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    if (typeof this.inRetention !== 'undefined') {
      toReturn['inRetention'] = this.inRetention;
    }
    return toReturn;
  }
}
class SinglePartnerMarketBranding {
  static fromProto(proto) {
    let m = new SinglePartnerMarketBranding();
    m = Object.assign(m, proto);
    if (proto.branding) {
      m.branding = Branding.fromProto(proto.branding);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.branding !== 'undefined' && this.branding !== null) {
      toReturn['branding'] = 'toApiJson' in this.branding ? this.branding.toApiJson() : this.branding;
    }
    return toReturn;
  }
}
class SnapshotConfiguration {
  static fromProto(proto) {
    let m = new SnapshotConfiguration();
    m = Object.assign(m, proto);
    if (proto.seoAdvertisingDataProvider) {
      m.seoAdvertisingDataProvider = parseInt(proto.seoAdvertisingDataProvider, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ppc !== 'undefined') {
      toReturn['ppc'] = this.ppc;
    }
    if (typeof this.remarketing !== 'undefined') {
      toReturn['remarketing'] = this.remarketing;
    }
    if (typeof this.useCustomSnapshotHeader !== 'undefined') {
      toReturn['useCustomSnapshotHeader'] = this.useCustomSnapshotHeader;
    }
    if (typeof this.customSnapshotHeader !== 'undefined') {
      toReturn['customSnapshotHeader'] = this.customSnapshotHeader;
    }
    if (typeof this.useCustomSnapshotFooter !== 'undefined') {
      toReturn['useCustomSnapshotFooter'] = this.useCustomSnapshotFooter;
    }
    if (typeof this.customSnapshotFooter !== 'undefined') {
      toReturn['customSnapshotFooter'] = this.customSnapshotFooter;
    }
    if (typeof this.useCustomSnapshotPopupMessage !== 'undefined') {
      toReturn['useCustomSnapshotPopupMessage'] = this.useCustomSnapshotPopupMessage;
    }
    if (typeof this.customSnapshotPopupMessage !== 'undefined') {
      toReturn['customSnapshotPopupMessage'] = this.customSnapshotPopupMessage;
    }
    if (typeof this.allowClaimUser !== 'undefined') {
      toReturn['allowClaimUser'] = this.allowClaimUser;
    }
    if (typeof this.seoAdvertisingDataProvider !== 'undefined') {
      toReturn['seoAdvertisingDataProvider'] = this.seoAdvertisingDataProvider;
    }
    if (typeof this.snapshotReportName !== 'undefined') {
      toReturn['snapshotReportName'] = this.snapshotReportName;
    }
    return toReturn;
  }
}
class SwapPartnerAccountGroupRequest {
  static fromProto(proto) {
    let m = new SwapPartnerAccountGroupRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.withPartnerId !== 'undefined') {
      toReturn['withPartnerId'] = this.withPartnerId;
    }
    if (typeof this.withAccountGroupId !== 'undefined') {
      toReturn['withAccountGroupId'] = this.withAccountGroupId;
    }
    return toReturn;
  }
}
class Theme {
  static fromProto(proto) {
    let m = new Theme();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.primaryColor !== 'undefined') {
      toReturn['primaryColor'] = this.primaryColor;
    }
    if (typeof this.primaryHoverColor !== 'undefined') {
      toReturn['primaryHoverColor'] = this.primaryHoverColor;
    }
    if (typeof this.primaryActiveColor !== 'undefined') {
      toReturn['primaryActiveColor'] = this.primaryActiveColor;
    }
    if (typeof this.secondaryColor !== 'undefined') {
      toReturn['secondaryColor'] = this.secondaryColor;
    }
    if (typeof this.secondaryHoverColor !== 'undefined') {
      toReturn['secondaryHoverColor'] = this.secondaryHoverColor;
    }
    if (typeof this.secondaryActiveColor !== 'undefined') {
      toReturn['secondaryActiveColor'] = this.secondaryActiveColor;
    }
    if (typeof this.focusColor !== 'undefined') {
      toReturn['focusColor'] = this.focusColor;
    }
    if (typeof this.fontColor !== 'undefined') {
      toReturn['fontColor'] = this.fontColor;
    }
    if (typeof this.fontDisabledColor !== 'undefined') {
      toReturn['fontDisabledColor'] = this.fontDisabledColor;
    }
    if (typeof this.accentsColor !== 'undefined') {
      toReturn['accentsColor'] = this.accentsColor;
    }
    if (typeof this.accentsActiveColor !== 'undefined') {
      toReturn['accentsActiveColor'] = this.accentsActiveColor;
    }
    if (typeof this.borderColor !== 'undefined') {
      toReturn['borderColor'] = this.borderColor;
    }
    return toReturn;
  }
}
class TriggerEventRequest {
  static fromProto(proto) {
    let m = new TriggerEventRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.eventData !== 'undefined') {
      toReturn['eventData'] = this.eventData;
    }
    if (typeof this.eventType !== 'undefined') {
      toReturn['eventType'] = this.eventType;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class URL {
  static fromProto(proto) {
    let m = new URL();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.secure !== 'undefined') {
      toReturn['secure'] = this.secure;
    }
    if (typeof this.insecure !== 'undefined') {
      toReturn['insecure'] = this.insecure;
    }
    return toReturn;
  }
}
class UpdateFeatureFlagRequest {
  static fromProto(proto) {
    let m = new UpdateFeatureFlagRequest();
    m = Object.assign(m, proto);
    if (proto.mutations) {
      m.mutations = proto.mutations.map(UpdateFeatureFlagRequestMutation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.mutations !== 'undefined' && this.mutations !== null) {
      toReturn['mutations'] = 'toApiJson' in this.mutations ? this.mutations.toApiJson() : this.mutations;
    }
    return toReturn;
  }
}
class UpdatePartnerAccountGroupRequest {
  static fromProto(proto) {
    let m = new UpdatePartnerAccountGroupRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class UpdatePartnerAdminRequest {
  static fromProto(proto) {
    let m = new UpdatePartnerAdminRequest();
    m = Object.assign(m, proto);
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    if (proto.permissions) {
      m.permissions = PartnerAdminPermissions.fromProto(proto.permissions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.permissions !== 'undefined' && this.permissions !== null) {
      toReturn['permissions'] = 'toApiJson' in this.permissions ? this.permissions.toApiJson() : this.permissions;
    }
    return toReturn;
  }
}
class UpdatePartnerModelMutation {
  static fromProto(proto) {
    let m = new UpdatePartnerModelMutation();
    m = Object.assign(m, proto);
    if (proto.countryAndState) {
      m.countryAndState = UpdatePartnerModelMutationCountryState.fromProto(proto.countryAndState);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.premiumSupport !== 'undefined') {
      toReturn['premiumSupport'] = this.premiumSupport;
    }
    if (typeof this.standardPrioritySupport !== 'undefined') {
      toReturn['standardPrioritySupport'] = this.standardPrioritySupport;
    }
    if (typeof this.priorityChatSupport !== 'undefined') {
      toReturn['priorityChatSupport'] = this.priorityChatSupport;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.addressLineOne !== 'undefined') {
      toReturn['addressLineOne'] = this.addressLineOne;
    }
    if (typeof this.addressLineTwo !== 'undefined') {
      toReturn['addressLineTwo'] = this.addressLineTwo;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.countryAndState !== 'undefined' && this.countryAndState !== null) {
      toReturn['countryAndState'] = 'toApiJson' in this.countryAndState ? this.countryAndState.toApiJson() : this.countryAndState;
    }
    if (typeof this.postalCode !== 'undefined') {
      toReturn['postalCode'] = this.postalCode;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    return toReturn;
  }
}
class UpdatePartnerModelRequest {
  static fromProto(proto) {
    let m = new UpdatePartnerModelRequest();
    m = Object.assign(m, proto);
    if (proto.mutations) {
      m.mutations = proto.mutations.map(UpdatePartnerModelMutation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.mutations !== 'undefined' && this.mutations !== null) {
      toReturn['mutations'] = 'toApiJson' in this.mutations ? this.mutations.toApiJson() : this.mutations;
    }
    return toReturn;
  }
}
class UpsertBrandingV2Request {
  static fromProto(proto) {
    let m = new UpsertBrandingV2Request();
    m = Object.assign(m, proto);
    if (proto.mutations) {
      m.mutations = proto.mutations.map(UpsertMutation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.mutations !== 'undefined' && this.mutations !== null) {
      toReturn['mutations'] = 'toApiJson' in this.mutations ? this.mutations.toApiJson() : this.mutations;
    }
    return toReturn;
  }
}
class UpsertMutation {
  static fromProto(proto) {
    let m = new UpsertMutation();
    m = Object.assign(m, proto);
    if (proto.uiTheme) {
      m.uiTheme = enumStringToValue(UITheme, proto.uiTheme);
    }
    if (proto.marketOverrides) {
      m.marketOverrides = UpsertMutationMarketOverridesMutation.fromProto(proto.marketOverrides);
    }
    if (proto.businessAppUiTheme) {
      m.businessAppUiTheme = enumStringToValue(UITheme, proto.businessAppUiTheme);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.faviconUrl !== 'undefined') {
      toReturn['faviconUrl'] = this.faviconUrl;
    }
    if (typeof this.shortcutIconUrl !== 'undefined') {
      toReturn['shortcutIconUrl'] = this.shortcutIconUrl;
    }
    if (typeof this.logoUrl !== 'undefined') {
      toReturn['logoUrl'] = this.logoUrl;
    }
    if (typeof this.uiTheme !== 'undefined') {
      toReturn['uiTheme'] = this.uiTheme;
    }
    if (typeof this.primaryColor !== 'undefined') {
      toReturn['primaryColor'] = this.primaryColor;
    }
    if (typeof this.marketOverrides !== 'undefined' && this.marketOverrides !== null) {
      toReturn['marketOverrides'] = 'toApiJson' in this.marketOverrides ? this.marketOverrides.toApiJson() : this.marketOverrides;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.darkModeLogoUrl !== 'undefined') {
      toReturn['darkModeLogoUrl'] = this.darkModeLogoUrl;
    }
    if (typeof this.businessAppUiTheme !== 'undefined') {
      toReturn['businessAppUiTheme'] = this.businessAppUiTheme;
    }
    return toReturn;
  }
}

// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'partner.vendasta-local.com',
  'test': '',
  'demo': 'partner-api-demo.apigateway.co',
  'prod': 'partner-api-prod.apigateway.co',
  'production': 'partner-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let AcquisitionDataApiService = /*#__PURE__*/(() => {
  class AcquisitionDataApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getAcquisitionData(r) {
      const request = r.toApiJson ? r : new GetAcquisitionDataRequest(r);
      return this.http.post(this._host + "/partner.v1.AcquisitionDataService/GetAcquisitionData", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAcquisitionDataResponse.fromProto(resp)));
    }
  }
  AcquisitionDataApiService.ɵfac = function AcquisitionDataApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AcquisitionDataApiService)();
  };
  AcquisitionDataApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AcquisitionDataApiService,
    factory: AcquisitionDataApiService.ɵfac,
    providedIn: 'root'
  });
  return AcquisitionDataApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let AddonApiService = /*#__PURE__*/(() => {
  class AddonApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    activate(r) {
      const request = r.toApiJson ? r : new ActivateAddonRequest(r);
      return this.http.post(this._host + "/partner.v1.Addon/Activate", request.toApiJson(), this.apiOptions()).pipe(map(resp => ActivateAddonResponse.fromProto(resp)));
    }
    deactivate(r) {
      const request = r.toApiJson ? r : new DeactivateAddonRequest(r);
      return this.http.post(this._host + "/partner.v1.Addon/Deactivate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listActivations(r) {
      const request = r.toApiJson ? r : new ListAddonActivationsRequest(r);
      return this.http.post(this._host + "/partner.v1.Addon/ListActivations", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAddonActivationsResponse.fromProto(resp)));
    }
    getActivation(r) {
      const request = r.toApiJson ? r : new GetAddonActivationRequest(r);
      return this.http.post(this._host + "/partner.v1.Addon/GetActivation", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAddonActivationResponse.fromProto(resp)));
    }
    listPartnerAddons(r) {
      const request = r.toApiJson ? r : new ListPartnerAddonsRequest(r);
      return this.http.post(this._host + "/partner.v1.Addon/ListPartnerAddons", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPartnerAddonsResponse.fromProto(resp)));
    }
  }
  AddonApiService.ɵfac = function AddonApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AddonApiService)();
  };
  AddonApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AddonApiService,
    factory: AddonApiService.ɵfac,
    providedIn: 'root'
  });
  return AddonApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let BrandingV2ApiService = /*#__PURE__*/(() => {
  class BrandingV2ApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getBranding(r) {
      const request = r.toApiJson ? r : new GetBrandingV2Request(r);
      return this.http.post(this._host + "/partner.v1.BrandingV2Service/GetBranding", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetBrandingV2Response.fromProto(resp)));
    }
    getMultiBranding(r) {
      const request = r.toApiJson ? r : new GetMultiBrandingV2Request(r);
      return this.http.post(this._host + "/partner.v1.BrandingV2Service/GetMultiBranding", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiBrandingV2Response.fromProto(resp)));
    }
    listBranding(r) {
      const request = r.toApiJson ? r : new ListBrandingV2Request(r);
      return this.http.post(this._host + "/partner.v1.BrandingV2Service/ListBranding", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListBrandingV2Response.fromProto(resp)));
    }
    upsertBranding(r) {
      const request = r.toApiJson ? r : new UpsertBrandingV2Request(r);
      return this.http.post(this._host + "/partner.v1.BrandingV2Service/UpsertBranding", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  BrandingV2ApiService.ɵfac = function BrandingV2ApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BrandingV2ApiService)();
  };
  BrandingV2ApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BrandingV2ApiService,
    factory: BrandingV2ApiService.ɵfac,
    providedIn: 'root'
  });
  return BrandingV2ApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let BusinessCenterApiService = /*#__PURE__*/(() => {
  class BusinessCenterApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    setConfiguration(r) {
      const request = r.toApiJson ? r : new SetBusinessCenterConfigRequest(r);
      return this.http.post(this._host + "/partner.v1.BusinessCenter/SetConfiguration", request.toApiJson(), this.apiOptions()).pipe(map(resp => SetBusinessCenterConfigResponse.fromProto(resp)));
    }
    getMarketConfiguration(r) {
      const request = r.toApiJson ? r : new GetBusinessCenterMarketConfigurationRequest(r);
      return this.http.post(this._host + "/partner.v1.BusinessCenter/GetMarketConfiguration", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetBusinessCenterMarketConfigurationResponse.fromProto(resp)));
    }
    updateMarketConfiguration(r) {
      const request = r.toApiJson ? r : new UpdateBusinessCenterMarketConfigurationRequest(r);
      return this.http.post(this._host + "/partner.v1.BusinessCenter/UpdateMarketConfiguration", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateBusinessCenterMarketConfigurationResponse.fromProto(resp)));
    }
  }
  BusinessCenterApiService.ɵfac = function BusinessCenterApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BusinessCenterApiService)();
  };
  BusinessCenterApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BusinessCenterApiService,
    factory: BusinessCenterApiService.ɵfac,
    providedIn: 'root'
  });
  return BusinessCenterApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CannyApiService = /*#__PURE__*/(() => {
  class CannyApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getSingleSignOn(r) {
      const request = r.toApiJson ? r : new GetSingleSignOnRequest(r);
      return this.http.post(this._host + "/partner.v1.CannyService/GetSingleSignOn", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSingleSignOnResponse.fromProto(resp)));
    }
  }
  CannyApiService.ɵfac = function CannyApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CannyApiService)();
  };
  CannyApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CannyApiService,
    factory: CannyApiService.ɵfac,
    providedIn: 'root'
  });
  return CannyApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CustomerSurveyApiService = /*#__PURE__*/(() => {
  class CustomerSurveyApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    respond(r) {
      const request = r.toApiJson ? r : new CustomerSurveyRespondRequest(r);
      return this.http.post(this._host + "/partner.v1.CustomerSurveyService/Respond", request.toApiJson(), this.apiOptions()).pipe(map(resp => CustomerSurveyRespondResponse.fromProto(resp)));
    }
    addFeedback(r) {
      const request = r.toApiJson ? r : new CustomerSurveyAddFeedbackRequest(r);
      return this.http.post(this._host + "/partner.v1.CustomerSurveyService/AddFeedback", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listResponses(r) {
      const request = r.toApiJson ? r : new CustomerSurveyListResponsesRequest(r);
      return this.http.post(this._host + "/partner.v1.CustomerSurveyService/ListResponses", request.toApiJson(), this.apiOptions()).pipe(map(resp => CustomerSurveyListResponsesResponse.fromProto(resp)));
    }
  }
  CustomerSurveyApiService.ɵfac = function CustomerSurveyApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CustomerSurveyApiService)();
  };
  CustomerSurveyApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CustomerSurveyApiService,
    factory: CustomerSurveyApiService.ɵfac,
    providedIn: 'root'
  });
  return CustomerSurveyApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let FeatureFlagsApiService = /*#__PURE__*/(() => {
  class FeatureFlagsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateFeatureFlagRequest(r);
      return this.http.post(this._host + "/partner.v1.FeatureFlags/Create", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateFeatureFlagRequest(r);
      return this.http.post(this._host + "/partner.v1.FeatureFlags/Update", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    batchGetStatus(r) {
      const request = r.toApiJson ? r : new BatchGetStatusFeatureFlagRequest(r);
      return this.http.post(this._host + "/partner.v1.FeatureFlags/BatchGetStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => BatchGetStatusFeatureFlagResponse.fromProto(resp)));
    }
    batchGet(r) {
      const request = r.toApiJson ? r : new BatchGetFeatureFlagRequest(r);
      return this.http.post(this._host + "/partner.v1.FeatureFlags/BatchGet", request.toApiJson(), this.apiOptions()).pipe(map(resp => BatchGetFeatureFlagResponse.fromProto(resp)));
    }
    list(r) {
      const request = r.toApiJson ? r : new ListFeatureFlagRequest(r);
      return this.http.post(this._host + "/partner.v1.FeatureFlags/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListFeatureFlagResponse.fromProto(resp)));
    }
    createAnalyticsDashboard(r) {
      const request = r.toApiJson ? r : new CreateAnalyticsDashboardRequest(r);
      return this.http.post(this._host + "/partner.v1.FeatureFlags/CreateAnalyticsDashboard", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    addPartnerToWhitelist(r) {
      const request = r.toApiJson ? r : new AddPartnerToWhitelistRequest(r);
      return this.http.post(this._host + "/partner.v1.FeatureFlags/AddPartnerToWhitelist", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  FeatureFlagsApiService.ɵfac = function FeatureFlagsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FeatureFlagsApiService)();
  };
  FeatureFlagsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: FeatureFlagsApiService,
    factory: FeatureFlagsApiService.ɵfac,
    providedIn: 'root'
  });
  return FeatureFlagsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let FreeTrialApiService = /*#__PURE__*/(() => {
  class FreeTrialApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getFreeTrialStatus(r) {
      const request = r.toApiJson ? r : new GetFreeTrialStatusRequest(r);
      return this.http.post(this._host + "/partner.v1.FreeTrialService/GetFreeTrialStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetFreeTrialStatusResponse.fromProto(resp)));
    }
    getFreeTrial(r) {
      const request = r.toApiJson ? r : new GetFreeTrialRequest(r);
      return this.http.post(this._host + "/partner.v1.FreeTrialService/GetFreeTrial", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetFreeTrialResponse.fromProto(resp)));
    }
    updateFreeTrial(r) {
      const request = r.toApiJson ? r : new UpdateFreeTrialRequest(r);
      return this.http.post(this._host + "/partner.v1.FreeTrialService/UpdateFreeTrial", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  FreeTrialApiService.ɵfac = function FreeTrialApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FreeTrialApiService)();
  };
  FreeTrialApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: FreeTrialApiService,
    factory: FreeTrialApiService.ɵfac,
    providedIn: 'root'
  });
  return FreeTrialApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let GrowthEventApiService = /*#__PURE__*/(() => {
  class GrowthEventApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    triggerEvent(r) {
      const request = r.toApiJson ? r : new TriggerEventRequest(r);
      return this.http.post(this._host + "/partner.v1.GrowthEventService/TriggerEvent", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  GrowthEventApiService.ɵfac = function GrowthEventApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || GrowthEventApiService)();
  };
  GrowthEventApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: GrowthEventApiService,
    factory: GrowthEventApiService.ɵfac,
    providedIn: 'root'
  });
  return GrowthEventApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let IAMApiService = /*#__PURE__*/(() => {
  class IAMApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    generateAccountGroupSession(r) {
      const request = r.toApiJson ? r : new GenerateAccountGroupSessionRequest(r);
      return this.http.post(this._host + "/partner.v1.IAM/GenerateAccountGroupSession", request.toApiJson(), this.apiOptions()).pipe(map(resp => GenerateAccountGroupSessionResponse.fromProto(resp)));
    }
    resendPartnerAdminWelcomeEmail(r) {
      const request = r.toApiJson ? r : new ResendPartnerAdminWelcomeEmailRequest(r);
      return this.http.post(this._host + "/partner.v1.IAM/ResendPartnerAdminWelcomeEmail", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updatePartnerAdmin(r) {
      const request = r.toApiJson ? r : new UpdatePartnerAdminRequest(r);
      return this.http.post(this._host + "/partner.v1.IAM/UpdatePartnerAdmin", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  IAMApiService.ɵfac = function IAMApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IAMApiService)();
  };
  IAMApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: IAMApiService,
    factory: IAMApiService.ɵfac,
    providedIn: 'root'
  });
  return IAMApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let PartnerApiService = /*#__PURE__*/(() => {
  class PartnerApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    reset(r) {
      const request = r.toApiJson ? r : new ResetPartnerRequest(r);
      return this.http.post(this._host + "/partner.v1.Partner/Reset", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateSubscriptionTier(r) {
      const request = r.toApiJson ? r : new UpdateSubscriptionTierRequest(r);
      return this.http.post(this._host + "/partner.v1.Partner/UpdateSubscriptionTier", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getUpdateSubscriptionTierStatus(r) {
      const request = r.toApiJson ? r : new GetUpdateSubscriptionTierStatusRequest(r);
      return this.http.post(this._host + "/partner.v1.Partner/GetUpdateSubscriptionTierStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetUpdateSubscriptionTierStatusResponse.fromProto(resp)));
    }
    canDoAction(r) {
      const request = r.toApiJson ? r : new PartnerCanDoActionRequest(r);
      return this.http.post(this._host + "/partner.v1.Partner/CanDoAction", request.toApiJson(), this.apiOptions()).pipe(map(resp => PartnerCanDoActionResponse.fromProto(resp)));
    }
    deletePartnerAccountGroup(r) {
      const request = r.toApiJson ? r : new DeletePartnerAccountGroupRequest(r);
      return this.http.post(this._host + "/partner.v1.Partner/DeletePartnerAccountGroup", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getPartnerAccountGroupMapping(r) {
      const request = r.toApiJson ? r : new GetPartnerAccountGroupMappingRequest(r);
      return this.http.post(this._host + "/partner.v1.Partner/GetPartnerAccountGroupMapping", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPartnerAccountGroupMappingResponse.fromProto(resp)));
    }
    createPartnerAccountGroup(r) {
      const request = r.toApiJson ? r : new CreatePartnerAccountGroupRequest(r);
      return this.http.post(this._host + "/partner.v1.Partner/CreatePartnerAccountGroup", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updatePartnerAccountGroup(r) {
      const request = r.toApiJson ? r : new UpdatePartnerAccountGroupRequest(r);
      return this.http.post(this._host + "/partner.v1.Partner/UpdatePartnerAccountGroup", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    swapPartnerAccountGroup(r) {
      const request = r.toApiJson ? r : new SwapPartnerAccountGroupRequest(r);
      return this.http.post(this._host + "/partner.v1.Partner/SwapPartnerAccountGroup", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    initiateSubscriptionTierUpdate(r) {
      const request = r.toApiJson ? r : new InitiateSubscriptionTierUpdateRequest(r);
      return this.http.post(this._host + "/partner.v1.Partner/InitiateSubscriptionTierUpdate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  PartnerApiService.ɵfac = function PartnerApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PartnerApiService)();
  };
  PartnerApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PartnerApiService,
    factory: PartnerApiService.ɵfac,
    providedIn: 'root'
  });
  return PartnerApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let PartnerHealthsApiService = /*#__PURE__*/(() => {
  class PartnerHealthsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    set(r) {
      const request = r.toApiJson ? r : new SetPartnerHealthRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerHealths/Set", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    get(r) {
      const request = r.toApiJson ? r : new GetPartnerHealthRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerHealths/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPartnerHealthResponse.fromProto(resp)));
    }
    list(r) {
      const request = r.toApiJson ? r : new ListPartnerHealthRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerHealths/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPartnerHealthResponse.fromProto(resp)));
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GetMultiPartnerHealthRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerHealths/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiPartnerHealthResponse.fromProto(resp)));
    }
  }
  PartnerHealthsApiService.ɵfac = function PartnerHealthsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PartnerHealthsApiService)();
  };
  PartnerHealthsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PartnerHealthsApiService,
    factory: PartnerHealthsApiService.ɵfac,
    providedIn: 'root'
  });
  return PartnerHealthsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let PartnerLegacyApiService = /*#__PURE__*/(() => {
  class PartnerLegacyApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createPartner(r) {
      const request = r.toApiJson ? r : new CreatePartnerRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerLegacy/CreatePartner", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getCreatePartnerStatus(r) {
      const request = r.toApiJson ? r : new GetCreatePartnerStatusRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerLegacy/GetCreatePartnerStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCreatePartnerStatusResponse.fromProto(resp)));
    }
    getSignUpAddPaymentCardResult(r) {
      const request = r.toApiJson ? r : new GetSignUpAddPaymentCardResultRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerLegacy/GetSignUpAddPaymentCardResult", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSignUpAddPaymentCardResultResponse.fromProto(resp)));
    }
    updatePartnerCompanyProfile(r) {
      const request = r.toApiJson ? r : new UpdateCompanyProfileRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerLegacy/UpdatePartnerCompanyProfile", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updatePartner(r) {
      const request = r.toApiJson ? r : new UpdatePartnerRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerLegacy/UpdatePartner", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getUpdatePartnerStatus(r) {
      const request = r.toApiJson ? r : new GetUpdatePartnerStatusRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerLegacy/GetUpdatePartnerStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetUpdatePartnerStatusResponse.fromProto(resp)));
    }
    getPartnerCenterNavigation(r) {
      const request = r.toApiJson ? r : new GetPartnerCenterNavigationRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerLegacy/GetPartnerCenterNavigation", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPartnerCenterNavigationResponse.fromProto(resp)));
    }
    listMarketsForUser(r) {
      const request = r.toApiJson ? r : new ListMarketsForUserRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerLegacy/ListMarketsForUser", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListMarketsForUserResponse.fromProto(resp)));
    }
  }
  PartnerLegacyApiService.ɵfac = function PartnerLegacyApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PartnerLegacyApiService)();
  };
  PartnerLegacyApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PartnerLegacyApiService,
    factory: PartnerLegacyApiService.ɵfac,
    providedIn: 'root'
  });
  return PartnerLegacyApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let PartnerModelApiService = /*#__PURE__*/(() => {
  class PartnerModelApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getPartnerModel(r) {
      const request = r.toApiJson ? r : new GetPartnerModelRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerModelService/GetPartnerModel", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPartnerModelResponse.fromProto(resp)));
    }
    getMultiPartnerModel(r) {
      const request = r.toApiJson ? r : new GetMultiPartnerModelRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerModelService/GetMultiPartnerModel", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiPartnerModelResponse.fromProto(resp)));
    }
    updatePartnerModel(r) {
      const request = r.toApiJson ? r : new UpdatePartnerModelRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerModelService/UpdatePartnerModel", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    searchPartnerModels(r) {
      const request = r.toApiJson ? r : new SearchPartnerModelsRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerModelService/SearchPartnerModels", request.toApiJson(), this.apiOptions()).pipe(map(resp => SearchPartnerModelsResponse.fromProto(resp)));
    }
  }
  PartnerModelApiService.ɵfac = function PartnerModelApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PartnerModelApiService)();
  };
  PartnerModelApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PartnerModelApiService,
    factory: PartnerModelApiService.ɵfac,
    providedIn: 'root'
  });
  return PartnerModelApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let PartnerSignupApiService = /*#__PURE__*/(() => {
  class PartnerSignupApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    selfSignUp(r) {
      const request = r.toApiJson ? r : new SelfSignUpRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerSignup/SelfSignUp", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    selfSignUpWithGoogle(r) {
      const request = r.toApiJson ? r : new SelfSignUpWithGoogleRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerSignup/SelfSignUpWithGoogle", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    selfSignUpWithLinkedIn(r) {
      const request = r.toApiJson ? r : new SelfSignUpWithLinkedRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerSignup/SelfSignUpWithLinkedIn", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    selfSignUpExistingAccountGroup(r) {
      const request = r.toApiJson ? r : new SelfSignUpExistingAccountGroupRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerSignup/SelfSignUpExistingAccountGroup", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    isEmailInUse(r) {
      const request = r.toApiJson ? r : new IsEmailInUseRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerSignup/IsEmailInUse", request.toApiJson(), this.apiOptions()).pipe(map(resp => IsEmailInUseResponse.fromProto(resp)));
    }
    isEmailDisposable(r) {
      const request = r.toApiJson ? r : new IsEmailDisposableRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerSignup/IsEmailDisposable", request.toApiJson(), this.apiOptions()).pipe(map(resp => IsEmailDisposableResponse.fromProto(resp)));
    }
    getSelfSignUpStatus(r) {
      const request = r.toApiJson ? r : new GetSelfSignUpStatusRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerSignup/GetSelfSignUpStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSelfSignUpStatusResponse.fromProto(resp)));
    }
    login(r) {
      const request = r.toApiJson ? r : new LoginRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerSignup/Login", request.toApiJson(), this.apiOptions()).pipe(map(resp => LoginResponse.fromProto(resp)));
    }
    signUp(r) {
      const request = r.toApiJson ? r : new SignUpRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerSignup/SignUp", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getGoogleProfile(r) {
      const request = r.toApiJson ? r : new GetGoogleProfileRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerSignup/GetGoogleProfile", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetGoogleProfileResponse.fromProto(resp)));
    }
    getLinkedInProfile(r) {
      const request = r.toApiJson ? r : new GetLinkedinProfileRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerSignup/GetLinkedInProfile", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetLinkedinProfileResponse.fromProto(resp)));
    }
    getMicrosoftProfile(r) {
      const request = r.toApiJson ? r : new GetMicrosoftProfileRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerSignup/GetMicrosoftProfile", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMicrosoftProfileResponse.fromProto(resp)));
    }
  }
  PartnerSignupApiService.ɵfac = function PartnerSignupApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PartnerSignupApiService)();
  };
  PartnerSignupApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PartnerSignupApiService,
    factory: PartnerSignupApiService.ɵfac,
    providedIn: 'root'
  });
  return PartnerSignupApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let PartnerTermsOfApiService = /*#__PURE__*/(() => {
  class PartnerTermsOfApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getTermsOfService(r) {
      const request = r.toApiJson ? r : new GetTermsOfServiceRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerTermsOfService/GetTermsOfService", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTermsOfServiceResponse.fromProto(resp)));
    }
    createTermsOfService(r) {
      const request = r.toApiJson ? r : new CreateTermsOfServiceRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerTermsOfService/CreateTermsOfService", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  PartnerTermsOfApiService.ɵfac = function PartnerTermsOfApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PartnerTermsOfApiService)();
  };
  PartnerTermsOfApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PartnerTermsOfApiService,
    factory: PartnerTermsOfApiService.ɵfac,
    providedIn: 'root'
  });
  return PartnerTermsOfApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let PartnerTrialApiService = /*#__PURE__*/(() => {
  class PartnerTrialApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getTrial(r) {
      const request = r.toApiJson ? r : new GetTrialRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerTrial/GetTrial", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTrialResponse.fromProto(resp)));
    }
    createTrial(r) {
      const request = r.toApiJson ? r : new CreateTrialRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerTrial/CreateTrial", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    cancelTrial(r) {
      const request = r.toApiJson ? r : new CancelTrialRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerTrial/CancelTrial", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listTrial(r) {
      const request = r.toApiJson ? r : new ListTrialRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerTrial/ListTrial", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListTrialResponse.fromProto(resp)));
    }
  }
  PartnerTrialApiService.ɵfac = function PartnerTrialApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PartnerTrialApiService)();
  };
  PartnerTrialApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PartnerTrialApiService,
    factory: PartnerTrialApiService.ɵfac,
    providedIn: 'root'
  });
  return PartnerTrialApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let PartnerUserAgreementTermsOfApiService = /*#__PURE__*/(() => {
  class PartnerUserAgreementTermsOfApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getUserAgreementTermsOfService(r) {
      const request = r.toApiJson ? r : new GetUserAgreementTermsOfServiceRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerUserAgreementTermsOfService/GetUserAgreementTermsOfService", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetUserAgreementTermsOfServiceResponse.fromProto(resp)));
    }
    setUserAgreementTermsOfService(r) {
      const request = r.toApiJson ? r : new SetUserAgreementTermsOfServiceRequest(r);
      return this.http.post(this._host + "/partner.v1.PartnerUserAgreementTermsOfService/SetUserAgreementTermsOfService", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  PartnerUserAgreementTermsOfApiService.ɵfac = function PartnerUserAgreementTermsOfApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PartnerUserAgreementTermsOfApiService)();
  };
  PartnerUserAgreementTermsOfApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PartnerUserAgreementTermsOfApiService,
    factory: PartnerUserAgreementTermsOfApiService.ɵfac,
    providedIn: 'root'
  });
  return PartnerUserAgreementTermsOfApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let PreviewEmailApiService = /*#__PURE__*/(() => {
  class PreviewEmailApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createPreviewEmail(r) {
      const request = r.toApiJson ? r : new CreatePreviewEmailRequest(r);
      return this.http.post(this._host + "/partner.v1.PreviewEmailService/CreatePreviewEmail", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    canSendPreviewEmail(r) {
      const request = r.toApiJson ? r : new CanSendPreviewEmailRequest(r);
      return this.http.post(this._host + "/partner.v1.PreviewEmailService/CanSendPreviewEmail", request.toApiJson(), this.apiOptions()).pipe(map(resp => CanSendPreviewEmailResponse.fromProto(resp)));
    }
  }
  PreviewEmailApiService.ɵfac = function PreviewEmailApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PreviewEmailApiService)();
  };
  PreviewEmailApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PreviewEmailApiService,
    factory: PreviewEmailApiService.ɵfac,
    providedIn: 'root'
  });
  return PreviewEmailApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let RewardsApiService = /*#__PURE__*/(() => {
  class RewardsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    addRewardToPartner(r) {
      const request = r.toApiJson ? r : new AddRewardToPartnerRequest(r);
      return this.http.post(this._host + "/partner.v1.Rewards/AddRewardToPartner", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    attemptRewardClaim(r) {
      const request = r.toApiJson ? r : new AttemptRewardClaimRequest(r);
      return this.http.post(this._host + "/partner.v1.Rewards/AttemptRewardClaim", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getReward(r) {
      const request = r.toApiJson ? r : new GetRewardRequest(r);
      return this.http.post(this._host + "/partner.v1.Rewards/GetReward", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetRewardResponse.fromProto(resp)));
    }
    isRewardConditionMetForPartner(r) {
      const request = r.toApiJson ? r : new IsRewardConditionMetForPartnerRequest(r);
      return this.http.post(this._host + "/partner.v1.Rewards/IsRewardConditionMetForPartner", request.toApiJson(), this.apiOptions()).pipe(map(resp => IsRewardConditionMetForPartnerResponse.fromProto(resp)));
    }
  }
  RewardsApiService.ɵfac = function RewardsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || RewardsApiService)();
  };
  RewardsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: RewardsApiService,
    factory: RewardsApiService.ɵfac,
    providedIn: 'root'
  });
  return RewardsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let SalesApiService = /*#__PURE__*/(() => {
  class SalesApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    setConfiguration(r) {
      const request = r.toApiJson ? r : new SetSalesConfigRequest(r);
      return this.http.post(this._host + "/partner.v1.Sales/SetConfiguration", request.toApiJson(), this.apiOptions()).pipe(map(resp => SetSalesConfigResponse.fromProto(resp)));
    }
    getConfiguration(r) {
      const request = r.toApiJson ? r : new GetSalesConfigRequest(r);
      return this.http.post(this._host + "/partner.v1.Sales/GetConfiguration", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSalesConfigResponse.fromProto(resp)));
    }
  }
  SalesApiService.ɵfac = function SalesApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SalesApiService)();
  };
  SalesApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SalesApiService,
    factory: SalesApiService.ɵfac,
    providedIn: 'root'
  });
  return SalesApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let StatsApiService = /*#__PURE__*/(() => {
  class StatsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listTop(r) {
      const request = r.toApiJson ? r : new ListTopRequest(r);
      return this.http.post(this._host + "/partner.v1.Stats/ListTop", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListTopResponse.fromProto(resp)));
    }
  }
  StatsApiService.ɵfac = function StatsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || StatsApiService)();
  };
  StatsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: StatsApiService,
    factory: StatsApiService.ɵfac,
    providedIn: 'root'
  });
  return StatsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let SubscriptionTiersApiService = /*#__PURE__*/(() => {
  class SubscriptionTiersApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getSubscriptionTier(r) {
      const request = r.toApiJson ? r : new GetSubscriptionTierRequest(r);
      return this.http.post(this._host + "/partner.v1.SubscriptionTiers/GetSubscriptionTier", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSubscriptionTierResponse.fromProto(resp)));
    }
    listSubscriptionTiers(r) {
      const request = r.toApiJson ? r : new ListSubscriptionTiersRequest(r);
      return this.http.post(this._host + "/partner.v1.SubscriptionTiers/ListSubscriptionTiers", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListSubscriptionTiersResponse.fromProto(resp)));
    }
    compareSubscriptionTiers(r) {
      const request = r.toApiJson ? r : new CompareSubscriptionTiersRequest(r);
      return this.http.post(this._host + "/partner.v1.SubscriptionTiers/CompareSubscriptionTiers", request.toApiJson(), this.apiOptions()).pipe(map(resp => CompareSubscriptionTiersResponse.fromProto(resp)));
    }
  }
  SubscriptionTiersApiService.ɵfac = function SubscriptionTiersApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SubscriptionTiersApiService)();
  };
  SubscriptionTiersApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SubscriptionTiersApiService,
    factory: SubscriptionTiersApiService.ɵfac,
    providedIn: 'root'
  });
  return SubscriptionTiersApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let TaskManagerApiService = /*#__PURE__*/(() => {
  class TaskManagerApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    setConfiguration(r) {
      const request = r.toApiJson ? r : new SetTaskManagerConfigRequest(r);
      return this.http.post(this._host + "/partner.v1.TaskManager/SetConfiguration", request.toApiJson(), this.apiOptions()).pipe(map(resp => SetTaskManagerConfigResponse.fromProto(resp)));
    }
    getConfiguration(r) {
      const request = r.toApiJson ? r : new GetTaskManagerConfigRequest(r);
      return this.http.post(this._host + "/partner.v1.TaskManager/GetConfiguration", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTaskManagerConfigResponse.fromProto(resp)));
    }
  }
  TaskManagerApiService.ɵfac = function TaskManagerApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TaskManagerApiService)();
  };
  TaskManagerApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TaskManagerApiService,
    factory: TaskManagerApiService.ɵfac,
    providedIn: 'root'
  });
  return TaskManagerApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let UserOnboardingApiService = /*#__PURE__*/(() => {
  class UserOnboardingApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    replaceWizardStatus(r) {
      const request = r.toApiJson ? r : new ReplaceWizardStatusRequest(r);
      return this.http.post(this._host + "/partner.v1.UserOnboarding/ReplaceWizardStatus", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getWizardStatus(r) {
      const request = r.toApiJson ? r : new GetWizardStatusRequest(r);
      return this.http.post(this._host + "/partner.v1.UserOnboarding/GetWizardStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetWizardStatusResponse.fromProto(resp)));
    }
    listWizardStatus(r) {
      const request = r.toApiJson ? r : new ListWizardStatusRequest(r);
      return this.http.post(this._host + "/partner.v1.UserOnboarding/ListWizardStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListWizardStatusResponse.fromProto(resp)));
    }
    deleteWizardStatus(r) {
      const request = r.toApiJson ? r : new DeleteWizardStatusRequest(r);
      return this.http.post(this._host + "/partner.v1.UserOnboarding/DeleteWizardStatus", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  UserOnboardingApiService.ɵfac = function UserOnboardingApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || UserOnboardingApiService)();
  };
  UserOnboardingApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: UserOnboardingApiService,
    factory: UserOnboardingApiService.ɵfac,
    providedIn: 'root'
  });
  return UserOnboardingApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let WhitelabelApiService = /*#__PURE__*/(() => {
  class WhitelabelApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getBranding(r) {
      const request = r.toApiJson ? r : new GetBrandingRequest(r);
      return this.http.post(this._host + "/partner.v1.Whitelabel/GetBranding", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetBrandingResponse.fromProto(resp)));
    }
    getMultiBranding(r) {
      const request = r.toApiJson ? r : new GetMultiBrandingRequest(r);
      return this.http.post(this._host + "/partner.v1.Whitelabel/GetMultiBranding", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiBrandingResponse.fromProto(resp)));
    }
    getConfiguration(r) {
      const request = r.toApiJson ? r : new GetConfigurationRequest(r);
      return this.http.post(this._host + "/partner.v1.Whitelabel/GetConfiguration", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetConfigurationResponse.fromProto(resp)));
    }
  }
  WhitelabelApiService.ɵfac = function WhitelabelApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || WhitelabelApiService)();
  };
  WhitelabelApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: WhitelabelApiService,
    factory: WhitelabelApiService.ɵfac,
    providedIn: 'root'
  });
  return WhitelabelApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { Access, AccessLevel, AcquisitionData, AcquisitionDataApiService, Action, ActivateAddonRequest, ActivateAddonResponse, AddPartnerToWhitelistRequest, AddRewardToPartnerRequest, AddonActivation, AddonActivationStatus, AddonApiService, AppIdentifier, AttemptRewardClaimRequest, BatchGetFeatureFlagRequest, BatchGetFeatureFlagResponse, BatchGetStatusFeatureFlagRequest, BatchGetStatusFeatureFlagResponse, BillingFrequency, Branding, BrandingApp, BrandingAppsEntry, BrandingAssets, BrandingUITheme, BrandingV2, BrandingV2ApiService, BusinessCenterApiService, BusinessCenterConfiguration, BusinessCenterMarketConfiguration, CanSendPreviewEmailRequest, CanSendPreviewEmailResponse, CancelTrialRequest, CannyApiService, Claimed, CompanyProfile, CompareSubscriptionTiersRequest, CompareSubscriptionTiersResponse, ComparisonCell, ComparisonRow, Configuration, CountConstraint, CreateAnalyticsDashboardRequest, CreateFeatureFlagRequest, CreatePartnerAccountGroupRequest, CreatePartnerRequest, CreatePreviewEmailRequest, CreateTermsOfServiceRequest, CreateTrialRequest, CustomerSurveyAddFeedbackRequest, CustomerSurveyApiService, CustomerSurveyListResponsesRequest, CustomerSurveyListResponsesResponse, CustomerSurveyPagedRequestOptions, CustomerSurveyPagedResponseMetadata, CustomerSurveyRespondRequest, CustomerSurveyRespondResponse, CustomerSurveyResponse, DeactivateAddonRequest, DeletePartnerAccountGroupRequest, DeleteWizardStatusRequest, EmailConfiguration, EmailPasswordCredential, ExistingAccount, ExitLinkConfiguration, ExperimentSetting, Expiration, FeatureFlag, FeatureFlagsApiService, Field, FieldMask, FreeTrialApiService, GenerateAccountGroupSessionRequest, GenerateAccountGroupSessionResponse, GetAcquisitionDataRequest, GetAcquisitionDataResponse, GetAddonActivationRequest, GetAddonActivationResponse, GetBrandingRequest, GetBrandingResponse, GetBrandingV2Request, GetBrandingV2Response, GetBusinessCenterMarketConfigurationRequest, GetBusinessCenterMarketConfigurationResponse, GetConfigurationRequest, GetConfigurationResponse, GetCreatePartnerStatusRequest, GetCreatePartnerStatusResponse, GetFreeTrialRequest, GetFreeTrialResponse, GetFreeTrialStatusRequest, GetFreeTrialStatusResponse, GetGoogleProfileRequest, GetGoogleProfileResponse, GetLinkedinProfileRequest, GetLinkedinProfileResponse, GetMicrosoftProfileRequest, GetMicrosoftProfileResponse, GetMultiBrandingRequest, GetMultiBrandingResponse, GetMultiBrandingV2Request, GetMultiBrandingV2Response, GetMultiPartnerHealthRequest, GetMultiPartnerHealthResponse, GetMultiPartnerModelRequest, GetMultiPartnerModelResponse, GetPartnerAccountGroupMappingRequest, GetPartnerAccountGroupMappingResponse, GetPartnerCenterNavigationRequest, GetPartnerCenterNavigationResponse, GetPartnerHealthRequest, GetPartnerHealthResponse, GetPartnerModelRequest, GetPartnerModelResponse, GetRewardRequest, GetRewardResponse, GetSalesConfigRequest, GetSalesConfigResponse, GetSelfSignUpStatusRequest, GetSelfSignUpStatusResponse, GetSignUpAddPaymentCardResultRequest, GetSignUpAddPaymentCardResultResponse, GetSignUpAddPaymentCardResultResponseStatus, GetSingleSignOnRequest, GetSingleSignOnResponse, GetSubscriptionTierRequest, GetSubscriptionTierResponse, GetTaskManagerConfigRequest, GetTaskManagerConfigResponse, GetTermsOfServiceRequest, GetTermsOfServiceResponse, GetTrialRequest, GetTrialResponse, GetUpdatePartnerStatusRequest, GetUpdatePartnerStatusResponse, GetUpdateSubscriptionTierStatusRequest, GetUpdateSubscriptionTierStatusResponse, GetUserAgreementTermsOfServiceRequest, GetUserAgreementTermsOfServiceResponse, GetWizardStatusRequest, GetWizardStatusResponse, GoogleTokenCredential, GrowthEventApiService, IAMApiService, InitiateSubscriptionTierUpdateRequest, IsEmailDisposableRequest, IsEmailDisposableResponse, IsEmailInUseRequest, IsEmailInUseResponse, IsRewardConditionMetForPartnerRequest, IsRewardConditionMetForPartnerResponse, LinkedInTokenCredential, ListAddonActivationsRequest, ListAddonActivationsResponse, ListBrandingV2Request, ListBrandingV2Response, ListFeatureFlagFilters, ListFeatureFlagRequest, ListFeatureFlagResponse, ListMarketsForUserRequest, ListMarketsForUserResponse, ListPartnerAddonsRequest, ListPartnerAddonsResponse, ListPartnerHealthRequest, ListPartnerHealthResponse, ListSubscriptionTiersRequest, ListSubscriptionTiersResponse, ListTopRequest, ListTopResponse, ListTrialRequest, ListTrialResponse, ListWizardStatusRequest, ListWizardStatusResponse, LoginRequest, LoginResponse, MailingConfiguration, Market, MicrosoftTokenCredential, Money, NavigationItem, NavigationItemBadge, NavigationItemChild, NewAccount, PagedRequestOptions, PagedResponseData, PagedResponseMetadata, PagingRequestMetadata, PagingResponseMetadata, PartnerAccess, PartnerAcquisitionData, PartnerAddon, PartnerAdminPermissions, PartnerApiService, PartnerCanDoActionRequest, PartnerCanDoActionResponse, PartnerHealth, PartnerHealthState, PartnerHealthSubState, PartnerHealthsApiService, PartnerInfo, PartnerLegacyApiService, PartnerModel, PartnerModelApiService, PartnerOrigin, PartnerSignupApiService, PartnerStats, PartnerTermsOfApiService, PartnerTrialApiService, PartnerType, PartnerUser, PartnerUserAgreementTermsOfApiService, PreviewEmailApiService, ReferralLink, ReplaceWizardStatusRequest, ReportAccess, ReportAccessIDType, ReportAccessScope, ReputationConfiguration, ResendPartnerAdminWelcomeEmailRequest, ResetPartnerRequest, Reward, RewardStatus, RewardsApiService, SalesApiService, SalesConfigInputs, SalesConfiguration, SalesSetting, SearchPartnerModelsFilters, SearchPartnerModelsRequest, SearchPartnerModelsResponse, SegmentedOnboardingConfiguration, SelectionCriteria, SelfSignUpExistingAccountGroupRequest, SelfSignUpRequest, SelfSignUpWithGoogleRequest, SelfSignUpWithLinkedRequest, SetBusinessCenterConfigRequest, SetBusinessCenterConfigResponse, SetPartnerHealthRequest, SetSalesConfigRequest, SetSalesConfigResponse, SetTaskManagerConfigRequest, SetTaskManagerConfigResponse, SetUserAgreementTermsOfServiceRequest, SignUpCredential, SignUpRequest, SinglePartnerMarketBranding, SnapshotConfiguration, StatsApiService, Status, SubscriptionFailure, SubscriptionLevel, SubscriptionTier, SubscriptionTierUpdateType, SubscriptionTiersApiService, SubscriptionUpdate, SupportFlag, SwapPartnerAccountGroupRequest, TaskManagerApiService, TaskManagerConfiguration, TaskStatus, TermOfService, TermsOfService, Theme, TierCostConstraint, TierUsageLimits, TimeRange, ToolkitData, Trial, TriggerEventRequest, UITheme, URL, UpdateBusinessCenterMarketConfigurationRequest, UpdateBusinessCenterMarketConfigurationResponse, UpdateCancelFreeTrialReasonMutation, UpdateCompanyProfileRequest, UpdateFeatureFlagRequest, UpdateFeatureFlagRequestMutation, UpdateFeatureFlagRequestMutationPartnerAccessMutation, UpdateFreeTrialActionRequiredStatusMutation, UpdateFreeTrialMutation, UpdateFreeTrialRequest, UpdatePartnerAccountGroupRequest, UpdatePartnerAdminRequest, UpdatePartnerModelMutation, UpdatePartnerModelMutationCountryState, UpdatePartnerModelRequest, UpdatePartnerRequest, UpdateSubscriptionTierRequest, UpdateSubscriptionTierStatus, UpsertBrandingV2Request, UpsertMutation, UpsertMutationMarketOverridesMutation, Usage, UserAgreementTermsOfService, UserCredential, UserOnboardingApiService, WhitelabelApiService, WizardStatus };
